
// Auto-generated file that is updated by a script.
// *DO NOT EDIT*
// Edits will be lost on update.

// spell-checker: disable
export type ISODateTimeString = `${number}-${number}-${number}T${number}:${number}:${number}.${number}Z`;

export interface KnownTracker {
	domains: string | string[];
	organizationKnownAs?: string;
	trackerKnownAs?: string;
	ghosteryId?: string;
	ghosteryOrganizationName?: string;
	whenAddedToGhostery?: ISODateTimeString;
	disconnectMeName?: string;
	whenAddedToDisconnectMe?: ISODateTimeString;
}

export interface KnownTrackersArchive {
	trackers: KnownTracker[];
}

export const KnownTrackersArchive: KnownTrackersArchive = {
	"trackers": [
		{
			"domains": "tiktok.com",
			"organizationKnownAs": "TikTok (ByteDance Inc)",
			"disconnectMeName": "TikTok",
			"whenAddedToDisconnectMe": "2022-09-16T17:00:39.000Z",
			"ghosteryId": "5432",
			"ghosteryOrganizationName": "ByteDance Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		} as KnownTracker,
		{
			"domains": "bluekai.com",
			"disconnectMeName": "Oracle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Oracle"
		},
		{
			"domains": "33across.com",
			"disconnectMeName": "33Across",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "375",
			"ghosteryOrganizationName": "33Across",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "33Across"
		},
		{
			"domains": "3lift.com",
			"disconnectMeName": "TripleLift",
			"whenAddedToDisconnectMe": "2017-03-09T23:35:41.000Z",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "TripleLift"
		},
		{
			"domains": "ad-delivery.net",
			"disconnectMeName": "AdDelivery",
			"whenAddedToDisconnectMe": "2023-10-06T03:07:40.000Z",
			"organizationKnownAs": "AdDelivery",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "admanmedia.com",
			"disconnectMeName": "AdmanMedia",
			"whenAddedToDisconnectMe": "2022-12-27T19:21:26.000Z",
			"ghosteryId": "4490",
			"ghosteryOrganizationName": "illumin",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adnxs.com",
			"trackerKnownAs": "Microsoft Xandr",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "adsrvr.org",
			"disconnectMeName": "The Trade Desk",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "The Trade Desk"
		},
		{
			"domains": "agkn.com",
			"disconnectMeName": "TransUnion",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3452",
			"ghosteryOrganizationName": "TransUnion",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "TransUnion"
		},
		{
			"domains": "amazon-adsystem.com",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Amazon"
		},
		{
			"domains": "bidr.io",
			"disconnectMeName": "Comcast",
			"whenAddedToDisconnectMe": "2019-04-29T22:43:38.000Z",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "btloader.com",
			"disconnectMeName": "Blockthrough",
			"whenAddedToDisconnectMe": "2023-07-24T14:03:04.000Z",
			"ghosteryId": "2675",
			"ghosteryOrganizationName": "Blockthrough",
			"whenAddedToGhostery": "2024-01-23T11:41:01.000Z",
			"organizationKnownAs": "Blockthrough"
		},
		{
			"domains": "casalemedia.com",
			"disconnectMeName": "IndexExchange",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "crwdcntrl.net",
			"disconnectMeName": "Lotame",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "103",
			"ghosteryOrganizationName": "Lotame",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Lotame"
		},
		{
			"domains": "doubleclick.net",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "eqads.com",
			"disconnectMeName": "EQ Ads",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "853",
			"ghosteryOrganizationName": "EQ Works",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "everesttech.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "facebook.com",
			"disconnectMeName": "Meta",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Meta"
		},
		{
			"domains": "facebook.net",
			"disconnectMeName": "Meta",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Meta"
		},
		{
			"domains": "fastclick.net",
			"disconnectMeName": "PublicisGroupe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "google.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "googleadservices.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "googlesyndication.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "googletagservices.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "id5-sync.com",
			"disconnectMeName": "ID5",
			"whenAddedToDisconnectMe": "2019-11-26T18:35:32.000Z",
			"organizationKnownAs": "ID5",
			"whenAddedToGhostery": "2023-07-28T09:11:50.000Z"
		},
		{
			"domains": "intentiq.com",
			"disconnectMeName": "IntentIQ",
			"whenAddedToDisconnectMe": "2023-07-24T14:03:04.000Z",
			"ghosteryId": "12",
			"ghosteryOrganizationName": "AlmondNet",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ipredictive.com",
			"disconnectMeName": "Viant",
			"whenAddedToDisconnectMe": "2018-08-27T19:07:15.000Z",
			"ghosteryId": "3878",
			"ghosteryOrganizationName": "Viant",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Viant"
		},
		{
			"domains": "liadm.com",
			"disconnectMeName": "LiveIntent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "674",
			"ghosteryOrganizationName": "LiveIntent",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LiveIntent"
		},
		{
			"domains": "lijit.com",
			"disconnectMeName": "Sovrn",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "99",
			"ghosteryOrganizationName": "Sovrn Holdings Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Sovrn"
		},
		{
			"domains": "linkedin.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "mediago.io",
			"disconnectMeName": "Baidu",
			"whenAddedToDisconnectMe": "2023-06-26T19:29:11.000Z",
			"organizationKnownAs": "Baidu"
		},
		{
			"domains": "ntv.io",
			"disconnectMeName": "Nativo",
			"whenAddedToDisconnectMe": "2022-12-27T19:21:26.000Z",
			"ghosteryId": "2568",
			"ghosteryOrganizationName": "Nativo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Nativo"
		},
		{
			"domains": "onetag-sys.com",
			"disconnectMeName": "OneTag",
			"whenAddedToDisconnectMe": "2023-06-15T20:47:42.000Z",
			"organizationKnownAs": "OneTag"
		},
		{
			"domains": "openx.net",
			"disconnectMeName": "OpenX",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "OpenX"
		},
		{
			"domains": "pippio.com",
			"disconnectMeName": "LiveRamp",
			"whenAddedToDisconnectMe": "2018-08-27T19:07:15.000Z",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LiveRamp"
		},
		{
			"domains": "postrelease.com",
			"disconnectMeName": "Nativo",
			"whenAddedToDisconnectMe": "2016-12-05T22:54:12.000Z",
			"ghosteryId": "2568",
			"ghosteryOrganizationName": "Nativo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Nativo"
		},
		{
			"domains": "primis.tech",
			"disconnectMeName": "Primis",
			"whenAddedToDisconnectMe": "2019-05-19T18:14:45.000Z",
			"organizationKnownAs": "Primis"
		},
		{
			"domains": "pubmatic.com",
			"disconnectMeName": "PubMatic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "PubMatic"
		},
		{
			"domains": "rlcdn.com",
			"disconnectMeName": "LiveRamp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LiveRamp"
		},
		{
			"domains": "rubiconproject.com",
			"disconnectMeName": "Magnite",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sharethrough.com",
			"disconnectMeName": "Sharethrough",
			"whenAddedToDisconnectMe": "2018-08-27T19:07:15.000Z",
			"ghosteryId": "718",
			"ghosteryOrganizationName": "Sharethrough, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Sharethrough"
		},
		{
			"domains": "simpli.fi",
			"disconnectMeName": "Simpli.fi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "550",
			"ghosteryOrganizationName": "Simplifi Holdings Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "smaato.net",
			"disconnectMeName": "VerveGroup",
			"whenAddedToDisconnectMe": "2022-12-27T19:21:26.000Z",
			"ghosteryId": "920",
			"ghosteryOrganizationName": "Verve Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "smartadserver.com",
			"disconnectMeName": "Equativ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "stackadapt.com",
			"disconnectMeName": "StackAdapt",
			"whenAddedToDisconnectMe": "2018-08-27T19:07:15.000Z",
			"ghosteryId": "3952",
			"ghosteryOrganizationName": "StackAdapt",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "StackAdapt"
		},
		{
			"domains": "stripe.com",
			"disconnectMeName": "Stripe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "Stripe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "stripe.network",
			"disconnectMeName": "Stripe",
			"whenAddedToDisconnectMe": "2018-12-08T05:06:08.000Z",
			"organizationKnownAs": "Stripe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tapad.com",
			"disconnectMeName": "Tapad",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "937",
			"ghosteryOrganizationName": "Telenor Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "technoratimedia.com",
			"disconnectMeName": "Synacor",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1650",
			"ghosteryOrganizationName": "Synacor",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Synacor"
		},
		{
			"domains": "yahoo.com",
			"disconnectMeName": "Yahoo!",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "yieldmo.com",
			"disconnectMeName": "Yieldmo",
			"whenAddedToDisconnectMe": "2016-12-05T22:54:12.000Z",
			"ghosteryId": "2918",
			"ghosteryOrganizationName": "Yieldmo, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Yieldmo"
		},
		{
			"domains": "youtube.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "zemanta.com",
			"disconnectMeName": "Outbrain",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "189",
			"ghosteryOrganizationName": "Outbrain",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Outbrain"
		},
		{
			"domains": "adobedc.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2023-12-05T19:38:40.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2024-09-25T14:34:57.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "adobedtm.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe",
			"whenAddedToDisconnectMe": "2017-02-22T11:43:37.000Z"
		},
		{
			"domains": "appboycdn.com",
			"disconnectMeName": "Braze",
			"whenAddedToDisconnectMe": "2024-01-23T00:07:37.000Z",
			"ghosteryId": "5321",
			"ghosteryOrganizationName": "Braze",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Braze"
		},
		{
			"domains": "braze.com",
			"disconnectMeName": "Braze",
			"whenAddedToDisconnectMe": "2024-01-23T00:07:37.000Z",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cloudfront.net",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Amazon"
		},
		{
			"domains": "contentsquare.net",
			"disconnectMeName": "ContentSquare",
			"whenAddedToDisconnectMe": "2023-04-13T17:07:02.000Z",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cookielaw.org",
			"disconnectMeName": "OneTrust",
			"whenAddedToDisconnectMe": "2024-08-01T18:03:23.000Z",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "OneTrust"
		},
		{
			"domains": "go-mpulse.net",
			"disconnectMeName": "Akamai",
			"whenAddedToDisconnectMe": "2016-12-05T22:54:12.000Z",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Akamai"
		},
		{
			"domains": "googletagmanager.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"whenAddedToDisconnectMe": "2017-08-07T07:07:07.000Z"
		},
		{
			"domains": "licdn.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "omtrdc.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "onetrust.com",
			"disconnectMeName": "OneTrust",
			"whenAddedToDisconnectMe": "2023-12-22T17:55:26.000Z",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "OneTrust"
		},
		{
			"domains": "onetrust.io",
			"disconnectMeName": "OneTrust",
			"whenAddedToDisconnectMe": "2024-01-23T00:07:37.000Z"
		},
		{
			"domains": "quantummetric.com",
			"disconnectMeName": "QuantumMetric",
			"whenAddedToDisconnectMe": "2023-11-06T21:08:04.000Z",
			"ghosteryId": "4748",
			"ghosteryOrganizationName": "Quantum Metric, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "usabilla.com",
			"disconnectMeName": "STG",
			"whenAddedToDisconnectMe": "2024-01-23T00:07:37.000Z",
			"ghosteryId": "2858",
			"ghosteryOrganizationName": "SurveyMonkey",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adxcel-ec2.com",
			"disconnectMeName": "ArtsAI",
			"whenAddedToDisconnectMe": "2024-01-23T00:07:37.000Z"
		},
		{
			"domains": "akstat.io",
			"disconnectMeName": "Akamai",
			"whenAddedToDisconnectMe": "2023-10-24T22:47:21.000Z",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Akamai"
		},
		{
			"domains": "bazaarvoice.com",
			"disconnectMeName": "Bazaarvoice",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1272",
			"ghosteryOrganizationName": "Bazaarvoice",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Bazaarvoice"
		},
		{
			"domains": "bidswitch.net",
			"disconnectMeName": "Criteo",
			"whenAddedToDisconnectMe": "2016-02-15T07:41:21.000Z",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Criteo"
		},
		{
			"domains": "bing.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "ctnsnet.com",
			"disconnectMeName": "Crimtan",
			"whenAddedToDisconnectMe": "2023-10-06T03:07:40.000Z",
			"ghosteryId": "606",
			"ghosteryOrganizationName": "Crimtan",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Crimtan"
		},
		{
			"domains": "demdex.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "google-analytics.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "googleapis.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "gstatic.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "pinimg.com",
			"disconnectMeName": "Pinterest",
			"whenAddedToDisconnectMe": "2018-08-27T19:07:15.000Z",
			"ghosteryId": "1306",
			"ghosteryOrganizationName": "Pinterest",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Pinterest"
		},
		{
			"domains": "pinterest.com",
			"disconnectMeName": "Pinterest",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1306",
			"ghosteryOrganizationName": "Pinterest",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Pinterest"
		},
		{
			"domains": "sc-static.net",
			"disconnectMeName": "Snap",
			"whenAddedToDisconnectMe": "2023-09-06T18:35:49.000Z",
			"ghosteryId": "157",
			"ghosteryOrganizationName": "Snap Technologies",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Snap"
		},
		{
			"domains": "snapchat.com",
			"disconnectMeName": "Snap",
			"whenAddedToDisconnectMe": "2022-09-16T17:00:39.000Z",
			"ghosteryId": "157",
			"ghosteryOrganizationName": "Snap Technologies",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Snap"
		},
		{
			"domains": "sojern.com",
			"disconnectMeName": "Sojern",
			"whenAddedToDisconnectMe": "2019-04-24T21:24:57.000Z",
			"ghosteryId": "782",
			"ghosteryOrganizationName": "Sojern, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Sojern"
		},
		{
			"domains": "tacdn.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tamgrt.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tribalfusion.com",
			"disconnectMeName": "VDX",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "64",
			"ghosteryOrganizationName": "Exponential Interactive, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "yieldoptimizer.com",
			"disconnectMeName": "Adara Media",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "286",
			"ghosteryOrganizationName": "Adara",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adara"
		},
		{
			"domains": "yimg.com",
			"disconnectMeName": "Yahoo!",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "optimizely.com",
			"disconnectMeName": "Optimizely",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Optimizely"
		},
		{
			"domains": "adroll.com",
			"disconnectMeName": "NextRoll",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "412",
			"ghosteryOrganizationName": "AdRoll",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "demandbase.com",
			"disconnectMeName": "Demandbase",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "53",
			"ghosteryOrganizationName": "Demandbase",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Demandbase"
		},
		{
			"domains": "yimg.jp",
			"disconnectMeName": "LYCorp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2456",
			"ghosteryOrganizationName": "Yahoo! Japan",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "salesloft.com",
			"disconnectMeName": "Salesloft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "6sc.co",
			"disconnectMeName": "6sense",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2536",
			"ghosteryOrganizationName": "6Sense",
			"whenAddedToGhostery": "2024-09-30T14:49:21.000Z",
			"organizationKnownAs": "6Sense"
		},
		{
			"domains": "impactcdn.com",
			"disconnectMeName": "Impact",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tvsquared.com",
			"disconnectMeName": "Innovid",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "episerver.net",
			"disconnectMeName": "Optimizely",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2024-10-28T18:08:10.000Z",
			"organizationKnownAs": "Optimizely"
		},
		{
			"domains": "amplitude.com",
			"disconnectMeName": "Amplitude",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3070",
			"ghosteryOrganizationName": "Amplitude",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Amplitude"
		},
		{
			"domains": "trkn.us",
			"disconnectMeName": "Claritas",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "company-target.com",
			"disconnectMeName": "Demandbase",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "53",
			"ghosteryOrganizationName": "Demandbase",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Demandbase"
		},
		{
			"domains": "ml314.com",
			"disconnectMeName": "Bombora",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "933",
			"ghosteryOrganizationName": "Bombora",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Bombora"
		},
		{
			"domains": "taboola.com",
			"disconnectMeName": "Taboola",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Taboola"
		},
		{
			"domains": "outbrain.com",
			"disconnectMeName": "Outbrain",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Outbrain"
		},
		{
			"domains": "reson8.com",
			"disconnectMeName": "Resonate",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "868",
			"ghosteryOrganizationName": "Resonate",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Resonate"
		},
		{
			"domains": "zoominfo.com",
			"disconnectMeName": "ZoomInfo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "datadoghq-browser-agent.com",
			"disconnectMeName": "DataDog",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "sentry.io",
			"disconnectMeName": "FunctionalSoftware",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "scorecardresearch.com",
			"disconnectMeName": "comScore",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "246",
			"ghosteryOrganizationName": "comScore, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "comScore"
		},
		{
			"domains": "px-cloud.net",
			"disconnectMeName": "HumanSecurity",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "redditstatic.com",
			"disconnectMeName": "reddit",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "reddit"
		},
		{
			"domains": "teads.tv",
			"disconnectMeName": "Teads",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2521",
			"ghosteryOrganizationName": "Teads",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Teads"
		},
		{
			"domains": "ispot.tv",
			"disconnectMeName": "iSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tk0x1.com",
			"disconnectMeName": "LoopMe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "reddit.com",
			"disconnectMeName": "reddit",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "reddit"
		},
		{
			"domains": "clarity.ms",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "quantserve.com",
			"disconnectMeName": "Quantcast",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Quantcast"
		},
		{
			"domains": "statcounter.com",
			"disconnectMeName": "StatCounter",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "162",
			"ghosteryOrganizationName": "StatCounter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "StatCounter"
		},
		{
			"domains": "e-planning.net",
			"disconnectMeName": "Caraytech",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "509",
			"ghosteryOrganizationName": "e-planning",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "minutemedia-prebid.com",
			"disconnectMeName": "MinuteMedia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "quantcount.com",
			"disconnectMeName": "Quantcast",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Quantcast"
		},
		{
			"domains": "openxcdn.net",
			"disconnectMeName": "OpenX",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "eu-1-id5-sync.com",
			"disconnectMeName": "ID5",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adtrafficquality.google",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2024-10-28T18:23:01.000Z"
		},
		{
			"domains": "media-amazon.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "criteo.com",
			"disconnectMeName": "Criteo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Criteo"
		},
		{
			"domains": "ytimg.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "cloudflareinsights.com",
			"disconnectMeName": "Cloudflare",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2913",
			"ghosteryOrganizationName": "Cloudflare",
			"whenAddedToGhostery": "2023-08-31T15:44:33.000Z",
			"organizationKnownAs": "Cloudflare"
		},
		{
			"domains": "dwin1.com",
			"disconnectMeName": "Awin",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1202",
			"ghosteryOrganizationName": "Axel Springer Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ads-twitter.com",
			"disconnectMeName": "Twitter",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "moengage.com",
			"disconnectMeName": "MoEngage",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "t.co",
			"disconnectMeName": "Twitter",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "twitter.com",
			"disconnectMeName": "Twitter",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "oath.com",
			"disconnectMeName": "Yahoo!",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "clean.gg",
			"disconnectMeName": "HumanSecurity",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "media.net",
			"disconnectMeName": "media.net",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1879",
			"ghosteryOrganizationName": "Media.net",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Media.net"
		},
		{
			"domains": "seedtag.com",
			"disconnectMeName": "SeedTag",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5280",
			"ghosteryOrganizationName": "Seedtag Advertising S.L",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "SeedTag"
		},
		{
			"domains": "criteo.net",
			"disconnectMeName": "Criteo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Criteo"
		},
		{
			"domains": "indexww.com",
			"disconnectMeName": "IndexExchange",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bounceexchange.com",
			"disconnectMeName": "Wunderkind",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2468",
			"ghosteryOrganizationName": "Bounce Exchange",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "flashtalking.com",
			"disconnectMeName": "Flashtalking",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "442",
			"ghosteryOrganizationName": "Flashtalking",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Flashtalking"
		},
		{
			"domains": "kampyle.com",
			"disconnectMeName": "Medallia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Medallia"
		},
		{
			"domains": "pulseinsights.com",
			"ghosteryId": "3656",
			"ghosteryOrganizationName": "Pulse Insights",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mczbf.com",
			"disconnectMeName": "PublicisGroupe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "dotomi.com",
			"disconnectMeName": "PublicisGroupe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "videoamp.com",
			"disconnectMeName": "VideoAmp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cdnwidget.com",
			"disconnectMeName": "CDNWidget",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "bouncex.net",
			"disconnectMeName": "Wunderkind",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "eum-appdynamics.com",
			"ghosteryId": "2793",
			"ghosteryOrganizationName": "AppDynamics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cloudflare.com",
			"disconnectMeName": "Cloudflare",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2913",
			"ghosteryOrganizationName": "Cloudflare",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Cloudflare"
		},
		{
			"domains": "microsoft.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "akamaized.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "microsoftonline.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "atdmt.com",
			"disconnectMeName": "Meta",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Meta"
		},
		{
			"domains": "live.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "gfx.ms",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "azure.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "visualstudio.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "twimg.com",
			"disconnectMeName": "Twitter",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "x.com",
			"disconnectMeName": "Twitter",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "browser-intake-datadoghq.com",
			"disconnectMeName": "DataDog",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "btttag.com",
			"ghosteryId": "3355",
			"ghosteryOrganizationName": "Blue Triangle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "BlueTriangle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "attn.tv",
			"disconnectMeName": "Attentive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "attentivemobile.com",
			"disconnectMeName": "AttentiveMobile",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pdst.fm",
			"disconnectMeName": "Spotify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mathtag.com",
			"disconnectMeName": "MediaMath",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "290",
			"ghosteryOrganizationName": "MediaMath, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "MediaMath"
		},
		{
			"domains": "azureedge.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "noibu.com",
			"disconnectMeName": "Noibu",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mountain.com",
			"disconnectMeName": "MNTN",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "wisepops.net",
			"disconnectMeName": "Wisepops",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "appspot.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wisepops.com",
			"ghosteryId": "3348",
			"ghosteryOrganizationName": "WisePops",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "Wisepops",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "WisePops"
		},
		{
			"domains": "turn.com",
			"disconnectMeName": "Nexxen",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5298",
			"ghosteryOrganizationName": "Singtel",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "techlab-cdn.com",
			"disconnectMeName": "Akamai",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "qualtrics.com",
			"disconnectMeName": "Qualtrics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Qualtrics"
		},
		{
			"domains": "trackjs.com",
			"ghosteryId": "3549",
			"ghosteryOrganizationName": "TrackJS",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adsafeprotected.com",
			"disconnectMeName": "Integral Ad Science",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "474",
			"ghosteryOrganizationName": "Integral Ad Science, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Integral Ad Science"
		},
		{
			"domains": "privacy-mgmt.com",
			"disconnectMeName": "Sourcepoint",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5230",
			"ghosteryOrganizationName": "Sourcepoint",
			"whenAddedToGhostery": "2024-04-25T15:06:02.000Z",
			"organizationKnownAs": "Sourcepoint"
		},
		{
			"domains": "newrelic.com",
			"disconnectMeName": "New Relic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "942",
			"ghosteryOrganizationName": "New Relic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "New Relic"
		},
		{
			"domains": "privacymanager.io",
			"disconnectMeName": "LiveRamp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adlightning.com",
			"disconnectMeName": "Boltive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5304",
			"ghosteryOrganizationName": "Ad Lightning",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cxense.com",
			"disconnectMeName": "Piano",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1160",
			"ghosteryOrganizationName": "Cxense",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tiqcdn.com",
			"ghosteryId": "662",
			"ghosteryOrganizationName": "Tealium",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "Tealium",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "Tealium"
		},
		{
			"domains": "doubleverify.com",
			"disconnectMeName": "DoubleVerify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "DoubleVerify"
		},
		{
			"domains": "celtra.com",
			"ghosteryId": "921",
			"ghosteryOrganizationName": "Celtra",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "2mdn.net",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "the-ozone-project.com",
			"disconnectMeName": "OzoneProject",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "newscgp.com",
			"disconnectMeName": "NCAudienceExchange",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5365",
			"ghosteryOrganizationName": "News Corp",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "imrworldwide.com",
			"disconnectMeName": "Nielsen",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Nielsen"
		},
		{
			"domains": "dianomi.com",
			"disconnectMeName": "dianomi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1284",
			"ghosteryOrganizationName": "Dianomi",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Dianomi"
		},
		{
			"domains": "brandmetrics.com",
			"disconnectMeName": "BrandMetrics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "datadome.co",
			"disconnectMeName": "Datadome",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5226",
			"ghosteryOrganizationName": "DataDome",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "DataDome"
		},
		{
			"domains": "360yield.com",
			"disconnectMeName": "Improve Digital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "523",
			"ghosteryOrganizationName": "Improve Digital",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Improve Digital"
		},
		{
			"domains": "parsely.com",
			"disconnectMeName": "Parse.ly",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1009",
			"ghosteryOrganizationName": "Parse.ly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Parse.ly"
		},
		{
			"domains": "kargo.com",
			"disconnectMeName": "Kargo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Kargo"
		},
		{
			"domains": "permutive.app",
			"disconnectMeName": "Permutive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "nr-data.net",
			"disconnectMeName": "New Relic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "942",
			"ghosteryOrganizationName": "New Relic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "New Relic"
		},
		{
			"domains": "permutive.com",
			"disconnectMeName": "Permutive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5148",
			"ghosteryOrganizationName": "Permutive, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Permutive"
		},
		{
			"domains": "typekit.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "connatix.com",
			"disconnectMeName": "Connatix.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3942",
			"ghosteryOrganizationName": "Connatix Native Exchange Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "crazyegg.com",
			"disconnectMeName": "Crazy Egg",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "50",
			"ghosteryOrganizationName": "Crazy Egg",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Crazy Egg"
		},
		{
			"domains": "serverbid.com",
			"disconnectMeName": "Consumable",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5347",
			"ghosteryOrganizationName": "GiftConnect",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cootlogix.com",
			"disconnectMeName": "Cootlogix",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "uidapi.com",
			"disconnectMeName": "The Trade Desk",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "hadronid.net",
			"disconnectMeName": "Audigent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ad.gt",
			"disconnectMeName": "Audigent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "richaudience.com",
			"disconnectMeName": "RichAudience",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "semasio.net",
			"disconnectMeName": "Fyllo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2088",
			"ghosteryOrganizationName": "Semasio GmbH",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sonobi.com",
			"disconnectMeName": "Sonobi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1412",
			"ghosteryOrganizationName": "Sonobi, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Sonobi"
		},
		{
			"domains": "emxdgt.com",
			"disconnectMeName": "Cadent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5333",
			"ghosteryOrganizationName": "Engine",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "yellowblue.io",
			"disconnectMeName": "Unity",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "kueezrtb.com",
			"disconnectMeName": "Kueez",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "sitescout.com",
			"disconnectMeName": "BasisTechnologies",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "714",
			"ghosteryOrganizationName": "Centro",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "1rx.io",
			"disconnectMeName": "Nexxen",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "673",
			"ghosteryOrganizationName": "RhythmOne, LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "streamrail.com",
			"ghosteryId": "5016",
			"ghosteryOrganizationName": "ironSource",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "brealtime.com",
			"disconnectMeName": "Cadent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "trustarc.com",
			"disconnectMeName": "TrustARC",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "TrustArc"
		},
		{
			"domains": "w55c.net",
			"disconnectMeName": "Roku",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "292",
			"ghosteryOrganizationName": "DataXu",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "amazon.dev",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "coveo.com",
			"disconnectMeName": "Coveo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "bizographics.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "clicktale.net",
			"disconnectMeName": "ContentSquare",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "41",
			"ghosteryOrganizationName": "ClickTale",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "driftt.com",
			"disconnectMeName": "Drift",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "marketo.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mktoresp.com",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hs-scripts.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hotjar.com",
			"disconnectMeName": "Hotjar",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3632",
			"ghosteryOrganizationName": "Hotjar",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Hotjar"
		},
		{
			"domains": "heapanalytics.com",
			"disconnectMeName": "Heap",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2695",
			"ghosteryOrganizationName": "Heap",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Heap"
		},
		{
			"domains": "hs-banner.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-03-22T13:47:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hsleadflows.net",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hubspot.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hsadspixel.net",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-06-06T09:29:25.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hs-analytics.net",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hotjar.io",
			"disconnectMeName": "Hotjar",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3632",
			"ghosteryOrganizationName": "Hotjar",
			"whenAddedToGhostery": "2024-02-26T13:50:19.000Z",
			"organizationKnownAs": "Hotjar"
		},
		{
			"domains": "hsforms.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-06-06T08:37:37.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "hubapi.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "wp.com",
			"disconnectMeName": "Automattic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "245",
			"ghosteryOrganizationName": "Automattic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Automattic"
		},
		{
			"domains": "googleoptimize.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "evgnet.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "evergage.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "atlassian.net",
			"ghosteryId": "5312",
			"ghosteryOrganizationName": "Atlassian",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "serving-sys.com",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Amazon"
		},
		{
			"domains": "osano.com",
			"disconnectMeName": "Osano",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "confiant-integrations.net",
			"disconnectMeName": "Confiant",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "creativecdn.com",
			"disconnectMeName": "RTBHouse",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3371",
			"ghosteryOrganizationName": "RTB House",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "clarium.io",
			"disconnectMeName": "Confiant",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "deliverimp.com",
			"disconnectMeName": "DeliverImp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "rtbhouse.com",
			"disconnectMeName": "RTBHouse",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "branch.io",
			"disconnectMeName": "Branch",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4164",
			"ghosteryOrganizationName": "Branch Metrics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Branch"
		},
		{
			"domains": "force.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ipify.org",
			"disconnectMeName": "ipify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "app.link",
			"disconnectMeName": "Branch",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4164",
			"ghosteryOrganizationName": "Branch Metrics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Branch"
		},
		{
			"domains": "contextweb.com",
			"disconnectMeName": "PulsePoint",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "293",
			"ghosteryOrganizationName": "PulsePoint, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "PulsePoint"
		},
		{
			"domains": "truste.com",
			"disconnectMeName": "TrustARC",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "TrustArc"
		},
		{
			"domains": "thrtle.com",
			"disconnectMeName": "Throtle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "betrad.com",
			"disconnectMeName": "Crownpeak",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4957",
			"ghosteryOrganizationName": "Crownpeak",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Crownpeak"
		},
		{
			"domains": "evidon.com",
			"ghosteryId": "4957",
			"ghosteryOrganizationName": "Crownpeak",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "w-x.co",
			"ghosteryId": "263",
			"ghosteryOrganizationName": "IBM",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "appsflyer.com",
			"disconnectMeName": "AppsFlyer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4300",
			"ghosteryOrganizationName": "AppsFlyer",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "AppsFlyer"
		},
		{
			"domains": "medallia.com",
			"disconnectMeName": "Medallia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Medallia"
		},
		{
			"domains": "siteimproveanalytics.com",
			"disconnectMeName": "SiteImprove",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Siteimprove"
		},
		{
			"domains": "clearbitjs.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "en25.com",
			"disconnectMeName": "Oracle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Oracle"
		},
		{
			"domains": "soundcloud.com",
			"ghosteryId": "1817",
			"ghosteryOrganizationName": "SoundCloud",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "siteimproveanalytics.io",
			"disconnectMeName": "SiteImprove",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove",
			"whenAddedToGhostery": "2024-09-23T10:10:00.000Z",
			"organizationKnownAs": "Siteimprove"
		},
		{
			"domains": "fullstory.com",
			"disconnectMeName": "Fullstory",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4100",
			"ghosteryOrganizationName": "fullstory",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "fullstory"
		},
		{
			"domains": "adnxs-simple.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2024-03-22T13:47:05.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "siftscience.com",
			"disconnectMeName": "SiftScience",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2686",
			"ghosteryOrganizationName": "Sift Science",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adswizz.com",
			"disconnectMeName": "SiriusXM",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adgrx.com",
			"disconnectMeName": "Samsung",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "433",
			"ghosteryOrganizationName": "Samsung",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Samsung"
		},
		{
			"domains": "signifyd.com",
			"disconnectMeName": "Signifyd",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4889",
			"ghosteryOrganizationName": "Signifyd",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Signifyd"
		},
		{
			"domains": "riskified.com",
			"disconnectMeName": "Riskified",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5292",
			"ghosteryOrganizationName": "Riskified",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Riskified"
		},
		{
			"domains": "impactradius-event.com",
			"disconnectMeName": "Impact",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2230",
			"ghosteryOrganizationName": "Impact Radius",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Impact"
		},
		{
			"domains": "forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hexagon-analytics.com",
			"ghosteryId": "5421",
			"ghosteryOrganizationName": "Brandwatch",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "applovin.com",
			"disconnectMeName": "Applovin",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "online-metrix.net",
			"disconnectMeName": "OnlineMetrix",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "chartbeat.com",
			"disconnectMeName": "Chartbeat",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "313",
			"ghosteryOrganizationName": "ChartBeat",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "ChartBeat"
		},
		{
			"domains": "chartbeat.net",
			"disconnectMeName": "Chartbeat",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "313",
			"ghosteryOrganizationName": "ChartBeat",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "ChartBeat"
		},
		{
			"domains": "3gl.net",
			"ghosteryId": "2897",
			"ghosteryOrganizationName": "Catchpoint Systems",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "acsbapp.com",
			"disconnectMeName": "Accessibe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "dynatrace.com",
			"disconnectMeName": "Dynatrace",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "micpn.com",
			"disconnectMeName": "MoveableInk",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "expedia.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tagcommander.com",
			"ghosteryId": "1789",
			"ghosteryOrganizationName": "Commanders Act",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "trvl-px.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "rkdms.com",
			"disconnectMeName": "Merkle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sail-horizon.com",
			"disconnectMeName": "SailThru",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1550",
			"ghosteryOrganizationName": "Sailthru",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Sailthru"
		},
		{
			"domains": "tru.am",
			"disconnectMeName": "TrueAnthem",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3030",
			"ghosteryOrganizationName": "trueAnthem",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "trueAnthem"
		},
		{
			"domains": "bluecava.com",
			"disconnectMeName": "Adstra",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "670",
			"ghosteryOrganizationName": "Qualia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sail-personalize.com",
			"disconnectMeName": "SailThru",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1550",
			"ghosteryOrganizationName": "Sailthru",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Sailthru"
		},
		{
			"domains": "innovid.com",
			"disconnectMeName": "Innovid",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "825",
			"ghosteryOrganizationName": "Innovid",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Innovid"
		},
		{
			"domains": "xg4ken.com",
			"disconnectMeName": "Skai",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1299",
			"ghosteryOrganizationName": "Kenshoo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "invocacdn.com",
			"disconnectMeName": "Invoca",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "securedvisit.com",
			"disconnectMeName": "Merkle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2234",
			"ghosteryOrganizationName": "SecuredVisit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "rtmark.net",
			"disconnectMeName": "Propeller Ads",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5316",
			"ghosteryOrganizationName": "Big Wall Vision",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "admedo.com",
			"disconnectMeName": "Admedo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3222",
			"ghosteryOrganizationName": "Admedo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Admedo"
		},
		{
			"domains": "mrf.io",
			"disconnectMeName": "Marfeel",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "newsroom.bi",
			"disconnectMeName": "Marfeel",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "hscollectedforms.net",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-06-06T08:37:37.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "bttrack.com",
			"disconnectMeName": "Bidtellect",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4166",
			"ghosteryOrganizationName": "Simpli.fi",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "undertone.com",
			"disconnectMeName": "Undertone",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "269",
			"ghosteryOrganizationName": "Perion",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pushnami.com",
			"disconnectMeName": "Pushnami",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "jquery.com",
			"ghosteryId": "5354",
			"ghosteryOrganizationName": "JS Foundation",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "p7cloud.net",
			"disconnectMeName": "p7cloud.net",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "getblueshift.com",
			"disconnectMeName": "BlueShift",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "servenobid.com",
			"disconnectMeName": "ServeNoBid",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "a-mo.net",
			"disconnectMeName": "AdaptMX",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "omnitagjs.com",
			"disconnectMeName": "AdYouLike",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2629",
			"ghosteryOrganizationName": "Open Web",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "moatads.com",
			"disconnectMeName": "Oracle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Oracle"
		},
		{
			"domains": "insightexpressai.com",
			"disconnectMeName": "BainCapital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "114",
			"ghosteryOrganizationName": "Kantar Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "blismedia.com",
			"disconnectMeName": "Blis",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5318",
			"ghosteryOrganizationName": "Blis",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Blis"
		},
		{
			"domains": "connextra.com",
			"disconnectMeName": "Betgenius",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "502",
			"ghosteryOrganizationName": "Connextra",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hsforms.net",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-06-06T09:11:42.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "livechatinc.com",
			"disconnectMeName": "LiveChat",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2653",
			"ghosteryOrganizationName": "LiveChat",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LiveChat"
		},
		{
			"domains": "ubembed.com",
			"disconnectMeName": "Unbounce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pbbl.co",
			"disconnectMeName": "PebblePost",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "visualwebsiteoptimizer.com",
			"disconnectMeName": "Wingify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "276",
			"ghosteryOrganizationName": "Wingify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Wingify"
		},
		{
			"domains": "omappapi.com",
			"disconnectMeName": "Retyp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5129",
			"ghosteryOrganizationName": "OptinMonster",
			"whenAddedToGhostery": "2024-03-22T13:47:05.000Z"
		},
		{
			"domains": "aralego.com",
			"disconnectMeName": "ucfunnel",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "aralego.net",
			"ghosteryId": "5431",
			"ghosteryOrganizationName": "ucfunnel",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "appdynamics.com",
			"ghosteryId": "2793",
			"ghosteryOrganizationName": "AppDynamics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "c3tag.com",
			"disconnectMeName": "C3 Metrics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "754",
			"ghosteryOrganizationName": "C3 Metrics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "C3 Metrics"
		},
		{
			"domains": "iesnare.com",
			"disconnectMeName": "TransUnion",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "388",
			"ghosteryOrganizationName": "iovation",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "gannett-cdn.com",
			"ghosteryId": "76",
			"ghosteryOrganizationName": "Gannett Digital Media Network",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "polarcdn-terrax.com",
			"disconnectMeName": "Nova",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "polarcdn-pentos.com",
			"disconnectMeName": "Nova",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "urbanairship.com",
			"ghosteryId": "3072",
			"ghosteryOrganizationName": "Urban Airship, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "unrulymedia.com",
			"disconnectMeName": "Nexxen",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1904",
			"ghosteryOrganizationName": "Tremor International",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "inq.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "230",
			"ghosteryOrganizationName": "TouchCommerce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "blueconic.net",
			"disconnectMeName": "BlueConic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3860",
			"ghosteryOrganizationName": "BlueConic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "BlueConic"
		},
		{
			"domains": "tealiumiq.com",
			"disconnectMeName": "Tealium",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "662",
			"ghosteryOrganizationName": "Tealium",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Tealium"
		},
		{
			"domains": "nuance.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "akamaihd.net",
			"disconnectMeName": "Akamai",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Akamai"
		},
		{
			"domains": "lpsnmedia.net",
			"disconnectMeName": "LivePerson",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LivePerson"
		},
		{
			"domains": "liveperson.com",
			"disconnectMeName": "LivePerson",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LivePerson"
		},
		{
			"domains": "liveperson.net",
			"disconnectMeName": "LivePerson",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "LivePerson"
		},
		{
			"domains": "sharethis.com",
			"disconnectMeName": "ShareThis",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "149",
			"ghosteryOrganizationName": "ShareThis, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "ShareThis"
		},
		{
			"domains": "fundraiseup.com",
			"disconnectMeName": "FundraiseUp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "fndrsp.net",
			"disconnectMeName": "FundraiseUp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "wknd.ai",
			"disconnectMeName": "Wunderkind",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "channeladvisor.com",
			"disconnectMeName": "ChannelAdvisor",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "367",
			"ghosteryOrganizationName": "ChannelAdvisor",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "ChannelAdvisor"
		},
		{
			"domains": "abtasty.com",
			"disconnectMeName": "ABTasty",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3037",
			"ghosteryOrganizationName": "AB Tasty",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "spotify.com",
			"ghosteryId": "1816",
			"ghosteryOrganizationName": "Spotify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "iperceptions.com",
			"disconnectMeName": "iPerceptions",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "92",
			"ghosteryOrganizationName": "iPerceptions",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "iPerceptions"
		},
		{
			"domains": "aspnetcdn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "twitchcdn.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "jtvnw.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ttvnw.net",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Amazon"
		},
		{
			"domains": "bigcrunch.com",
			"disconnectMeName": "BigCrunch",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "gumgum.com",
			"disconnectMeName": "GumGum",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "84",
			"ghosteryOrganizationName": "GumGum",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "GumGum"
		},
		{
			"domains": "js7k.com",
			"disconnectMeName": "Yahoo!",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "researchnow.com",
			"disconnectMeName": "Dynata",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2770",
			"ghosteryOrganizationName": "Research Now Group, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "justpremium.com",
			"disconnectMeName": "GumGum",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2882",
			"ghosteryOrganizationName": "GumGum",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "GumGum"
		},
		{
			"domains": "wistia.com",
			"disconnectMeName": "Wistia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1307",
			"ghosteryOrganizationName": "Wistia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Wistia"
		},
		{
			"domains": "media6degrees.com",
			"disconnectMeName": "Dstillery",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "111",
			"ghosteryOrganizationName": "Dstillery",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Dstillery"
		},
		{
			"domains": "spotxchange.com",
			"disconnectMeName": "Magnite",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2991",
			"ghosteryOrganizationName": "RTL Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pages02.net",
			"ghosteryId": "263",
			"ghosteryOrganizationName": "IBM",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "eloqua.com",
			"disconnectMeName": "Oracle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Oracle"
		},
		{
			"domains": "sentry-cdn.com",
			"disconnectMeName": "FunctionalSoftware",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "clicktripz.com",
			"disconnectMeName": "ClickTripz",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3110",
			"ghosteryOrganizationName": "ClickTripz",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "ClickTripz"
		},
		{
			"domains": "mainadv.com",
			"ghosteryId": "1622",
			"ghosteryOrganizationName": "mainADV",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "smct.co",
			"ghosteryId": "4941",
			"ghosteryOrganizationName": "Smarter Click Technology",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "smct.io",
			"disconnectMeName": "intent.ly",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "udmserve.net",
			"disconnectMeName": "Underdog Media",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "748",
			"ghosteryOrganizationName": "Underdog Media LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Underdog Media"
		},
		{
			"domains": "adentifi.com",
			"disconnectMeName": "AdTheorent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3622",
			"ghosteryOrganizationName": "AdTheorent, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "AdTheorent"
		},
		{
			"domains": "ninthdecimal.com",
			"disconnectMeName": "InMarket",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "youtube-nocookie.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "truoptik.com",
			"disconnectMeName": "TransUnion",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tynt.com",
			"disconnectMeName": "33Across",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "375",
			"ghosteryOrganizationName": "33Across",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "33Across"
		},
		{
			"domains": "tiktokv.us",
			"disconnectMeName": "TikTok",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "lytics.io",
			"ghosteryId": "4376",
			"ghosteryOrganizationName": "Lytics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "colossusssp.com",
			"disconnectMeName": "ColossusMedia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "monetate.net",
			"disconnectMeName": "Monetate",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "601",
			"ghosteryOrganizationName": "Monetate",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Monetate"
		},
		{
			"domains": "proper.io",
			"ghosteryId": "5216",
			"ghosteryOrganizationName": "Proper Media",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "anyclip.com",
			"disconnectMeName": "AnyClip",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "springserve.com",
			"disconnectMeName": "SpringServe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2581",
			"ghosteryOrganizationName": "SpringServe, LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "SpringServe"
		},
		{
			"domains": "euid.eu",
			"disconnectMeName": "EUiD",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "geoedge.be",
			"disconnectMeName": "Geoedge",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "disqus.com",
			"disconnectMeName": "Disqus",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nextmillmedia.com",
			"disconnectMeName": "NextMillennium",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "smilewanted.com",
			"disconnectMeName": "SmileWanted",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "brainlyads.com",
			"disconnectMeName": "NextMillennium",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "storygize.net",
			"disconnectMeName": "Storygize",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tremorhub.com",
			"disconnectMeName": "Nexxen",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "564",
			"ghosteryOrganizationName": "Tremor Video",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adform.net",
			"disconnectMeName": "Adform",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "457",
			"ghosteryOrganizationName": "Adform",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adform"
		},
		{
			"domains": "ck-ie.com",
			"disconnectMeName": "SmartyAds",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adkernel.com",
			"disconnectMeName": "AdKernel",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "spot.im",
			"disconnectMeName": "OpenWeb",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3625",
			"ghosteryOrganizationName": "Spot.IM Ltd.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "p-n.io",
			"disconnectMeName": "Pushly",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "childlikeform.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "skimresources.com",
			"disconnectMeName": "Taboola",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "587",
			"ghosteryOrganizationName": "SkimLinks",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "opecloud.com",
			"disconnectMeName": "TripleLift",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4582",
			"ghosteryOrganizationName": "1plusX AG",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "guim.co.uk",
			"ghosteryId": "5402",
			"ghosteryOrganizationName": "The Guardian",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "guardianapps.co.uk",
			"ghosteryId": "5402",
			"ghosteryOrganizationName": "The Guardian",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "unblockia.com",
			"disconnectMeName": "Unblockia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "opti-digital.com",
			"disconnectMeName": "optidigital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "bugsnag.com",
			"disconnectMeName": "SmartBear",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3347",
			"ghosteryOrganizationName": "SmartBear",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "SmartBear"
		},
		{
			"domains": "speedcurve.com",
			"disconnectMeName": "SpeedCurve",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "scene7.com",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "vimeo.com",
			"disconnectMeName": "Vimeo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1552",
			"ghosteryOrganizationName": "Vimeo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Vimeo"
		},
		{
			"domains": "pardot.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Salesforce"
		},
		{
			"domains": "ipinfo.io",
			"disconnectMeName": "IDBLLC",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5074",
			"ghosteryOrganizationName": "ipinfo.io",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "px-cdn.net",
			"disconnectMeName": "HumanSecurity",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "onesignal.com",
			"disconnectMeName": "OneSignal",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4304",
			"ghosteryOrganizationName": "OneSignal",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "OneSignal"
		},
		{
			"domains": "adthrive.com",
			"disconnectMeName": "Raptive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "slickstream.com",
			"disconnectMeName": "Raptive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "convertkit.com",
			"disconnectMeName": "ConvertKit",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "jwplayer.com",
			"disconnectMeName": "JWPlayer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ccgateway.net",
			"disconnectMeName": "ccgateway.net",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pghub.io",
			"disconnectMeName": "Tapad",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "paypal.com",
			"disconnectMeName": "Paypal",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "248",
			"ghosteryOrganizationName": "eBay",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "yotpo.com",
			"disconnectMeName": "Yotpo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2657",
			"ghosteryOrganizationName": "Yotpo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Yotpo"
		},
		{
			"domains": "paypalobjects.com",
			"ghosteryId": "248",
			"ghosteryOrganizationName": "eBay",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bootstrapcdn.com",
			"ghosteryId": "5320",
			"ghosteryOrganizationName": "BootstrapCDN",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "helpscout.net",
			"disconnectMeName": "HelpScout",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "rakuten.com",
			"disconnectMeName": "Rakuten",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "linksynergy.com",
			"disconnectMeName": "Rakuten",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3334",
			"ghosteryOrganizationName": "Rakuten Marketing LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Rakuten"
		},
		{
			"domains": "imgix.net",
			"disconnectMeName": "Imgix",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "sardine.ai",
			"disconnectMeName": "SardineAI",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mapixl.com",
			"disconnectMeName": "MarketingArchitects",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "servedbyadbutler.com",
			"disconnectMeName": "Sparklit",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "userzoom.com",
			"ghosteryId": "1692",
			"ghosteryOrganizationName": "UserZoom",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mparticle.com",
			"disconnectMeName": "mParticle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mouseflow.com",
			"disconnectMeName": "Mouseflow",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "418",
			"ghosteryOrganizationName": "Mouseflow",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Mouseflow"
		},
		{
			"domains": "segment.com",
			"disconnectMeName": "Twilio",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1440",
			"ghosteryOrganizationName": "Segment",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "litix.io",
			"ghosteryId": "4482",
			"ghosteryOrganizationName": "Mux",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "intercom.io",
			"disconnectMeName": "Intercom",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1161",
			"ghosteryOrganizationName": "Intercom",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Intercom"
		},
		{
			"domains": "intercomcdn.com",
			"ghosteryId": "1161",
			"ghosteryOrganizationName": "Intercom",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "gravatar.com",
			"disconnectMeName": "Automattic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "245",
			"ghosteryOrganizationName": "Automattic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Automattic"
		},
		{
			"domains": "googleusercontent.com",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "scdn.co",
			"ghosteryId": "1816",
			"ghosteryOrganizationName": "Spotify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "vidazoo.com",
			"disconnectMeName": "Vidazoo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pbstck.com",
			"disconnectMeName": "Pubstack",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "klarnaservices.com",
			"disconnectMeName": "Klarna",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "listrakbi.com",
			"disconnectMeName": "Listrak",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1115",
			"ghosteryOrganizationName": "Listrak",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Listrak"
		},
		{
			"domains": "ywxi.net",
			"ghosteryId": "1141",
			"ghosteryOrganizationName": "McAfee",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "listrak.com",
			"disconnectMeName": "Listrak",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "2o7.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "pepperjam.com",
			"disconnectMeName": "Partnerize",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "espssl.com",
			"disconnectMeName": "Listrak",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "rezync.com",
			"disconnectMeName": "ZetaGlobal",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "rfihub.net",
			"disconnectMeName": "ZetaGlobal",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "boomtrain.com",
			"disconnectMeName": "ZetaGlobal",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "rfihub.com",
			"disconnectMeName": "ZetaGlobal",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ziffstatic.com",
			"ghosteryId": "660",
			"ghosteryOrganizationName": "Ziff Davis LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "app-us1.com",
			"disconnectMeName": "ActiveCampaign",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "zdbb.net",
			"ghosteryId": "660",
			"ghosteryOrganizationName": "Ziff Davis LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "trackcmp.net",
			"disconnectMeName": "ActiveCampaign",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5121",
			"ghosteryOrganizationName": "Active Campaign",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ampproject.org",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "digicert.com",
			"ghosteryId": "1526",
			"ghosteryOrganizationName": "Digicert",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nextdoor.com",
			"disconnectMeName": "Nextdoor",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "samplicio.us",
			"disconnectMeName": "Cint",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "dotmetrics.net",
			"disconnectMeName": "DotMetrics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "videoplayerhub.com",
			"disconnectMeName": "Blockthrough",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cpx.to",
			"disconnectMeName": "Captify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1976",
			"ghosteryOrganizationName": "Captify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Captify"
		},
		{
			"domains": "servebom.com",
			"disconnectMeName": "FuturePlc",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2052",
			"ghosteryOrganizationName": "Purch Group, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sndcdn.com",
			"ghosteryId": "1817",
			"ghosteryOrganizationName": "SoundCloud",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ctfassets.net",
			"ghosteryId": "5325",
			"ghosteryOrganizationName": "Contentful GmbH",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pingdom.net",
			"disconnectMeName": "SolarWinds",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "consentmanager.net",
			"ghosteryId": "1813",
			"ghosteryOrganizationName": "iubenda",
			"whenAddedToGhostery": "2024-07-02T17:16:11.000Z"
		},
		{
			"domains": "mxpnl.com",
			"disconnectMeName": "Mixpanel",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "227",
			"ghosteryOrganizationName": "Mixpanel",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Mixpanel"
		},
		{
			"domains": "quora.com",
			"disconnectMeName": "Quora",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mgid.com",
			"disconnectMeName": "MGID",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "577",
			"ghosteryOrganizationName": "MGID Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "MGID"
		},
		{
			"domains": "mixpanel.com",
			"disconnectMeName": "Mixpanel",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "227",
			"ghosteryOrganizationName": "Mixpanel",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Mixpanel"
		},
		{
			"domains": "clearbit.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5324",
			"ghosteryOrganizationName": "Clearbit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "xing.com",
			"ghosteryId": "2787",
			"ghosteryOrganizationName": "XING",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cquotient.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Salesforce"
		},
		{
			"domains": "pxf.io",
			"disconnectMeName": "Impact",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "igodigital.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Salesforce"
		},
		{
			"domains": "privacy-center.org",
			"disconnectMeName": "Didomi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5327",
			"ghosteryOrganizationName": "Didomi",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Didomi"
		},
		{
			"domains": "pro-market.net",
			"disconnectMeName": "Datonics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "12",
			"ghosteryOrganizationName": "AlmondNet",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "shopify.com",
			"ghosteryId": "2179",
			"ghosteryOrganizationName": "Shopify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "Shopify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "Shopify"
		},
		{
			"domains": "shopifysvc.com",
			"disconnectMeName": "Shopify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "scarabresearch.com",
			"disconnectMeName": "SAP",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5182",
			"ghosteryOrganizationName": "Emarsys",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cookiebot.com",
			"disconnectMeName": "UserCentrics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "getsmartcontent.com",
			"ghosteryId": "2133",
			"ghosteryOrganizationName": "Get Smart Content",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "quantcast.com",
			"disconnectMeName": "Quantcast",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Quantcast"
		},
		{
			"domains": "inmobi.com",
			"disconnectMeName": "InMobi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "bluecore.com",
			"disconnectMeName": "Bluecore",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3058",
			"ghosteryOrganizationName": "TriggerMail",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "inside-graph.com",
			"ghosteryId": "3042",
			"ghosteryOrganizationName": "PowerFront",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pangle-ads.com",
			"disconnectMeName": "Bytedance",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pubnation.com",
			"disconnectMeName": "OpenX",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "aweber.com",
			"disconnectMeName": "AWeber",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1305",
			"ghosteryOrganizationName": "AWeber Communications",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "AWeber"
		},
		{
			"domains": "mediavine.com",
			"disconnectMeName": "Mediavine",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "sda.fyi",
			"disconnectMeName": "sda.fyi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pendo.io",
			"disconnectMeName": "Pendo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "airpr.com",
			"disconnectMeName": "Onclusive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5235",
			"ghosteryOrganizationName": "AirPR",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "marketo.com",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "steelhousemedia.com",
			"disconnectMeName": "MNTN",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "751",
			"ghosteryOrganizationName": "Steel House, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "optmstr.com",
			"ghosteryId": "5129",
			"ghosteryOrganizationName": "OptinMonster",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ensighten.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "728",
			"ghosteryOrganizationName": "Ensighten",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "rudderlabs.com",
			"disconnectMeName": "RudderStack",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "myfonts.net",
			"disconnectMeName": "MyFonts",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2683",
			"ghosteryOrganizationName": "MyFonts",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "MyFonts"
		},
		{
			"domains": "useinsider.com",
			"ghosteryId": "4816",
			"ghosteryOrganizationName": "Insider",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "Insider",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "Insider"
		},
		{
			"domains": "audioeye.com",
			"disconnectMeName": "AudioEye",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "iadvize.com",
			"ghosteryId": "2128",
			"ghosteryOrganizationName": "iAdvize",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "decibelinsight.net",
			"ghosteryId": "3679",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "kaltura.com",
			"disconnectMeName": "Kaltura",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1480",
			"ghosteryOrganizationName": "Kaltura",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Kaltura"
		},
		{
			"domains": "blogherads.com",
			"disconnectMeName": "BlogHer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "29",
			"ghosteryOrganizationName": "Penske Media Corporation",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tinypass.com",
			"disconnectMeName": "Piano",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Piano"
		},
		{
			"domains": "piano.io",
			"disconnectMeName": "Piano",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Piano"
		},
		{
			"domains": "browsiprod.com",
			"disconnectMeName": "Browsi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "treasuredata.com",
			"disconnectMeName": "TreasureData",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4464",
			"ghosteryOrganizationName": "arm",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "jwplatform.com",
			"disconnectMeName": "JWPlayer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "lightboxcdn.com",
			"disconnectMeName": "Digioh",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "aidemsrv.com",
			"disconnectMeName": "aidem",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "e-volution.ai",
			"disconnectMeName": "EvolutionTechnologies",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adscale.de",
			"disconnectMeName": "adscale",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "342",
			"ghosteryOrganizationName": "Ströer SSP GmbH",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "lunamedia.live",
			"disconnectMeName": "LunaMedia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cloudinary.com",
			"disconnectMeName": "Cloudinary",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pub.network",
			"disconnectMeName": "Freestar",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "scaredsnakes.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "segment.io",
			"disconnectMeName": "Twilio",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1440",
			"ghosteryOrganizationName": "Segment",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "redd.it",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "redditmedia.com",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "smadex.com",
			"disconnectMeName": "Entravision",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "everestjs.net",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "brightcove.net",
			"ghosteryId": "683",
			"ghosteryOrganizationName": "Brightcove",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bkrtx.com",
			"disconnectMeName": "Oracle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Oracle"
		},
		{
			"domains": "granify.com",
			"ghosteryId": "2980",
			"ghosteryOrganizationName": "Granify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "foresee.com",
			"ghosteryId": "330",
			"ghosteryOrganizationName": "ForeSee Results",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "t13.io",
			"disconnectMeName": "t13.io",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "zencdn.net",
			"disconnectMeName": "Brightcove",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4475",
			"ghosteryOrganizationName": "Zencoder",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tappx.com",
			"disconnectMeName": "tappx",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "vox-cdn.com",
			"ghosteryId": "3999",
			"ghosteryOrganizationName": "Vox Media",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "betweendigital.com",
			"disconnectMeName": "BetweenDigital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2492",
			"ghosteryOrganizationName": "Between Digital",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fonts.net",
			"ghosteryId": "3427",
			"ghosteryOrganizationName": "Monotype Imaging",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "btstatic.com",
			"disconnectMeName": "TransUnion",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "761",
			"ghosteryOrganizationName": "Signal Digital Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "convertexperiments.com",
			"disconnectMeName": "convertexperiments.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5041",
			"ghosteryOrganizationName": "Convert",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Convert"
		},
		{
			"domains": "recaptcha.net",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2024-01-23T11:41:01.000Z",
			"organizationKnownAs": "Google"
		},
		{
			"domains": "samba.tv",
			"disconnectMeName": "Samba.tv",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5388",
			"ghosteryOrganizationName": "Samba TV",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mookie1.com",
			"disconnectMeName": "WPP",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4758",
			"ghosteryOrganizationName": "Xaxis",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "jwpsrv.com",
			"disconnectMeName": "JWPlayer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adnami.io",
			"disconnectMeName": "Adnami",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "jwpcdn.com",
			"disconnectMeName": "JWPlayer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "jwpltx.com",
			"disconnectMeName": "JWPlayer",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wpengine.com",
			"ghosteryId": "5415",
			"ghosteryOrganizationName": "WP Engine",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cheqzone.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adpushup.com",
			"disconnectMeName": "Zelto",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "datadoghq.com",
			"disconnectMeName": "DataDog",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "4dex.io",
			"disconnectMeName": "Adagio",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cpmstar.com",
			"disconnectMeName": "CPMStar",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "647",
			"ghosteryOrganizationName": "CPMStar",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "CPMStar"
		},
		{
			"domains": "smartyads.com",
			"disconnectMeName": "SmartyAds",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "krxd.net",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Salesforce"
		},
		{
			"domains": "survicate.com",
			"disconnectMeName": "Survicate",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "swiftypecdn.com",
			"ghosteryId": "5332",
			"ghosteryOrganizationName": "Elastic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "auth0.com",
			"ghosteryId": "5313",
			"ghosteryOrganizationName": "Auth0 Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "office.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "dstillery.com",
			"disconnectMeName": "Dstillery",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "nyt.com",
			"ghosteryId": "1962",
			"ghosteryOrganizationName": "The New York Times Company",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "zqtk.net",
			"ghosteryId": "246",
			"ghosteryOrganizationName": "comScore, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adrecover.com",
			"ghosteryId": "3507",
			"ghosteryOrganizationName": "AdPushUp, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "outbrainimg.com",
			"disconnectMeName": "Outbrain",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Outbrain"
		},
		{
			"domains": "revjet.com",
			"disconnectMeName": "Innervate",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "dyntrk.com",
			"disconnectMeName": "DynAdmic",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "matheranalytics.com",
			"disconnectMeName": "MatherEconomics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5233",
			"ghosteryOrganizationName": "Mather Economics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "digitaleast.mobi",
			"disconnectMeName": "DigitalEast",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "digitalgov.gov",
			"ghosteryId": "5409",
			"ghosteryOrganizationName": "USA Government",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "presage.io",
			"disconnectMeName": "Ogury",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "infolinks.com",
			"disconnectMeName": "Infolinks",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "88",
			"ghosteryOrganizationName": "Infolinks",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Infolinks"
		},
		{
			"domains": "sekindo.com",
			"disconnectMeName": "Primis",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2061",
			"ghosteryOrganizationName": "SekiNdo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "npttech.com",
			"disconnectMeName": "Piano",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Piano"
		},
		{
			"domains": "a-mx.com",
			"disconnectMeName": "AdaptMX",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "aticdn.net",
			"ghosteryId": "1270",
			"ghosteryOrganizationName": "AT Internet",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "Piano",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tvpixel.com",
			"disconnectMeName": "LiveRamp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp",
			"whenAddedToGhostery": "2024-05-22T14:55:07.000Z",
			"organizationKnownAs": "LiveRamp"
		},
		{
			"domains": "revcontent.com",
			"disconnectMeName": "RevContent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3626",
			"ghosteryOrganizationName": "Revcontent",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Revcontent"
		},
		{
			"domains": "ad-score.com",
			"disconnectMeName": "Protected Media",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "earnify.com",
			"disconnectMeName": "Earnify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4358",
			"ghosteryOrganizationName": "Earnify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Earnify"
		},
		{
			"domains": "a2z.com",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "fwmrm.net",
			"disconnectMeName": "Comcast",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Comcast"
		},
		{
			"domains": "admantx.com",
			"ghosteryId": "5336",
			"ghosteryOrganizationName": "Expert System, SpA",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nondescriptnote.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "polarcdn.com",
			"disconnectMeName": "Nova",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "polarcdn-engine.com",
			"disconnectMeName": "Nova",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "klevu.com",
			"disconnectMeName": "Klevu",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "stamped.io",
			"disconnectMeName": "Stamped",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "klaviyo.com",
			"disconnectMeName": "Klaviyo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "merchant-center-analytics.goog",
			"disconnectMeName": "Google",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "im-apps.net",
			"disconnectMeName": "IntimateMerger",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4067",
			"ghosteryOrganizationName": "Intimate Merger",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "snackly.co",
			"ghosteryId": "4282",
			"ghosteryOrganizationName": "Minute.ly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "conviva.com",
			"disconnectMeName": "Conviva",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Conviva"
		},
		{
			"domains": "friendbuy.com",
			"ghosteryId": "5219",
			"ghosteryOrganizationName": "FriendBuy",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "s-microsoft.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ib-ibi.com",
			"disconnectMeName": "iBehavior",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "611",
			"ghosteryOrganizationName": "KBM Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "deepintent.com",
			"disconnectMeName": "Deep Intent",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5037",
			"ghosteryOrganizationName": "Deep Intent",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Deep Intent"
		},
		{
			"domains": "stickyadstv.com",
			"disconnectMeName": "Comcast",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Comcast"
		},
		{
			"domains": "farsnails.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ngtv.io",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "jivox.com",
			"disconnectMeName": "Jivox",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1872",
			"ghosteryOrganizationName": "Jivox",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Jivox"
		},
		{
			"domains": "line-scdn.net",
			"disconnectMeName": "LYCorp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5232",
			"ghosteryOrganizationName": "Line",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "naver.net",
			"ghosteryId": "4249",
			"ghosteryOrganizationName": "Naver",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "line.me",
			"disconnectMeName": "LYCorp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5232",
			"ghosteryOrganizationName": "Line",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pstatic.net",
			"ghosteryId": "4249",
			"ghosteryOrganizationName": "Naver",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "naver.com",
			"ghosteryId": "4249",
			"ghosteryOrganizationName": "Naver",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tradedoubler.com",
			"disconnectMeName": "Tradedoubler",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "668",
			"ghosteryOrganizationName": "Tradedoubler AB",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Tradedoubler"
		},
		{
			"domains": "dailymotion.com",
			"ghosteryId": "5411",
			"ghosteryOrganizationName": "Vivendi",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "dm-event.net",
			"ghosteryId": "5411",
			"ghosteryOrganizationName": "Vivendi",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "singular.net",
			"disconnectMeName": "SingularLabs",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "yahoo.net",
			"disconnectMeName": "Yahoo!",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pubwise.io",
			"disconnectMeName": "PubWise",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "shop.app",
			"disconnectMeName": "Shopify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "rebuyengine.com",
			"disconnectMeName": "RebuyInc",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "smile.io",
			"disconnectMeName": "Smile",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "trustpilot.com",
			"disconnectMeName": "TrustPilot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5155",
			"ghosteryOrganizationName": "Trustpilot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Trustpilot"
		},
		{
			"domains": "strangeclocks.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "apple.com",
			"ghosteryId": "390",
			"ghosteryOrganizationName": "Apple",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "esm1.net",
			"disconnectMeName": "CoxEnterprises",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4642",
			"ghosteryOrganizationName": "Dealer.com",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "travelaudience.com",
			"disconnectMeName": "Amadeus",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4913",
			"ghosteryOrganizationName": "Travel Audience",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wishabi.net",
			"disconnectMeName": "Wishabi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "curalate.com",
			"disconnectMeName": "Bazaarvoice",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "brcdn.com",
			"ghosteryId": "396",
			"ghosteryOrganizationName": "BloomReach",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wishabi.com",
			"disconnectMeName": "Wishabi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "brsrvr.com",
			"disconnectMeName": "BloomReach",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "396",
			"ghosteryOrganizationName": "BloomReach",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "BloomReach"
		},
		{
			"domains": "qualaroo.com",
			"disconnectMeName": "Qualaroo",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tp88trk.com",
			"disconnectMeName": "tp88trk",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mailchimp.com",
			"disconnectMeName": "MailChimp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1187",
			"ghosteryOrganizationName": "MailChimp",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "MailChimp"
		},
		{
			"domains": "addtoany.com",
			"disconnectMeName": "AddtoAny",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4",
			"ghosteryOrganizationName": "AddToAny",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "AddToAny"
		},
		{
			"domains": "cdninstagram.com",
			"disconnectMeName": "Meta",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Meta"
		},
		{
			"domains": "sascdn.com",
			"disconnectMeName": "Equativ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "stretchsquirrel.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "amazon.com",
			"disconnectMeName": "Amazon.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Amazon"
		},
		{
			"domains": "ssl-images-amazon.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "Amazon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "Amazon"
		},
		{
			"domains": "resetdigital.co",
			"disconnectMeName": "ResetDigital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "eyeota.net",
			"disconnectMeName": "Eyeota",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1727",
			"ghosteryOrganizationName": "Eyeota",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Eyeota"
		},
		{
			"domains": "exelator.com",
			"disconnectMeName": "Nielsen",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Nielsen"
		},
		{
			"domains": "rmtag.com",
			"disconnectMeName": "Rakuten",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3334",
			"ghosteryOrganizationName": "Rakuten Marketing LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Rakuten"
		},
		{
			"domains": "bing.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "dynamicyield.com",
			"ghosteryId": "2280",
			"ghosteryOrganizationName": "Dynamic Yield",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "Mastercard",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "affec.tv",
			"disconnectMeName": "HybridTheory",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "payments-amazon.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "espncdn.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "githubassets.com",
			"ghosteryId": "1618",
			"ghosteryOrganizationName": "GitHub, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bfmio.com",
			"disconnectMeName": "BeachFront",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "selectmedia.asia",
			"disconnectMeName": "SelectMedia",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "salesforce.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Salesforce"
		},
		{
			"domains": "salesforceliveagent.com",
			"disconnectMeName": "Salesforce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Salesforce"
		},
		{
			"domains": "res-x.com",
			"disconnectMeName": "Monetate",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "351",
			"ghosteryOrganizationName": "Certona",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nocookie.net",
			"ghosteryId": "5412",
			"ghosteryOrganizationName": "Wikia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wikia-services.com",
			"ghosteryId": "5412",
			"ghosteryOrganizationName": "Wikia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "basis.net",
			"disconnectMeName": "BasisTechnologies",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "impactradius-tag.com",
			"ghosteryId": "2230",
			"ghosteryOrganizationName": "Impact Radius",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "afterpay.com",
			"disconnectMeName": "AfterPay",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mediawallahscript.com",
			"disconnectMeName": "Mediawallah",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "h-cdn.com",
			"ghosteryId": "4896",
			"ghosteryOrganizationName": "Hola CDN",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "appnexus.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "knotch.it",
			"ghosteryId": "4114",
			"ghosteryOrganizationName": "Knotch",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "brightcove.com",
			"disconnectMeName": "Brightcove",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "683",
			"ghosteryOrganizationName": "Brightcove",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Brightcove"
		},
		{
			"domains": "usemessages.com",
			"disconnectMeName": "HubSpot",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "HubSpot"
		},
		{
			"domains": "mfadsrvr.com",
			"disconnectMeName": "MediaForce",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "intergient.com",
			"disconnectMeName": "Playwire",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "intergi.com",
			"disconnectMeName": "Intergi",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "playwire.com",
			"disconnectMeName": "Playwire",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4577",
			"ghosteryOrganizationName": "Snowplow",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fbcdn.net",
			"disconnectMeName": "Meta",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Meta"
		},
		{
			"domains": "s-onetag.com",
			"disconnectMeName": "Sovrn",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5424",
			"ghosteryOrganizationName": "OneTag",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "etsystatic.com",
			"ghosteryId": "2030",
			"ghosteryOrganizationName": "Etsy, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wsod.com",
			"disconnectMeName": "Markit",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "624",
			"ghosteryOrganizationName": "Markit on Demand",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Markit"
		},
		{
			"domains": "raygun.io",
			"ghosteryId": "4101",
			"ghosteryOrganizationName": "Raygun",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adobe.com",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adobe"
		},
		{
			"domains": "go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "yottaa.net",
			"ghosteryId": "5419",
			"ghosteryOrganizationName": "Yottaa",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "kickfire.com",
			"disconnectMeName": "IDG",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ebaystatic.com",
			"disconnectMeName": "eBay",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "220",
			"ghosteryOrganizationName": "eBay",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "eBay"
		},
		{
			"domains": "ebayimg.com",
			"disconnectMeName": "eBay",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "220",
			"ghosteryOrganizationName": "eBay",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "eBay"
		},
		{
			"domains": "ebayrtm.com",
			"ghosteryId": "220",
			"ghosteryOrganizationName": "eBay",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ebayadservices.com",
			"disconnectMeName": "eBay",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "perfdrive.com",
			"disconnectMeName": "Radware",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "nitropay.com",
			"disconnectMeName": "NitroPay",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "5346",
			"ghosteryOrganizationName": "GG Software LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "kameleoon.eu",
			"disconnectMeName": "Kameleoon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3044",
			"ghosteryOrganizationName": "Kameleoon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Kameleoon"
		},
		{
			"domains": "gorgias.chat",
			"disconnectMeName": "Gorgias",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "chimpstatic.com",
			"disconnectMeName": "MailChimp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1187",
			"ghosteryOrganizationName": "MailChimp",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "MailChimp"
		},
		{
			"domains": "shopifycdn.com",
			"ghosteryId": "2179",
			"ghosteryOrganizationName": "Shopify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "parastorage.com",
			"ghosteryId": "5414",
			"ghosteryOrganizationName": "Wix",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wixmp.com",
			"ghosteryId": "5414",
			"ghosteryOrganizationName": "Wix",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wix.com",
			"ghosteryId": "5414",
			"ghosteryOrganizationName": "Wix",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sumo.com",
			"disconnectMeName": "BDOW",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3560",
			"ghosteryOrganizationName": "SumoMe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "callrail.com",
			"disconnectMeName": "CallRail",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2652",
			"ghosteryOrganizationName": "CallRail",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "CallRail"
		},
		{
			"domains": "sumome.com",
			"disconnectMeName": "BDOW",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3560",
			"ghosteryOrganizationName": "SumoMe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "aniview.com",
			"disconnectMeName": "Aniview",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "upsellit.com",
			"disconnectMeName": "UpsellIt",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "642",
			"ghosteryOrganizationName": "UpSellit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "UpSellit"
		},
		{
			"domains": "sundaysky.com",
			"disconnectMeName": "SundaySky",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1896",
			"ghosteryOrganizationName": "SundaySky",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "SundaySky"
		},
		{
			"domains": "rightnowtech.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "shopifyapps.com",
			"disconnectMeName": "Shopify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "refersion.com",
			"disconnectMeName": "Refersion",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3359",
			"ghosteryOrganizationName": "Refersion",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Refersion"
		},
		{
			"domains": "jsrdn.com",
			"disconnectMeName": "DistroScale",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "4472",
			"ghosteryOrganizationName": "Distroscale",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Distroscale"
		},
		{
			"domains": "turner.com",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "Warner Bros. Discovery",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mrtnsvr.com",
			"disconnectMeName": "mrtnsvr.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "warnermedia.com",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "modularmental.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "wistia.net",
			"ghosteryId": "1307",
			"ghosteryOrganizationName": "Wistia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "dynamics.com",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "acuityplatform.com",
			"disconnectMeName": "Acuity",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1635",
			"ghosteryOrganizationName": "Acuity Ads",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Acuity"
		},
		{
			"domains": "msecnd.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nowinteract.com",
			"ghosteryId": "3623",
			"ghosteryOrganizationName": "Now Interact",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "connectad.io",
			"disconnectMeName": "ConnectAdRealtime",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cedexis.com",
			"disconnectMeName": "Cedexis",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "691",
			"ghosteryOrganizationName": "Cedexis",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Cedexis"
		},
		{
			"domains": "cedexis-radar.net",
			"ghosteryId": "691",
			"ghosteryOrganizationName": "Cedexis",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "browser-update.org",
			"disconnectMeName": "Browser-Update.org",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1146",
			"ghosteryOrganizationName": "Browser-Update",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Browser-Update"
		},
		{
			"domains": "adlooxtracking.com",
			"disconnectMeName": "Adloox",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1455",
			"ghosteryOrganizationName": "Adloox",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Adloox"
		},
		{
			"domains": "zeotap.com",
			"disconnectMeName": "Zeotap",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "jetpackdigital.com",
			"ghosteryId": "1859",
			"ghosteryOrganizationName": "Jetpack Digital",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "grow.me",
			"disconnectMeName": "Mediavine",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "plausible.io",
			"ghosteryId": "5437",
			"ghosteryOrganizationName": "Plausible Insights OÜ",
			"whenAddedToGhostery": "2023-10-23T10:26:24.000Z"
		},
		{
			"domains": "instagram.com",
			"disconnectMeName": "Meta",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Meta"
		},
		{
			"domains": "4dsply.com",
			"disconnectMeName": "Adsupply",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2159",
			"ghosteryOrganizationName": "AdSupply",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "AdSupply"
		},
		{
			"domains": "wt-safetag.com",
			"ghosteryId": "335",
			"ghosteryOrganizationName": "Webtrekk",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "msn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "Microsoft"
		},
		{
			"domains": "virtualearth.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pixel.ad",
			"disconnectMeName": "pixel.ad",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "714",
			"ghosteryOrganizationName": "Centro",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "getrockerbox.com",
			"disconnectMeName": "RockerBox",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "3705",
			"ghosteryOrganizationName": "Rockerbox",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Rockerbox"
		},
		{
			"domains": "salecycle.com",
			"ghosteryId": "1963",
			"ghosteryOrganizationName": "SaleCycle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "edigitalsurvey.com",
			"ghosteryId": "4605",
			"ghosteryOrganizationName": "MaruEdr",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "certona.net",
			"ghosteryId": "351",
			"ghosteryOrganizationName": "Certona",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "yieldify.com",
			"disconnectMeName": "Yieldify",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2874",
			"ghosteryOrganizationName": "Yieldify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Yieldify"
		},
		{
			"domains": "petametrics.com",
			"ghosteryId": "5356",
			"ghosteryOrganizationName": "LiftIgniter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "prmutv.co",
			"disconnectMeName": "Permutive",
			"organizationKnownAs": "Permutive",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "shopperapproved.com",
			"ghosteryId": "3981",
			"ghosteryOrganizationName": "Shopper Approved",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "acxiom.com",
			"disconnectMeName": "Acxiom",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "alicdn.com",
			"ghosteryId": "3001",
			"ghosteryOrganizationName": "Alibaba",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "AlibabaGroup",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "Alibaba"
		},
		{
			"domains": "mmstat.com",
			"ghosteryId": "2149",
			"ghosteryOrganizationName": "MarkMonitor",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "alibaba.com",
			"ghosteryId": "3001",
			"ghosteryOrganizationName": "Alibaba",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mentorsticks.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adrta.com",
			"ghosteryId": "4097",
			"ghosteryOrganizationName": "Pixalate, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "advertising.com",
			"disconnectMeName": "Yahoo!",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "addthis.com",
			"disconnectMeName": "Oracle",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Oracle"
		},
		{
			"domains": "azurefd.net",
			"disconnectMeName": "Microsoft",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "b0e8.com",
			"disconnectMeName": "BrightEdge",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "brightedge.com",
			"disconnectMeName": "BrightEdge",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "vindicosuite.com",
			"disconnectMeName": "Viant",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "739",
			"ghosteryOrganizationName": "Vindico Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "webtrendslive.com",
			"disconnectMeName": "Webtrends",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "181",
			"ghosteryOrganizationName": "Webtrends",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"organizationKnownAs": "Webtrends"
		},
		{
			"domains": "optimahub.com",
			"ghosteryId": "3231",
			"ghosteryOrganizationName": "Datalicious",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tiktokcdn.com",
			"ghosteryId": "5432",
			"ghosteryOrganizationName": "ByteDance Inc",
			"whenAddedToGhostery": "2023-09-27T14:48:32.000Z",
			"disconnectMeName": "Bytedance",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"organizationKnownAs": "Bytedance"
		},
		{
			"domains": "cohesionapps.com",
			"ghosteryId": "5118",
			"ghosteryOrganizationName": "Red Ventures",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z",
			"disconnectMeName": "cohesionapps.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "events.launchdarkly.com",
			"ghosteryId": "4946",
			"ghosteryOrganizationName": "Launch Darkly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pricespider.com",
			"ghosteryId": "4411",
			"ghosteryOrganizationName": "Price Spider",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "snippet.minute.ly",
			"ghosteryId": "4282",
			"ghosteryOrganizationName": "Minute.ly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sanalytics.disneyplus.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company",
			"whenAddedToGhostery": "2024-05-28T13:05:38.000Z"
		},
		{
			"domains": "widget.engageya.com",
			"ghosteryId": "4404",
			"ghosteryOrganizationName": "Engageya",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "static.ordergroove.com",
			"ghosteryId": "4456",
			"ghosteryOrganizationName": "Order Groove",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "app.viral-loops.com",
			"ghosteryId": "4339",
			"ghosteryOrganizationName": "Viral-Loops",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tracker.unbxdapi.com",
			"ghosteryId": "4437",
			"ghosteryOrganizationName": "UNBXD",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "thisgreencolumn.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pubnub.com",
			"disconnectMeName": "PubNub",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "webgains.io",
			"disconnectMeName": "ad pepper group",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ay.delivery",
			"disconnectMeName": "AssertiveYield",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "adara.com",
			"disconnectMeName": "RateGain",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "gbqofs.com",
			"disconnectMeName": "gbqofs.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "jsdelivr.net",
			"disconnectMeName": "Volentio JSD",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "bizible.com",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "bizibly.com",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "arkoselabs.com",
			"disconnectMeName": "ArkoseLabs",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "effulgenttempest.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "albss.com",
			"disconnectMeName": "albss.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "webcontentassessor.com",
			"disconnectMeName": "TMTDigital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn_6vxkyqywaf9f1t7-usbank.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733864389-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "ebxcdn.com",
			"disconnectMeName": "Echobox",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "awswaf.com",
			"disconnectMeName": "Amazon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tiktokcdn-us.com",
			"disconnectMeName": "Bytedance",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ttwstatic.com",
			"disconnectMeName": "Bytedance",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "trackonomics.net",
			"disconnectMeName": "Impact",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "enigmaticcanyon.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "sparkloop.app",
			"disconnectMeName": "SparkLoop",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "geoip-js.com",
			"disconnectMeName": "MaxMind",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "maggieeatstheangel.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ltwebstatic.com",
			"disconnectMeName": "Shein",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-119_ts-1733859552-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "nimbleplot.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "fouanalytics.com",
			"disconnectMeName": "FouAnalytics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "b2c.com",
			"disconnectMeName": "Marketing Science",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "isstarsbuilding.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "sprysummit.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-119_ts-1733853201-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "curbminers.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ambrosialsummit.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "flourishingpartnership.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "quadpay.com",
			"disconnectMeName": "Zip",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "damageddistance.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "daum.net",
			"disconnectMeName": "Kakao",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-119_ts-1733852078-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733861220-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "cdn-net.com",
			"disconnectMeName": "American Express",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mux.com",
			"disconnectMeName": "Mux",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "getdeviceinf.com",
			"disconnectMeName": "getdeviceinf.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "7seasky.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn_3siux5otvvf1mct-intuit.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn_42v6draxyafsjmv-homedepot.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "contentful.com",
			"disconnectMeName": "Contentful",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "alcmpn.com",
			"disconnectMeName": "Adstra",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "emarsys.net",
			"disconnectMeName": "SAP",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733852622-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733855525-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "andstarsbuilding.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-119_ts-1733860447-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "rageagainstthesoap.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733854788-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "joincheckmate.com",
			"disconnectMeName": "Checkmate",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "bitmovin.com",
			"disconnectMeName": "BitMovin",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "thisgreencolumn.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733852959-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn_ed65ynwxvsuk9lf-cbs.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "geniuslinkcdn.com",
			"disconnectMeName": "Geniuslink",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "flipp.com",
			"disconnectMeName": "Flipp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "bleacherreport.net",
			"disconnectMeName": "Warner Bros. Discovery",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "piwik.pro",
			"disconnectMeName": "CookieInformation",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "traderbyte.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733861070-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-119_ts-1733858629-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733852790-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "fonts.googleapis.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdn.cookielaw.org",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "www.googletagmanager.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn3.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a20673560014.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "www.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "s.adroll.com",
			"ghosteryId": "412",
			"ghosteryOrganizationName": "AdRoll",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tag.demandbase.com",
			"ghosteryId": "53",
			"ghosteryOrganizationName": "Demandbase"
		},
		{
			"domains": "snap.licdn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "connect.facebook.net",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "s.yimg.jp",
			"ghosteryId": "2456",
			"ghosteryOrganizationName": "Yahoo! Japan"
		},
		{
			"domains": "j.6sc.co",
			"ghosteryId": "2536",
			"ghosteryOrganizationName": "6Sense"
		},
		{
			"domains": "bat.bing.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "www.youtube.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-29673.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "idio.episerver.net",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "usea01.idio.episerver.net",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "s.usea01.idio.episerver.net",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "cdn.amplitude.com",
			"ghosteryId": "3070",
			"ghosteryOrganizationName": "Amplitude"
		},
		{
			"domains": "t.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cmp.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "images4.cmp.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9513928.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "td.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ad.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "g.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "googleads.g.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "s.company-target.com",
			"ghosteryId": "53",
			"ghosteryOrganizationName": "Demandbase"
		},
		{
			"domains": "id.rlcdn.com",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp"
		},
		{
			"domains": "api.company-target.com",
			"ghosteryId": "53",
			"ghosteryOrganizationName": "Demandbase"
		},
		{
			"domains": "idio.episerver.net",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "usea01.idio.episerver.net",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "a.usea01.idio.episerver.net",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "d.adroll.com",
			"ghosteryId": "412",
			"ghosteryOrganizationName": "AdRoll",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "www.google-analytics.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ads.linkedin.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "px.ads.linkedin.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2024-05-10T10:39:49.000Z"
		},
		{
			"domains": "tag-logger.demandbase.com",
			"ghosteryId": "53",
			"ghosteryOrganizationName": "Demandbase"
		},
		{
			"domains": "www.facebook.com",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "csxd.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "x.adroll.com",
			"ghosteryId": "412",
			"ghosteryOrganizationName": "AdRoll"
		},
		{
			"domains": "ipv6.6sc.co",
			"ghosteryId": "2536",
			"ghosteryOrganizationName": "6Sense"
		},
		{
			"domains": "b.6sc.co",
			"ghosteryId": "2536",
			"ghosteryOrganizationName": "6Sense"
		},
		{
			"domains": "c.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "logx.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "d.adroll.com",
			"ghosteryId": "412",
			"ghosteryOrganizationName": "AdRoll",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ipv4.d.adroll.com",
			"ghosteryId": "412",
			"ghosteryOrganizationName": "AdRoll"
		},
		{
			"domains": "x.bidswitch.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "idsync.rlcdn.com",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp"
		},
		{
			"domains": "pixel.tapad.com",
			"ghosteryId": "937",
			"ghosteryOrganizationName": "Telenor Group"
		},
		{
			"domains": "dsum-sec.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "pixel.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "us-u.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "sync.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "eb2.3lift.com",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sync.outbrain.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ib.adnxs.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "image2.pubmatic.com",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc."
		},
		{
			"domains": "ds.reson8.com",
			"ghosteryId": "868",
			"ghosteryOrganizationName": "Resonate"
		},
		{
			"domains": "i.liadm.com",
			"ghosteryId": "674",
			"ghosteryOrganizationName": "LiveIntent"
		},
		{
			"domains": "idsync.reson8.com",
			"ghosteryId": "868",
			"ghosteryOrganizationName": "Resonate"
		},
		{
			"domains": "api2.amplitude.com",
			"ghosteryId": "3070",
			"ghosteryOrganizationName": "Amplitude"
		},
		{
			"domains": "my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "zoom-privacy.my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "pubnub.com",
			"disconnectMeName": "PubNub",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "fonts.gstatic.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "pagead2.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o168728.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "sb.scorecardresearch.com",
			"ghosteryId": "246",
			"ghosteryOrganizationName": "comScore, Inc."
		},
		{
			"domains": "accounts.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2024-12-04T18:48:10.000Z"
		},
		{
			"domains": "s.pinimg.com",
			"ghosteryId": "1306",
			"ghosteryOrganizationName": "Pinterest",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "analytics.tiktok.com",
			"ghosteryId": "5432",
			"ghosteryOrganizationName": "ByteDance Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "www.redditstatic.com",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "aa.agkn.com",
			"ghosteryId": "3452",
			"ghosteryOrganizationName": "TransUnion"
		},
		{
			"domains": "d.agkn.com",
			"ghosteryId": "3452",
			"ghosteryOrganizationName": "TransUnion"
		},
		{
			"domains": "p.teads.tv",
			"ghosteryId": "2521",
			"ghosteryOrganizationName": "Teads"
		},
		{
			"domains": "js.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "4704202.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "pixel-config.reddit.com",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "alb.reddit.com",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "tr.snapchat.com",
			"ghosteryId": "157",
			"ghosteryOrganizationName": "Snap Technologies"
		},
		{
			"domains": "cm.teads.tv",
			"ghosteryId": "2521",
			"ghosteryOrganizationName": "Teads"
		},
		{
			"domains": "ct.pinterest.com",
			"ghosteryId": "1306",
			"ghosteryOrganizationName": "Pinterest",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "insight.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "www.clarity.ms",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fledge.teads.tv",
			"ghosteryId": "2521",
			"ghosteryOrganizationName": "Teads"
		},
		{
			"domains": "t.teads.tv",
			"ghosteryId": "2521",
			"ghosteryOrganizationName": "Teads"
		},
		{
			"domains": "tr6.snapchat.com",
			"ghosteryId": "157",
			"ghosteryOrganizationName": "Snap Technologies"
		},
		{
			"domains": "k.clarity.ms",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "storage.googleapis.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "g.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "securepubads.g.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fundingchoicesmessages.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2024-05-27T13:23:48.000Z"
		},
		{
			"domains": "imasdk.googleapis.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "www.gstatic.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "secure.quantserve.com",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "secure.statcounter.com",
			"ghosteryId": "162",
			"ghosteryOrganizationName": "StatCounter"
		},
		{
			"domains": "pbjs.e-planning.net",
			"ghosteryId": "509",
			"ghosteryOrganizationName": "e-planning"
		},
		{
			"domains": "analytics.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-06-19T15:39:26.000Z"
		},
		{
			"domains": "g.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "stats.g.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "rules.quantcount.com",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "c.statcounter.com",
			"ghosteryId": "162",
			"ghosteryOrganizationName": "StatCounter"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "0f9a68466fe2b73d6237f15ffb343d6b.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us-east-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "s3.us-east-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "polymarket-upload.s3.us-east-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "pixel.quantserve.com",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited"
		},
		{
			"domains": "ep1.adtrafficquality.google",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ep2.adtrafficquality.google",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "tpc.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "www.googleadservices.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "csi.gstatic.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "m.media-amazon.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "dynamic.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "sslwidget.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "gum.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "sr-client-cfg.amplitude.com",
			"ghosteryId": "3070",
			"ghosteryOrganizationName": "Amplitude"
		},
		{
			"domains": "us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "fledge.us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "measurement-api.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "cognito-identity.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "sts.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "commerce.bing.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "c.bing.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "rum.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "dataplane.rum.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "i.ytimg.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "play.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2024-12-05T11:28:39.000Z"
		},
		{
			"domains": "jnn-pa.googleapis.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "static.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ddvql06zg3s2o.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "static.cloudflareinsights.com",
			"ghosteryId": "2913",
			"ghosteryOrganizationName": "Cloudflare"
		},
		{
			"domains": "webgains.io",
			"disconnectMeName": "ad pepper group",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "www.dwin1.com",
			"ghosteryId": "1202",
			"ghosteryOrganizationName": "Axel Springer Group"
		},
		{
			"domains": "static.ads-twitter.com",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "analytics.twitter.com",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "d1flfk77wl2xk4.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "geolocation.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "s.yimg.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cmp.oath.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "consent.cmp.oath.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdn.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "ay.delivery",
			"disconnectMeName": "AssertiveYield",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pm-widget.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "trc.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "prebid.media.net",
			"ghosteryId": "1879",
			"ghosteryOrganizationName": "Media.net"
		},
		{
			"domains": "s.seedtag.com",
			"ghosteryId": "5280",
			"ghosteryOrganizationName": "Seedtag Advertising S.L"
		},
		{
			"domains": "bidder.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "hbopenbid.pubmatic.com",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc."
		},
		{
			"domains": "rtb.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "ads.yieldmo.com",
			"ghosteryId": "2918",
			"ghosteryOrganizationName": "Yieldmo, Inc."
		},
		{
			"domains": "htlb.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "tlx.3lift.com",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc."
		},
		{
			"domains": "prebid-server.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "fastlane.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "bidder.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "display.bidder.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "rp.liadm.com",
			"ghosteryId": "674",
			"ghosteryOrganizationName": "LiveIntent"
		},
		{
			"domains": "beacon.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "la-trc-events.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "images.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "pips.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "api.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "cds.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "abb51f12be187afe26053e18be4e1c87.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "static.criteo.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "js-sec.indexww.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "eus.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "ads.pubmatic.com",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc."
		},
		{
			"domains": "yahoo-bidout-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "contextual.media.net",
			"ghosteryId": "1879",
			"ghosteryOrganizationName": "Media.net"
		},
		{
			"domains": "assets.adobedtm.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "s.go-mpulse.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "dpm.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "comcast.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "d1.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "comcastcom.d1.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdn.quantummetric.com",
			"ghosteryId": "4748",
			"ghosteryOrganizationName": "Quantum Metric, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tag.bounceexchange.com",
			"ghosteryId": "2468",
			"ghosteryOrganizationName": "Bounce Exchange"
		},
		{
			"domains": "servedby.flashtalking.com",
			"ghosteryId": "442",
			"ghosteryOrganizationName": "Flashtalking",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "c.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "nebula-cdn.kampyle.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "c.go-mpulse.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "js.pulseinsights.com",
			"ghosteryId": "3656",
			"ghosteryOrganizationName": "Pulse Insights"
		},
		{
			"domains": "assets.bounceexchange.com",
			"ghosteryId": "2468",
			"ghosteryOrganizationName": "Bounce Exchange"
		},
		{
			"domains": "s.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "survey.pulseinsights.com",
			"ghosteryId": "3656",
			"ghosteryOrganizationName": "Pulse Insights"
		},
		{
			"domains": "login.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "4053494.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "login-ds.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "adservice.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "rl.quantummetric.com",
			"ghosteryId": "4748",
			"ghosteryOrganizationName": "Quantum Metric, Inc."
		},
		{
			"domains": "ingest.quantummetric.com",
			"ghosteryId": "4748",
			"ghosteryOrganizationName": "Quantum Metric, Inc."
		},
		{
			"domains": "adobedc.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "api.bounceexchange.com",
			"ghosteryId": "2468",
			"ghosteryOrganizationName": "Bounce Exchange"
		},
		{
			"domains": "my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "comcast-privacy.my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "col.eum-appdynamics.com",
			"ghosteryId": "2793",
			"ghosteryOrganizationName": "AppDynamics"
		},
		{
			"domains": "cdnjs.cloudflare.com",
			"ghosteryId": "2913",
			"ghosteryOrganizationName": "Cloudflare",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "www.microsoft.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdn-dynmedia-1.microsoft.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "mwf-service.akamaized.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "mscom.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "msftenterprise.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cm.everesttech.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "target.microsoft.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "login.microsoftonline.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "ad.atdmt.com",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta"
		},
		{
			"domains": "login.live.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "data.microsoft.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "events.data.microsoft.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "browser.events.data.microsoft.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "wcpstatic.microsoft.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "mem.gfx.ms",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "monitor.azure.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2024-01-23T11:41:01.000Z"
		},
		{
			"domains": "js.monitor.azure.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2024-01-23T11:41:01.000Z"
		},
		{
			"domains": "services.visualstudio.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "dc.services.visualstudio.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "abs.twimg.com",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp."
		},
		{
			"domains": "abs-0.twimg.com",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp."
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "wyndhamhotelgroup.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "maps.googleapis.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "wyndham.btttag.com",
			"ghosteryId": "3355",
			"ghosteryOrganizationName": "Blue Triangle"
		},
		{
			"domains": "static.tacdn.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)"
		},
		{
			"domains": "pixel.mathtag.com",
			"ghosteryId": "290",
			"ghosteryOrganizationName": "MediaMath, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adara.com",
			"disconnectMeName": "RateGain",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tag.yieldoptimizer.com",
			"ghosteryId": "286",
			"ghosteryOrganizationName": "Adara"
		},
		{
			"domains": "js.ipredictive.com",
			"ghosteryId": "3878",
			"ghosteryOrganizationName": "Viant"
		},
		{
			"domains": "www.tamgrt.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)"
		},
		{
			"domains": "adara.com",
			"disconnectMeName": "RateGain",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ad.ipredictive.com",
			"ghosteryId": "3878",
			"ghosteryOrganizationName": "Viant",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "adara.com",
			"disconnectMeName": "RateGain",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8052794.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6344610.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "f9prodcdn.azureedge.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "beacon.sojern.com",
			"ghosteryId": "782",
			"ghosteryOrganizationName": "Sojern, Inc."
		},
		{
			"domains": "r.appspot.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "uc.r.appspot.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "frontier-ga-c49424850.uc.r.appspot.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8303106.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "g.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cm.g.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.wisepops.com",
			"ghosteryId": "3348",
			"ghosteryOrganizationName": "WisePops"
		},
		{
			"domains": "tracking.wisepops.com",
			"ghosteryId": "3348",
			"ghosteryOrganizationName": "WisePops"
		},
		{
			"domains": "r.turn.com",
			"ghosteryId": "5298",
			"ghosteryOrganizationName": "Singtel",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "activity.wisepops.com",
			"ghosteryId": "3348",
			"ghosteryOrganizationName": "WisePops"
		},
		{
			"domains": "delta.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn0djfqwpekjgb6nu-deltacx.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "analytics.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sp.analytics.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "usage.trackjs.com",
			"ghosteryId": "3549",
			"ghosteryOrganizationName": "TrackJS",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "edge.adobedc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "d3h0wybtovte4j.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "static.adsafeprotected.com",
			"ghosteryId": "474",
			"ghosteryOrganizationName": "Integral Ad Science, Inc."
		},
		{
			"domains": "cdn.privacy-mgmt.com",
			"ghosteryId": "5230",
			"ghosteryOrganizationName": "Sourcepoint"
		},
		{
			"domains": "js-agent.newrelic.com",
			"ghosteryId": "942",
			"ghosteryOrganizationName": "New Relic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "aps.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "config.aps.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "tagan.adlightning.com",
			"ghosteryId": "5304",
			"ghosteryOrganizationName": "Ad Lightning"
		},
		{
			"domains": "api.rlcdn.com",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp"
		},
		{
			"domains": "aax.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "pixel.adsafeprotected.com",
			"ghosteryId": "474",
			"ghosteryOrganizationName": "Integral Ad Science, Inc."
		},
		{
			"domains": "api.cxense.com",
			"ghosteryId": "1160",
			"ghosteryOrganizationName": "Cxense"
		},
		{
			"domains": "tags.tiqcdn.com",
			"ghosteryId": "662",
			"ghosteryOrganizationName": "Tealium",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pg-prebid-server.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "grid-bidder.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "cdn.cxense.com",
			"ghosteryId": "1160",
			"ghosteryOrganizationName": "Cxense"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "4c65737c5a2b3ad3e7e488a1ae932783.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.doubleverify.com",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify"
		},
		{
			"domains": "ads.celtra.com",
			"ghosteryId": "921",
			"ghosteryOrganizationName": "Celtra"
		},
		{
			"domains": "acdn.adnxs.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "u.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "dowjones.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cache-ssl.celtra.com",
			"ghosteryId": "921",
			"ghosteryOrganizationName": "Celtra"
		},
		{
			"domains": "comcluster.cxense.com",
			"ghosteryId": "1160",
			"ghosteryOrganizationName": "Cxense"
		},
		{
			"domains": "s0.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tags.newscgp.com",
			"ghosteryId": "5365",
			"ghosteryOrganizationName": "News Corp"
		},
		{
			"domains": "us.tags.newscgp.com",
			"ghosteryId": "5365",
			"ghosteryOrganizationName": "News Corp"
		},
		{
			"domains": "d1z2jf7jlzjs58.cloudfront.net",
			"ghosteryId": "1009",
			"ghosteryOrganizationName": "Parse.ly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "secure-us.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "amplify.outbrain.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "www.dianomi.com",
			"ghosteryId": "1284",
			"ghosteryOrganizationName": "Dianomi",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hb.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "dowjones.hb.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "widgets.outbrain.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "js.datadome.co",
			"ghosteryId": "5226",
			"ghosteryOrganizationName": "DataDome",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "gbqofs.com",
			"disconnectMeName": "gbqofs.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ad.360yield.com",
			"ghosteryId": "523",
			"ghosteryOrganizationName": "Improve Digital",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "dt.adsafeprotected.com",
			"ghosteryId": "474",
			"ghosteryOrganizationName": "Integral Ad Science, Inc."
		},
		{
			"domains": "tps.doubleverify.com",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify"
		},
		{
			"domains": "track.celtra.com",
			"ghosteryId": "921",
			"ghosteryOrganizationName": "Celtra"
		},
		{
			"domains": "cdn.parsely.com",
			"ghosteryId": "1009",
			"ghosteryOrganizationName": "Parse.ly"
		},
		{
			"domains": "cdn-gl.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "wave.outbrain.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "tr.outbrain.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pixel.newscgp.com",
			"ghosteryId": "5365",
			"ghosteryOrganizationName": "News Corp"
		},
		{
			"domains": "v2.pixel.newscgp.com",
			"ghosteryId": "5365",
			"ghosteryOrganizationName": "News Corp"
		},
		{
			"domains": "widget-pixels.outbrain.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "mv.outbrain.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "ssp-sync.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "p1.parsely.com",
			"ghosteryId": "1009",
			"ghosteryOrganizationName": "Parse.ly"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13961696.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "api-js.datadome.co",
			"ghosteryId": "5226",
			"ghosteryOrganizationName": "DataDome"
		},
		{
			"domains": "mcdp-nydc1.outbrain.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "crb.kargo.com",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo"
		},
		{
			"domains": "image8.pubmatic.com",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc."
		},
		{
			"domains": "prebid-match.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "tpsc-ue1.doubleverify.com",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify"
		},
		{
			"domains": "bam.nr-data.net",
			"ghosteryId": "942",
			"ghosteryOrganizationName": "New Relic"
		},
		{
			"domains": "api.permutive.com",
			"ghosteryId": "5148",
			"ghosteryOrganizationName": "Permutive, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "use.typekit.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "p.typekit.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "capi.connatix.com",
			"ghosteryId": "3942",
			"ghosteryOrganizationName": "Connatix Native Exchange Inc."
		},
		{
			"domains": "script.crazyegg.com",
			"ghosteryId": "50",
			"ghosteryOrganizationName": "Crazy Egg"
		},
		{
			"domains": "cd.connatix.com",
			"ghosteryId": "3942",
			"ghosteryOrganizationName": "Connatix Native Exchange Inc."
		},
		{
			"domains": "ap.lijit.com",
			"ghosteryId": "99",
			"ghosteryOrganizationName": "Sovrn Holdings Inc"
		},
		{
			"domains": "e.serverbid.com",
			"ghosteryId": "5347",
			"ghosteryOrganizationName": "GiftConnect"
		},
		{
			"domains": "btlr.sharethrough.com",
			"ghosteryId": "718",
			"ghosteryOrganizationName": "Sharethrough, Inc"
		},
		{
			"domains": "jsdelivr.net",
			"disconnectMeName": "Volentio JSD",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cdn-ima.33across.com",
			"ghosteryId": "375",
			"ghosteryOrganizationName": "33Across"
		},
		{
			"domains": "cds.connatix.com",
			"ghosteryId": "3942",
			"ghosteryOrganizationName": "Connatix Native Exchange Inc."
		},
		{
			"domains": "cdn.fastclick.net",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "secure.cdn.fastclick.net",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "tags.crwdcntrl.net",
			"ghosteryId": "103",
			"ghosteryOrganizationName": "Lotame",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "lexicon.33across.com",
			"ghosteryId": "375",
			"ghosteryOrganizationName": "33Across"
		},
		{
			"domains": "bcp.crwdcntrl.net",
			"ghosteryId": "103",
			"ghosteryOrganizationName": "Lotame"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "71d4789b3d5769b6600b3d780e31eab6.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cpe.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "ad.cpe.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "proc.ad.cpe.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "tracking.crazyegg.com",
			"ghosteryId": "50",
			"ghosteryOrganizationName": "Crazy Egg"
		},
		{
			"domains": "ins.connatix.com",
			"ghosteryId": "3942",
			"ghosteryOrganizationName": "Connatix Native Exchange Inc."
		},
		{
			"domains": "vid.connatix.com",
			"ghosteryId": "3942",
			"ghosteryOrganizationName": "Connatix Native Exchange Inc."
		},
		{
			"domains": "lit.connatix.com",
			"ghosteryId": "3942",
			"ghosteryOrganizationName": "Connatix Native Exchange Inc."
		},
		{
			"domains": "sync.intentiq.com",
			"ghosteryId": "12",
			"ghosteryOrganizationName": "AlmondNet"
		},
		{
			"domains": "d-code.liadm.com",
			"ghosteryId": "674",
			"ghosteryOrganizationName": "LiveIntent"
		},
		{
			"domains": "api.btloader.com",
			"ghosteryId": "2675",
			"ghosteryOrganizationName": "Blockthrough"
		},
		{
			"domains": "img.connatix.com",
			"ghosteryId": "3942",
			"ghosteryOrganizationName": "Connatix Native Exchange Inc."
		},
		{
			"domains": "idx.liadm.com",
			"ghosteryId": "674",
			"ghosteryOrganizationName": "LiveIntent"
		},
		{
			"domains": "uipglob.semasio.net",
			"ghosteryId": "2088",
			"ghosteryOrganizationName": "Semasio GmbH"
		},
		{
			"domains": "secure.adnxs.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "token.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "match.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "d.turn.com",
			"ghosteryId": "5298",
			"ghosteryOrganizationName": "Singtel"
		},
		{
			"domains": "go.sonobi.com",
			"ghosteryId": "1412",
			"ghosteryOrganizationName": "Sonobi, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sync.go.sonobi.com",
			"ghosteryId": "1412",
			"ghosteryOrganizationName": "Sonobi, Inc"
		},
		{
			"domains": "cpe.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "ad.cpe.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "hb.ad.cpe.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "web.hb.ad.cpe.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "hb.emxdgt.com",
			"ghosteryId": "5333",
			"ghosteryOrganizationName": "Engine"
		},
		{
			"domains": "prg.smartadserver.com",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver"
		},
		{
			"domains": "pixel-us-east.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "fanbyte-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "ssc-cms.33across.com",
			"ghosteryId": "375",
			"ghosteryOrganizationName": "33Across"
		},
		{
			"domains": "pixel-sync.sitescout.com",
			"ghosteryId": "714",
			"ghosteryOrganizationName": "Centro"
		},
		{
			"domains": "sync.1rx.io",
			"ghosteryId": "673",
			"ghosteryOrganizationName": "RhythmOne, LLC"
		},
		{
			"domains": "data.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "vast.doubleverify.com",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify"
		},
		{
			"domains": "prebid.adnxs.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "match.sharethrough.com",
			"ghosteryId": "718",
			"ghosteryOrganizationName": "Sharethrough, Inc"
		},
		{
			"domains": "image4.pubmatic.com",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc."
		},
		{
			"domains": "ce.lijit.com",
			"ghosteryId": "99",
			"ghosteryOrganizationName": "Sovrn Holdings Inc"
		},
		{
			"domains": "unified.adsafeprotected.com",
			"ghosteryId": "474",
			"ghosteryOrganizationName": "Integral Ad Science, Inc."
		},
		{
			"domains": "sdk.streamrail.com",
			"ghosteryId": "5016",
			"ghosteryOrganizationName": "ironSource",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ybp.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pr-bh.ybp.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "gcdn.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "r5---sn-ab5sznzy.c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "r1---sn-ab5l6nrd.c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "choices.trustarc.com",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc"
		},
		{
			"domains": "choices-or.trustarc.com",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc"
		},
		{
			"domains": "beacon-nf.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "enduser.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "aax-us-east.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "beacon-iad2.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "um.simpli.fi",
			"ghosteryId": "550",
			"ghosteryOrganizationName": "Simplifi Holdings Inc."
		},
		{
			"domains": "prod.bidr.io",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "match.prod.bidr.io",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sync.ipredictive.com",
			"ghosteryId": "3878",
			"ghosteryOrganizationName": "Viant"
		},
		{
			"domains": "ad.turn.com",
			"ghosteryId": "5298",
			"ghosteryOrganizationName": "Singtel"
		},
		{
			"domains": "i.w55c.net",
			"ghosteryId": "292",
			"ghosteryOrganizationName": "DataXu"
		},
		{
			"domains": "vad-bid.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "secure-gg.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "ts.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "fw.adsafeprotected.com",
			"ghosteryId": "474",
			"ghosteryOrganizationName": "Integral Ad Science, Inc."
		},
		{
			"domains": "ade.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "oajs.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "google-bidout-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "r4---sn-ab5sznzk.c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.flashtalking.com",
			"ghosteryId": "442",
			"ghosteryOrganizationName": "Flashtalking",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "consent.trustarc.com",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc",
			"whenAddedToGhostery": "2023-05-16T09:04:17.000Z"
		},
		{
			"domains": "scripts.demandbase.com",
			"ghosteryId": "53",
			"ghosteryOrganizationName": "Demandbase"
		},
		{
			"domains": "sjs.bizographics.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2024-05-10T10:39:49.000Z"
		},
		{
			"domains": "cdnssl.clicktale.net",
			"ghosteryId": "41",
			"ghosteryOrganizationName": "ClickTale"
		},
		{
			"domains": "js.driftt.com",
			"ghosteryId": "4715",
			"ghosteryOrganizationName": "Drift",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hj.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "static.hj.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "c.clicktale.net",
			"ghosteryId": "41",
			"ghosteryOrganizationName": "ClickTale"
		},
		{
			"domains": "munchkin.marketo.net",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13175845.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "bizible.com",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "078-whz-188.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "bizibly.com",
			"disconnectMeName": "Adobe",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "js.hs-scripts.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "dcvxs6ggqztsa.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "static.hotjar.com",
			"ghosteryId": "3632",
			"ghosteryOrganizationName": "Hotjar"
		},
		{
			"domains": "cdn.heapanalytics.com",
			"ghosteryId": "2695",
			"ghosteryOrganizationName": "Heap"
		},
		{
			"domains": "js.hs-banner.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-03-22T13:47:05.000Z"
		},
		{
			"domains": "js.hsleadflows.net",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "js.hubspot.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "js.hsadspixel.net",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "js.hs-analytics.net",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "script.hotjar.com",
			"ghosteryId": "3632",
			"ghosteryOrganizationName": "Hotjar"
		},
		{
			"domains": "vc.hotjar.io",
			"ghosteryId": "3632",
			"ghosteryOrganizationName": "Hotjar"
		},
		{
			"domains": "cta-service-cms2.hubspot.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-03-22T13:47:05.000Z"
		},
		{
			"domains": "perf-na1.hsforms.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "track.hubspot.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "forms.hubspot.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "api.hubapi.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "s1.wp.com",
			"ghosteryId": "245",
			"ghosteryOrganizationName": "Automattic"
		},
		{
			"domains": "stats.wp.com",
			"ghosteryId": "245",
			"ghosteryOrganizationName": "Automattic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pixel.wp.com",
			"ghosteryId": "245",
			"ghosteryOrganizationName": "Automattic",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "s0.wp.com",
			"ghosteryId": "245",
			"ghosteryOrganizationName": "Automattic"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o4506547460440064.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "s-usweb.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "us-7.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "wingstoprestaurants.us-7.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "usadmm.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10980674.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "hathway.atlassian.net",
			"ghosteryId": "5312",
			"ghosteryOrganizationName": "Atlassian"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6318018.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "secure-ds.serving-sys.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "bs.serving-sys.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "privacyportal-eu.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "challenges.cloudflare.com",
			"ghosteryId": "2913",
			"ghosteryOrganizationName": "Cloudflare"
		},
		{
			"domains": "wileypublishing.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "wileypublishing.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "srv.stackadapt.com",
			"ghosteryId": "3952",
			"ghosteryOrganizationName": "StackAdapt",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tags.srv.stackadapt.com",
			"ghosteryId": "3952",
			"ghosteryOrganizationName": "StackAdapt",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "znbegz4t5dmpws5f4-wiley.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "invstatic101.creativecdn.com",
			"ghosteryId": "3371",
			"ghosteryOrganizationName": "RTB House"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "e0ed086689ed106374ea1de0541bf086.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "1390f5a0b31376f1883dda0adc2a619f.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.branch.io",
			"ghosteryId": "4164",
			"ghosteryOrganizationName": "Branch Metrics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wendyscommunities.force.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "privacyportal.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "consent-api.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "d22xmn10vbouk4.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "api2.branch.io",
			"ghosteryId": "4164",
			"ghosteryOrganizationName": "Branch Metrics"
		},
		{
			"domains": "arkoselabs.com",
			"disconnectMeName": "ArkoseLabs",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pdx-col.eum-appdynamics.com",
			"ghosteryId": "2793",
			"ghosteryOrganizationName": "AppDynamics"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "2549153.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "tr.contextweb.com",
			"ghosteryId": "293",
			"ghosteryOrganizationName": "PulsePoint, Inc."
		},
		{
			"domains": "d15kdpgjg3unno.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "hbx.media.net",
			"ghosteryId": "1879",
			"ghosteryOrganizationName": "Media.net"
		},
		{
			"domains": "tag.tapad.com",
			"ghosteryId": "937",
			"ghosteryOrganizationName": "Telenor Group"
		},
		{
			"domains": "pub.doubleverify.com",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify"
		},
		{
			"domains": "bh-eu.contextweb.com",
			"ghosteryId": "293",
			"ghosteryOrganizationName": "PulsePoint, Inc."
		},
		{
			"domains": "preferences.trustarc.com",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc"
		},
		{
			"domains": "privacy-policy.truste.com",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "77974a43be0b8f1debeb2562c32b4080.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "dyv1bugovvq1g.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "sqs.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "bh.contextweb.com",
			"ghosteryId": "293",
			"ghosteryOrganizationName": "PulsePoint, Inc."
		},
		{
			"domains": "vtrk.doubleverify.com",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify"
		},
		{
			"domains": "bh-medscape-cdn.contextweb.com",
			"ghosteryId": "293",
			"ghosteryOrganizationName": "PulsePoint, Inc."
		},
		{
			"domains": "hblg.media.net",
			"ghosteryId": "1879",
			"ghosteryOrganizationName": "Media.net"
		},
		{
			"domains": "ajax.googleapis.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c.betrad.com",
			"ghosteryId": "4957",
			"ghosteryOrganizationName": "Crownpeak",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "c.evidon.com",
			"ghosteryId": "4957",
			"ghosteryOrganizationName": "Crownpeak",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hbxlp.media.net",
			"ghosteryId": "1879",
			"ghosteryOrganizationName": "Media.net"
		},
		{
			"domains": "l.evidon.com",
			"ghosteryId": "4957",
			"ghosteryOrganizationName": "Crownpeak",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "micro.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "s.w-x.co",
			"ghosteryId": "263",
			"ghosteryOrganizationName": "IBM"
		},
		{
			"domains": "websdk.appsflyer.com",
			"ghosteryId": "4300",
			"ghosteryOrganizationName": "AppsFlyer"
		},
		{
			"domains": "effulgenttempest.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cdn.adsafeprotected.com",
			"ghosteryId": "474",
			"ghosteryOrganizationName": "Integral Ad Science, Inc."
		},
		{
			"domains": "ads.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "direct.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "8f730da83b3d7edc22fa213bf7918bc4.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c2.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "digital-cloud-west.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "resources.digital-cloud-west.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "us5.us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "cat.us5.us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "lb.indexww.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "k8s1-event-tracker-va.lb.indexww.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "choices.truste.com",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a2692.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "vam-bid.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "azad.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "prebid-a.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "ads.us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "nr-events.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "weatherus-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "ssum-sec.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "vidstat.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "us.criteo.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "csm.us.criteo.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "azenduser.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "imprlatbmp.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "la-match.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "la-vid-events.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "us.criteo.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "imageproxy.us.criteo.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "tps-dn-ue1.doubleverify.com",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify"
		},
		{
			"domains": "img.en25.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "w.soundcloud.com",
			"ghosteryId": "1817",
			"ghosteryOrganizationName": "SoundCloud",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "segments.company-target.com",
			"ghosteryId": "53",
			"ghosteryOrganizationName": "Demandbase"
		},
		{
			"domains": "global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "6085497.global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "edge.fullstory.com",
			"ghosteryId": "4100",
			"ghosteryOrganizationName": "fullstory"
		},
		{
			"domains": "rs.fullstory.com",
			"ghosteryId": "4100",
			"ghosteryOrganizationName": "fullstory"
		},
		{
			"domains": "nym1-ib.adnxs.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "cdn.adnxs.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "crcdn01.adnxs-simple.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "cdn.siftscience.com",
			"ghosteryId": "2686",
			"ghosteryOrganizationName": "Sift Science"
		},
		{
			"domains": "attribution.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "adresults-60-adswizz.attribution.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "rtb.adgrx.com",
			"ghosteryId": "433",
			"ghosteryOrganizationName": "Samsung"
		},
		{
			"domains": "ads.linkedin.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "dc.ads.linkedin.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2024-05-10T10:39:49.000Z"
		},
		{
			"domains": "albss.com",
			"disconnectMeName": "albss.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cdn-scripts.signifyd.com",
			"ghosteryId": "4889",
			"ghosteryOrganizationName": "Signifyd",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "d34r8q7sht0t9k.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "beacon.riskified.com",
			"ghosteryId": "5292",
			"ghosteryOrganizationName": "Riskified"
		},
		{
			"domains": "d.impactradius-event.com",
			"ghosteryId": "2230",
			"ghosteryOrganizationName": "Impact Radius"
		},
		{
			"domains": "cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "29e1a833e2dd.cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "fcmatch.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fcmatch.youtube.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "img.riskified.com",
			"ghosteryId": "5292",
			"ghosteryOrganizationName": "Riskified"
		},
		{
			"domains": "imgs.signifyd.com",
			"ghosteryId": "4889",
			"ghosteryOrganizationName": "Signifyd"
		},
		{
			"domains": "cdn123.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "523c447d36c5454d99ed935f6f20ae97-29e1a833e2dd.cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "cdn0.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "cdn3.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "c.riskified.com",
			"ghosteryId": "5292",
			"ghosteryOrganizationName": "Riskified"
		},
		{
			"domains": "albss.com",
			"disconnectMeName": "albss.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "duuytoqss3gu4.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "static.chartbeat.com",
			"ghosteryId": "313",
			"ghosteryOrganizationName": "ChartBeat"
		},
		{
			"domains": "webcontentassessor.com",
			"disconnectMeName": "TMTDigital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "news.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "grid.bidswitch.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "ping.chartbeat.net",
			"ghosteryId": "313",
			"ghosteryOrganizationName": "ChartBeat"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "372c44d8c18b2473254f0f9dad8f6abd.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d1get58iwmjrxx.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "g.3gl.net",
			"ghosteryId": "2897",
			"ghosteryOrganizationName": "Catchpoint Systems"
		},
		{
			"domains": "r.3gl.net",
			"ghosteryId": "2897",
			"ghosteryOrganizationName": "Catchpoint Systems"
		},
		{
			"domains": "fid.agkn.com",
			"ghosteryId": "3452",
			"ghosteryOrganizationName": "TransUnion"
		},
		{
			"domains": "js-cdn.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "s2.go-mpulse.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "0e993ae85014f9cc08d5e105146d8487.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "d.us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "walgreens.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "mihvea1f.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13040738.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "udc-neb.kampyle.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "digital-cloud-west.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "analytics-fe.digital-cloud-west.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "www.expedia.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)"
		},
		{
			"domains": "mediaim.expedia.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)"
		},
		{
			"domains": "cdn.tagcommander.com",
			"ghosteryId": "1789",
			"ghosteryOrganizationName": "Commanders Act"
		},
		{
			"domains": "oms.expedia.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6519113.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "www.trvl-px.com",
			"ghosteryId": "3951",
			"ghosteryOrganizationName": "IAC (InterActiveCorp)",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "d30qdagvt44524.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "b-code.liadm.com",
			"ghosteryId": "674",
			"ghosteryOrganizationName": "LiveIntent"
		},
		{
			"domains": "sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "id.sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "a731d2bcb76fc4b7977904681bb2abf2.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ak.sail-horizon.com",
			"ghosteryId": "1550",
			"ghosteryOrganizationName": "Sailthru",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "graph.bluecava.com",
			"ghosteryId": "670",
			"ghosteryOrganizationName": "Qualia"
		},
		{
			"domains": "sync.graph.bluecava.com",
			"ghosteryId": "670",
			"ghosteryOrganizationName": "Qualia"
		},
		{
			"domains": "api.sail-personalize.com",
			"ghosteryId": "1550",
			"ghosteryOrganizationName": "Sailthru"
		},
		{
			"domains": "dsum.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "s-static.innovid.com",
			"ghosteryId": "825",
			"ghosteryOrganizationName": "Innovid"
		},
		{
			"domains": "rtr.innovid.com",
			"ghosteryId": "825",
			"ghosteryOrganizationName": "Innovid"
		},
		{
			"domains": "d2v83son8kay5v.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "resources.xg4ken.com",
			"ghosteryId": "1299",
			"ghosteryOrganizationName": "Kenshoo"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-40192.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "bf.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "srm.bf.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "685973.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "track.sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13092265.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "s-a.innovid.com",
			"ghosteryId": "825",
			"ghosteryOrganizationName": "Innovid"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn9nssxmv9itcz7nq-verizoncx.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "iad1.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "track.securedvisit.com",
			"ghosteryId": "2234",
			"ghosteryOrganizationName": "SecuredVisit"
		},
		{
			"domains": "s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bctn-vi.s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "rical-images.s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bctn-sao.s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "us-west-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "s3.us-west-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "bc228849563943-vegas-insider-cdn-production.s3.us-west-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "my.rtmark.net",
			"ghosteryId": "5316",
			"ghosteryOrganizationName": "Big Wall Vision"
		},
		{
			"domains": "l.admedo.com",
			"ghosteryId": "3222",
			"ghosteryOrganizationName": "Admedo"
		},
		{
			"domains": "pj.l.admedo.com",
			"ghosteryId": "3222",
			"ghosteryOrganizationName": "Admedo"
		},
		{
			"domains": "psb.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "l.admedo.com",
			"ghosteryId": "3222",
			"ghosteryOrganizationName": "Admedo"
		},
		{
			"domains": "ps.l.admedo.com",
			"ghosteryId": "3222",
			"ghosteryOrganizationName": "Admedo"
		},
		{
			"domains": "js-eu1.hs-scripts.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "pool.admedo.com",
			"ghosteryId": "3222",
			"ghosteryOrganizationName": "Admedo"
		},
		{
			"domains": "prod.bidr.io",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "segment.prod.bidr.io",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax"
		},
		{
			"domains": "js-eu1.hsadspixel.net",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "js-eu1.hs-analytics.net",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "js-eu1.hscollectedforms.net",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "js-eu1.hs-banner.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "trc-events.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "api-eu1.hubapi.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "forms-eu1.hscollectedforms.net",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "track-eu1.hubspot.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "prod.bidr.io",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "event.prod.bidr.io",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax"
		},
		{
			"domains": "cnv.event.prod.bidr.io",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "12332392.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.bttrack.com",
			"ghosteryId": "4166",
			"ghosteryOrganizationName": "Simpli.fi",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9544918.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "tags.w55c.net",
			"ghosteryId": "292",
			"ghosteryOrganizationName": "DataXu"
		},
		{
			"domains": "ads.undertone.com",
			"ghosteryId": "269",
			"ghosteryOrganizationName": "Perion",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "digital-cloud-prem.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "resources.digital-cloud-prem.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "digital-cloud-prem.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "analytics-fe.digital-cloud-prem.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "privacyportal-de.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "code.jquery.com",
			"ghosteryId": "5354",
			"ghosteryOrganizationName": "JS Foundation"
		},
		{
			"domains": "aps.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "client.aps.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "dsbahmgppc0j4.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "krk2.kargo.com",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "9b6bdaaaf6b8945e917ba4134f56009b.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "static.yieldmo.com",
			"ghosteryId": "2918",
			"ghosteryOrganizationName": "Yieldmo, Inc."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "2e83c8a7d9ccfe5bdfa1d700e14512df.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "matchadsrvr.yieldmo.com",
			"ghosteryId": "2918",
			"ghosteryOrganizationName": "Yieldmo, Inc."
		},
		{
			"domains": "a2745.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "go.sonobi.com",
			"ghosteryId": "1412",
			"ghosteryOrganizationName": "Sonobi, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "apex.go.sonobi.com",
			"ghosteryId": "1412",
			"ghosteryOrganizationName": "Sonobi, Inc"
		},
		{
			"domains": "hb-api.omnitagjs.com",
			"ghosteryId": "2629",
			"ghosteryOrganizationName": "Open Web"
		},
		{
			"domains": "rtb0.doubleverify.com",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify"
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "kinesis.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "z.moatads.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "aa1610a9270920b59c2e77d420139443.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "g.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bid.g.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "secure.insightexpressai.com",
			"ghosteryId": "114",
			"ghosteryOrganizationName": "Kantar Group"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "36165d1bbad51d3548c10dfc96bf5d8e.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "82f75e2615692b0be2e0a9c3729c9af8.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "a622.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "visitor.omnitagjs.com",
			"ghosteryId": "2629",
			"ghosteryOrganizationName": "Open Web"
		},
		{
			"domains": "brightcom-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "cs.admanmedia.com",
			"ghosteryId": "4490",
			"ghosteryOrganizationName": "illumin"
		},
		{
			"domains": "pm.w55c.net",
			"ghosteryId": "292",
			"ghosteryOrganizationName": "DataXu"
		},
		{
			"domains": "ad.smaato.net",
			"ghosteryId": "920",
			"ghosteryOrganizationName": "Verve Group"
		},
		{
			"domains": "s.ad.smaato.net",
			"ghosteryId": "920",
			"ghosteryOrganizationName": "Verve Group"
		},
		{
			"domains": "tr.blismedia.com",
			"ghosteryId": "5318",
			"ghosteryOrganizationName": "Blis"
		},
		{
			"domains": "navvy.media.net",
			"ghosteryId": "1879",
			"ghosteryOrganizationName": "Media.net"
		},
		{
			"domains": "a975.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "a639.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "ssl.connextra.com",
			"ghosteryId": "502",
			"ghosteryOrganizationName": "Connextra"
		},
		{
			"domains": "prod.bidr.io",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "event.prod.bidr.io",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax"
		},
		{
			"domains": "us-east-1.event.prod.bidr.io",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax"
		},
		{
			"domains": "media.bidr.io",
			"ghosteryId": "4160",
			"ghosteryOrganizationName": "Beeswax"
		},
		{
			"domains": "js.hsforms.net",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "cdn.livechatinc.com",
			"ghosteryId": "2653",
			"ghosteryOrganizationName": "LiveChat"
		},
		{
			"domains": "dev.visualwebsiteoptimizer.com",
			"ghosteryId": "276",
			"ghosteryOrganizationName": "Wingify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a.omappapi.com",
			"ghosteryId": "5129",
			"ghosteryOrganizationName": "OptinMonster"
		},
		{
			"domains": "api.livechatinc.com",
			"ghosteryId": "2653",
			"ghosteryOrganizationName": "LiveChat"
		},
		{
			"domains": "forms.hsforms.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "api.omappapi.com",
			"ghosteryId": "5129",
			"ghosteryOrganizationName": "OptinMonster"
		},
		{
			"domains": "forms-na1.hsforms.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "secure.livechatinc.com",
			"ghosteryId": "2653",
			"ghosteryOrganizationName": "LiveChat"
		},
		{
			"domains": "forms-na1.hubspot.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "z.omappapi.com",
			"ghosteryId": "5129",
			"ghosteryOrganizationName": "OptinMonster"
		},
		{
			"domains": "cdn.aralego.net",
			"ghosteryId": "5431",
			"ghosteryOrganizationName": "ucfunnel",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdn.appdynamics.com",
			"ghosteryId": "2793",
			"ghosteryOrganizationName": "AppDynamics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "usbank.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "usbank.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "562-ct.c3tag.com",
			"ghosteryId": "754",
			"ghosteryOrganizationName": "C3 Metrics"
		},
		{
			"domains": "img.c3tag.com",
			"ghosteryId": "754",
			"ghosteryOrganizationName": "C3 Metrics"
		},
		{
			"domains": "global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "5093.global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6219543.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "451-rqs-232.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "mpsnare.iesnare.com",
			"ghosteryId": "388",
			"ghosteryOrganizationName": "iovation"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn_6vxkyqywaf9f1t7-usbank.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "a.teads.tv",
			"ghosteryId": "2521",
			"ghosteryOrganizationName": "Teads"
		},
		{
			"domains": "hlsmedia.gannett-cdn.com",
			"ghosteryId": "76",
			"ghosteryOrganizationName": "Gannett Digital Media Network"
		},
		{
			"domains": "hp.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "7a9cc3caf59c26fa137c1d13957fa4e7.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "r5---sn-ab5sznze.c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "vidstatb.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "web-sdk.urbanairship.com",
			"ghosteryId": "3072",
			"ghosteryOrganizationName": "Urban Airship, Inc."
		},
		{
			"domains": "bid.contextweb.com",
			"ghosteryId": "293",
			"ghosteryOrganizationName": "PulsePoint, Inc."
		},
		{
			"domains": "targeting.unrulymedia.com",
			"ghosteryId": "1904",
			"ghosteryOrganizationName": "Tremor International"
		},
		{
			"domains": "taboola-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "znb1hw37qc9ivyln7-usaa.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "di.rlcdn.com",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6301032.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "ups.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "ups.inq.com",
			"ghosteryId": "230",
			"ghosteryOrganizationName": "TouchCommerce"
		},
		{
			"domains": "ups.blueconic.net",
			"ghosteryId": "3860",
			"ghosteryOrganizationName": "BlueConic"
		},
		{
			"domains": "datacloud.tealiumiq.com",
			"ghosteryId": "662",
			"ghosteryOrganizationName": "Tealium"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6451349.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "trial-eum-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "trial-eum-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn1gqrxzvrld7vjwm-upscx.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733864389-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "jf7gf3qxfa6bgz2yvpcq-pah2ky-d53a5af01-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "68794910.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "mboxedge34.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cdn.lpsnmedia.net",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fs.liveperson.com",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "dev.fs.liveperson.com",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "static-assets.dev.fs.liveperson.com",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "lpcdn.lpsnmedia.net",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a9972578858.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "uniteddigital.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "10b3b05bfd2cf4f3e33d1d18c31f1e70.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "maps.gstatic.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "united-sync.quantummetric.com",
			"ghosteryId": "4748",
			"ghosteryOrganizationName": "Quantum Metric, Inc."
		},
		{
			"domains": "173bf108.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "v.liveperson.net",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "va.v.liveperson.net",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "ws.sharethis.com",
			"ghosteryId": "149",
			"ghosteryOrganizationName": "ShareThis, Inc."
		},
		{
			"domains": "platform.twitter.com",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "l.sharethis.com",
			"ghosteryId": "149",
			"ghosteryOrganizationName": "ShareThis, Inc."
		},
		{
			"domains": "apis.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "analytics.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "connectid.analytics.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "ebxcdn.com",
			"disconnectMeName": "Echobox",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "803df48c028b96c04e78646a1346ced7.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ultimate-guitar-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "as-sec.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "9eb9f09bdb3cbccc95345ac0087a7b4a.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "t.channeladvisor.com",
			"ghosteryId": "367",
			"ghosteryOrganizationName": "ChannelAdvisor",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "try.abtasty.com",
			"ghosteryId": "3037",
			"ghosteryOrganizationName": "AB Tasty"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "4728858.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ulta3282541z.btttag.com",
			"ghosteryId": "3355",
			"ghosteryOrganizationName": "Blue Triangle"
		},
		{
			"domains": "ulta-1.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9596862.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "tracking2.channeladvisor.com",
			"ghosteryId": "367",
			"ghosteryOrganizationName": "ChannelAdvisor"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "14666520.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "pixels.spotify.com",
			"ghosteryId": "1816",
			"ghosteryOrganizationName": "Spotify"
		},
		{
			"domains": "dcinfos-cache.abtasty.com",
			"ghosteryId": "3037",
			"ghosteryOrganizationName": "AB Tasty"
		},
		{
			"domains": "ariane.abtasty.com",
			"ghosteryId": "3037",
			"ghosteryOrganizationName": "AB Tasty"
		},
		{
			"domains": "universal.iperceptions.com",
			"ghosteryId": "92",
			"ghosteryOrganizationName": "iPerceptions"
		},
		{
			"domains": "lptag.liveperson.net",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "accdn.lpsnmedia.net",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "lpcdn-gcp.lpsnmedia.net",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn0neqx1dggrrlv4y-uhgenterprise.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "api.iperceptions.com",
			"ghosteryId": "92",
			"ghosteryOrganizationName": "iPerceptions"
		},
		{
			"domains": "sd.iperceptions.com",
			"ghosteryId": "92",
			"ghosteryOrganizationName": "iPerceptions"
		},
		{
			"domains": "art.azureedge.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "post.iperceptions.com",
			"ghosteryId": "92",
			"ghosteryOrganizationName": "iPerceptions"
		},
		{
			"domains": "v.liveperson.net",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "va1.v.liveperson.net",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "cdnep-uhaul-uhaulcom-global-p-001.azureedge.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "ajax.aspnetcdn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "js.appboycdn.com",
			"ghosteryId": "5321",
			"ghosteryOrganizationName": "Braze"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn43febpplzacr5kl-uhaul.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "pdx1.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "d3i4yxtzktqr9n.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "k.twitchcdn.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "static-cdn.jtvnw.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "hls.ttvnw.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "abs.hls.ttvnw.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "pdx01.abs.hls.ttvnw.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "video-edge-c00fc8.pdx01.abs.hls.ttvnw.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d2v02itv0y9u9t.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "secure-sts-prod.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "redinuid.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "0c137993fae875e3643a81cfda992d0a.redinuid.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "darnuid.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "9c2a7ed4e91d369b.darnuid.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "g2.gumgum.com",
			"ghosteryId": "84",
			"ghosteryOrganizationName": "GumGum",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hb.undertone.com",
			"ghosteryId": "269",
			"ghosteryOrganizationName": "Perion"
		},
		{
			"domains": "exchange.postrelease.com",
			"ghosteryId": "2568",
			"ghosteryOrganizationName": "Nativo"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "9b4eac26e49535b81d8e0b2b5e932658.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ybp.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pn.ybp.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "a637.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "rtbc-ue1.doubleverify.com",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify"
		},
		{
			"domains": "tag.researchnow.com",
			"ghosteryId": "2770",
			"ghosteryOrganizationName": "Research Now Group, Inc"
		},
		{
			"domains": "tvtropes2023-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "csync.smartadserver.com",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver"
		},
		{
			"domains": "cdn.undertone.com",
			"ghosteryId": "269",
			"ghosteryOrganizationName": "Perion",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "match.justpremium.com",
			"ghosteryId": "2882",
			"ghosteryOrganizationName": "GumGum"
		},
		{
			"domains": "fast.wistia.com",
			"ghosteryId": "1307",
			"ghosteryOrganizationName": "Wistia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "idpix.media6degrees.com",
			"ghosteryId": "111",
			"ghosteryOrganizationName": "Dstillery"
		},
		{
			"domains": "pixel.everesttech.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "a.tribalfusion.com",
			"ghosteryId": "64",
			"ghosteryOrganizationName": "Exponential Interactive, Inc"
		},
		{
			"domains": "analytics.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cms.analytics.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "sync-tm.everesttech.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "srv.stackadapt.com",
			"ghosteryId": "3952",
			"ghosteryOrganizationName": "StackAdapt",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sync.srv.stackadapt.com",
			"ghosteryId": "3952",
			"ghosteryOrganizationName": "StackAdapt"
		},
		{
			"domains": "analytics.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ups.analytics.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "search.spotxchange.com",
			"ghosteryId": "2991",
			"ghosteryOrganizationName": "RTL Group"
		},
		{
			"domains": "sync.search.spotxchange.com",
			"ghosteryId": "2991",
			"ghosteryOrganizationName": "RTL Group"
		},
		{
			"domains": "embed-ssl.wistia.com",
			"ghosteryId": "1307",
			"ghosteryOrganizationName": "Wistia"
		},
		{
			"domains": "sc.pages02.net",
			"ghosteryId": "263",
			"ghosteryOrganizationName": "IBM"
		},
		{
			"domains": "www.sc.pages02.net",
			"ghosteryId": "263",
			"ghosteryOrganizationName": "IBM"
		},
		{
			"domains": "t.eloqua.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "s1358293874.t.eloqua.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "t.eloqua.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "s1137986.t.eloqua.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "pipedream.wistia.com",
			"ghosteryId": "1307",
			"ghosteryOrganizationName": "Wistia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "distillery.wistia.com",
			"ghosteryId": "1307",
			"ghosteryOrganizationName": "Wistia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "www.pages02.net",
			"ghosteryId": "263",
			"ghosteryOrganizationName": "IBM"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn9enqgwlulcwnbsw-truistcx.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "troweprice.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn8dicwx5syuf137l-trowe.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "trp-app.quantummetric.com",
			"ghosteryId": "4748",
			"ghosteryOrganizationName": "Quantum Metric, Inc."
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "12646335.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "static.clicktripz.com",
			"ghosteryId": "3110",
			"ghosteryOrganizationName": "ClickTripz"
		},
		{
			"domains": "tags.creativecdn.com",
			"ghosteryId": "3371",
			"ghosteryOrganizationName": "RTB House"
		},
		{
			"domains": "www.mainadv.com",
			"ghosteryId": "1622",
			"ghosteryOrganizationName": "mainADV",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "api.clicktripz.com",
			"ghosteryId": "3110",
			"ghosteryOrganizationName": "ClickTripz"
		},
		{
			"domains": "ams.creativecdn.com",
			"ghosteryId": "3371",
			"ghosteryOrganizationName": "RTB House"
		},
		{
			"domains": "d2d7do8qaecbru.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "rt.udmserve.net",
			"ghosteryId": "748",
			"ghosteryOrganizationName": "Underdog Media LLC"
		},
		{
			"domains": "eu-west-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cognito-identity.eu-west-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "eu-west-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "firehose.eu-west-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "toyota.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "toyota.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "awswaf.com",
			"disconnectMeName": "Amazon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "awswaf.com",
			"disconnectMeName": "Amazon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "toyota-tagging-prod.azureedge.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "px.adentifi.com",
			"ghosteryId": "3622",
			"ghosteryOrganizationName": "AdTheorent, Inc"
		},
		{
			"domains": "g.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pubads.g.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "621119.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "rtb.adentifi.com",
			"ghosteryId": "3622",
			"ghosteryOrganizationName": "AdTheorent, Inc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tapestry.tapad.com",
			"ghosteryId": "937",
			"ghosteryOrganizationName": "Telenor Group"
		},
		{
			"domains": "az.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "ca.az.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "af.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "srm.af.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "fox.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "www.youtube-nocookie.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "pubgw.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "c2shb.pubgw.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "foxnews-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "krk.kargo.com",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo"
		},
		{
			"domains": "ssc.33across.com",
			"ghosteryId": "375",
			"ghosteryOrganizationName": "33Across"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "af579235e9593550663e05cf3413f5bf.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ib.3lift.com",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc."
		},
		{
			"domains": "de.tynt.com",
			"ghosteryId": "375",
			"ghosteryOrganizationName": "33Across"
		},
		{
			"domains": "connatix-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "tiktokcdn-us.com",
			"disconnectMeName": "Bytedance",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tiktokcdn-us.com",
			"disconnectMeName": "Bytedance",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ttwstatic.com",
			"disconnectMeName": "Bytedance",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tiktokcdn-us.com",
			"disconnectMeName": "Bytedance",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tiktokcdn-us.com",
			"disconnectMeName": "Bytedance",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "tiktokcdn-us.com",
			"disconnectMeName": "Bytedance",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "p16-sign-va.tiktokcdn.com",
			"ghosteryId": "5432",
			"ghosteryOrganizationName": "ByteDance Inc",
			"whenAddedToGhostery": "2023-09-27T14:48:32.000Z"
		},
		{
			"domains": "tiktokcdn-us.com",
			"disconnectMeName": "Bytedance",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "c.lytics.io",
			"ghosteryId": "4376",
			"ghosteryOrganizationName": "Lytics",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "w.usabilla.com",
			"ghosteryId": "2858",
			"ghosteryOrganizationName": "SurveyMonkey",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "az.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "c.az.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "d6tizftlrpuof.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "sync.smartadserver.com",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver"
		},
		{
			"domains": "us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "us5.us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "b.us5.us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "se.monetate.net",
			"ghosteryId": "601",
			"ghosteryOrganizationName": "Monetate"
		},
		{
			"domains": "sb.monetate.net",
			"ghosteryId": "601",
			"ghosteryOrganizationName": "Monetate"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "8a2d06b1080ff0218dd90ea9967ac096.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "af.monetate.net",
			"ghosteryId": "601",
			"ghosteryOrganizationName": "Monetate"
		},
		{
			"domains": "global.proper.io",
			"ghosteryId": "5216",
			"ghosteryOrganizationName": "Proper Media",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "player.anyclip.com",
			"ghosteryId": "5259",
			"ghosteryOrganizationName": "AnyClip",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "abcheck.proper.io",
			"ghosteryId": "5216",
			"ghosteryOrganizationName": "Proper Media"
		},
		{
			"domains": "bids.proper.io",
			"ghosteryId": "5216",
			"ghosteryOrganizationName": "Proper Media"
		},
		{
			"domains": "pxdrop.lijit.com",
			"ghosteryId": "99",
			"ghosteryOrganizationName": "Sovrn Holdings Inc"
		},
		{
			"domains": "eb.proper.io",
			"ghosteryId": "5216",
			"ghosteryOrganizationName": "Proper Media"
		},
		{
			"domains": "vid.springserve.com",
			"ghosteryId": "2581",
			"ghosteryOrganizationName": "SpringServe, LLC",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "my.outbrain.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "paid.outbrain.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "6cb27aae3db662ea51b634352d6d1c49.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ay.delivery",
			"disconnectMeName": "AssertiveYield",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ad.smaato.net",
			"ghosteryId": "920",
			"ghosteryOrganizationName": "Verve Group"
		},
		{
			"domains": "prebid.ad.smaato.net",
			"ghosteryId": "920",
			"ghosteryOrganizationName": "Verve Group"
		},
		{
			"domains": "ssp.disqus.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "rocketcentral.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "data.adobedc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "dictionary.data.adobedc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "c.gumgum.com",
			"ghosteryId": "84",
			"ghosteryOrganizationName": "GumGum",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "js.gumgum.com",
			"ghosteryId": "84",
			"ghosteryOrganizationName": "GumGum"
		},
		{
			"domains": "rtb.gumgum.com",
			"ghosteryId": "84",
			"ghosteryOrganizationName": "GumGum"
		},
		{
			"domains": "va-g2.gumgum.com",
			"ghosteryId": "84",
			"ghosteryOrganizationName": "GumGum"
		},
		{
			"domains": "wo.gumgum.com",
			"ghosteryId": "84",
			"ghosteryOrganizationName": "GumGum"
		},
		{
			"domains": "update.wo.gumgum.com",
			"ghosteryId": "84",
			"ghosteryOrganizationName": "GumGum"
		},
		{
			"domains": "s.update.wo.gumgum.com",
			"ghosteryId": "84",
			"ghosteryOrganizationName": "GumGum"
		},
		{
			"domains": "ad-events.flashtalking.com",
			"ghosteryId": "442",
			"ghosteryOrganizationName": "Flashtalking"
		},
		{
			"domains": "stat.flashtalking.com",
			"ghosteryId": "442",
			"ghosteryOrganizationName": "Flashtalking",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ask-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "anyclip-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "ssbsync-global.smartadserver.com",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver"
		},
		{
			"domains": "publishers.tremorhub.com",
			"ghosteryId": "564",
			"ghosteryOrganizationName": "Tremor Video"
		},
		{
			"domains": "pbs.publishers.tremorhub.com",
			"ghosteryId": "564",
			"ghosteryOrganizationName": "Tremor Video"
		},
		{
			"domains": "cm.adform.net",
			"ghosteryId": "457",
			"ghosteryOrganizationName": "Adform"
		},
		{
			"domains": "lax1-ib.adnxs.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "dictionarycomllc.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "22e3374687e1e456a0fd7a1c56668575.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "r3---sn-ab5l6nrk.c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "stx-match.dotomi.com",
			"ghosteryId": "280",
			"ghosteryOrganizationName": "Conversant"
		},
		{
			"domains": "ssl.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "global.ssl.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "thepointsguy.global.ssl.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "cdn.cohesionapps.com",
			"ghosteryId": "5118",
			"ghosteryOrganizationName": "Red Ventures",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "freetls.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "thepointsguy.freetls.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn1yezw3uq6lqu1lc-redventures.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "cdn.permutive.com",
			"ghosteryId": "5148",
			"ghosteryOrganizationName": "Permutive, Inc."
		},
		{
			"domains": "launcher.spot.im",
			"ghosteryId": "3625",
			"ghosteryOrganizationName": "Spot.IM Ltd."
		},
		{
			"domains": "direct-events-collector.spot.im",
			"ghosteryId": "3625",
			"ghosteryOrganizationName": "Spot.IM Ltd."
		},
		{
			"domains": "static-cdn.spot.im",
			"ghosteryId": "3625",
			"ghosteryOrganizationName": "Spot.IM Ltd."
		},
		{
			"domains": "publisher-assets.spot.im",
			"ghosteryId": "3625",
			"ghosteryOrganizationName": "Spot.IM Ltd."
		},
		{
			"domains": "ay.delivery",
			"disconnectMeName": "AssertiveYield",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "trackonomics.net",
			"disconnectMeName": "Impact",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "s.skimresources.com",
			"ghosteryId": "587",
			"ghosteryOrganizationName": "SkimLinks"
		},
		{
			"domains": "api-2-0.spot.im",
			"ghosteryId": "3625",
			"ghosteryOrganizationName": "Spot.IM Ltd."
		},
		{
			"domains": "t.skimresources.com",
			"ghosteryId": "587",
			"ghosteryOrganizationName": "SkimLinks"
		},
		{
			"domains": "p.skimresources.com",
			"ghosteryId": "587",
			"ghosteryOrganizationName": "SkimLinks"
		},
		{
			"domains": "r.skimresources.com",
			"ghosteryId": "587",
			"ghosteryOrganizationName": "SkimLinks"
		},
		{
			"domains": "ampcid.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "89782c56c7b4bffaa5d69a297282bb74.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "pix.spot.im",
			"ghosteryId": "3625",
			"ghosteryOrganizationName": "Spot.IM Ltd."
		},
		{
			"domains": "cdn.opecloud.com",
			"ghosteryId": "4582",
			"ghosteryOrganizationName": "1plusX AG"
		},
		{
			"domains": "dmp.3lift.com",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc."
		},
		{
			"domains": "dcapi.dmp.3lift.com",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc."
		},
		{
			"domains": "pdmp.dcapi.dmp.3lift.com",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc."
		},
		{
			"domains": "dmp.3lift.com",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc."
		},
		{
			"domains": "us-east-1.dmp.3lift.com",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc."
		},
		{
			"domains": "papi-public.us-east-1.dmp.3lift.com",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc."
		},
		{
			"domains": "pdmp.papi-public.us-east-1.dmp.3lift.com",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc."
		},
		{
			"domains": "assets.guim.co.uk",
			"ghosteryId": "5402",
			"ghosteryOrganizationName": "The Guardian"
		},
		{
			"domains": "i.guim.co.uk",
			"ghosteryId": "5402",
			"ghosteryOrganizationName": "The Guardian"
		},
		{
			"domains": "interactive.guim.co.uk",
			"ghosteryId": "5402",
			"ghosteryOrganizationName": "The Guardian"
		},
		{
			"domains": "uploads.guim.co.uk",
			"ghosteryId": "5402",
			"ghosteryOrganizationName": "The Guardian"
		},
		{
			"domains": "www3.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "nextgen.guardianapps.co.uk",
			"ghosteryId": "5402",
			"ghosteryOrganizationName": "The Guardian"
		},
		{
			"domains": "api.nextgen.guardianapps.co.uk",
			"ghosteryId": "5402",
			"ghosteryOrganizationName": "The Guardian"
		},
		{
			"domains": "marketingplatform.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "62effc0d28f2b1e21a32f66cf3cfc7e1.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "enigmaticcanyon.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "6178e793ae58b49064ca32fd7bfff10f.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a27160410180.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "sessions.bugsnag.com",
			"ghosteryId": "3347",
			"ghosteryOrganizationName": "SmartBear"
		},
		{
			"domains": "retail.googleapis.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ae61dc44dfe56dcc8f69dace63e3a522.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "target.scene7.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "digital-cloud.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2024-05-23T13:41:22.000Z"
		},
		{
			"domains": "resources.digital-cloud.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "af5f2e18f1d0f108660f4ade529bf1c0.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "player.vimeo.com",
			"ghosteryId": "1552",
			"ghosteryOrganizationName": "Vimeo"
		},
		{
			"domains": "pi.pardot.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "789-ejh-884.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "lab.amplitude.com",
			"ghosteryId": "3070",
			"ghosteryOrganizationName": "Amplitude"
		},
		{
			"domains": "flag.lab.amplitude.com",
			"ghosteryId": "3070",
			"ghosteryOrganizationName": "Amplitude"
		},
		{
			"domains": "lab.amplitude.com",
			"ghosteryId": "3070",
			"ghosteryOrganizationName": "Amplitude"
		},
		{
			"domains": "api.lab.amplitude.com",
			"ghosteryId": "3070",
			"ghosteryOrganizationName": "Amplitude"
		},
		{
			"domains": "t-mobile.scene7.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fs.liveperson.com",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "tmo-assets.fs.liveperson.com",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn3edajdvgwonv9nr-tmobilecx.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "4367576.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.onesignal.com",
			"ghosteryId": "4304",
			"ghosteryOrganizationName": "OneSignal",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "aps.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "c.aps.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "cdn.jwplayer.com",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player"
		},
		{
			"domains": "gpsb-reims.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "prebid.sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "d9.flashtalking.com",
			"ghosteryId": "442",
			"ghosteryOrganizationName": "Flashtalking"
		},
		{
			"domains": "tk.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "c1.adform.net",
			"ghosteryId": "457",
			"ghosteryOrganizationName": "Adform"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "62718610aceb0a697a20b4d45808c079.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "secure-gl.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "pandg.tapad.com",
			"ghosteryId": "937",
			"ghosteryOrganizationName": "Telenor Group"
		},
		{
			"domains": "ybp.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nrb.ybp.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "edgecast-vod.yimg.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "www.quantummetric.com",
			"ghosteryId": "4748",
			"ghosteryOrganizationName": "Quantum Metric, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "developers.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "subway.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "subway2016.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "d2.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "subwayfranchiseeadvertising.d2.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "www.paypal.com",
			"ghosteryId": "248",
			"ghosteryOrganizationName": "eBay",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdn-loyalty.yotpo.com",
			"ghosteryId": "2657",
			"ghosteryOrganizationName": "Yotpo"
		},
		{
			"domains": "www.paypalobjects.com",
			"ghosteryId": "248",
			"ghosteryOrganizationName": "eBay"
		},
		{
			"domains": "t.paypal.com",
			"ghosteryId": "248",
			"ghosteryOrganizationName": "eBay"
		},
		{
			"domains": "cdn-swell-assets.yotpo.com",
			"ghosteryId": "2657",
			"ghosteryOrganizationName": "Yotpo"
		},
		{
			"domains": "staticw2.yotpo.com",
			"ghosteryId": "2657",
			"ghosteryOrganizationName": "Yotpo"
		},
		{
			"domains": "us.creativecdn.com",
			"ghosteryId": "3371",
			"ghosteryOrganizationName": "RTB House"
		},
		{
			"domains": "p.yotpo.com",
			"ghosteryId": "2657",
			"ghosteryOrganizationName": "Yotpo"
		},
		{
			"domains": "maxcdn.bootstrapcdn.com",
			"ghosteryId": "5320",
			"ghosteryOrganizationName": "BootstrapCDN"
		},
		{
			"domains": "rd.linksynergy.com",
			"ghosteryId": "3334",
			"ghosteryOrganizationName": "Rakuten Marketing LLC"
		},
		{
			"domains": "ut.rd.linksynergy.com",
			"ghosteryId": "3334",
			"ghosteryOrganizationName": "Rakuten Marketing LLC"
		},
		{
			"domains": "d3hb14vkzrxvla.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8246315.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "6e4118fe2c8686e9bc34c778edf31709.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn4tqdz21wlnz4zv8-stockxcustomerres.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-40161.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o438986.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "14636937.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "execute-api.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "tnd389f0za.execute-api.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o221737.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "sparkloop.app",
			"disconnectMeName": "SparkLoop",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "api.amplitude.com",
			"ghosteryId": "3070",
			"ghosteryOrganizationName": "Amplitude",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "sparkloop.app",
			"disconnectMeName": "SparkLoop",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "sparkloop.app",
			"disconnectMeName": "SparkLoop",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "d3e54v103j8qbb.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "steamuserimages-a.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "img.youtube.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn-pci.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "tapi.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "cdn-pci.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "a8367280580.cdn-pci.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "cdn3.userzoom.com",
			"ghosteryId": "1692",
			"ghosteryOrganizationName": "UserZoom"
		},
		{
			"domains": "statefarmmutualautomobileinsurancecompany.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a6558036.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a23755770403.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "cdn.mouseflow.com",
			"ghosteryId": "418",
			"ghosteryOrganizationName": "Mouseflow"
		},
		{
			"domains": "cdn.segment.com",
			"ghosteryId": "1440",
			"ghosteryOrganizationName": "Segment"
		},
		{
			"domains": "attribution.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "adresults-42-adswizz.attribution.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "pixel.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13717202.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fg8vvsvnieiv3ej16jby.litix.io",
			"ghosteryId": "4482",
			"ghosteryOrganizationName": "Mux"
		},
		{
			"domains": "widget.intercom.io",
			"ghosteryId": "1161",
			"ghosteryOrganizationName": "Intercom"
		},
		{
			"domains": "js.intercomcdn.com",
			"ghosteryId": "1161",
			"ghosteryOrganizationName": "Intercom"
		},
		{
			"domains": "nexus-websocket-a.intercom.io",
			"ghosteryId": "1161",
			"ghosteryOrganizationName": "Intercom"
		},
		{
			"domains": "my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "stackoverflow-privacy.my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "www.gravatar.com",
			"ghosteryId": "245",
			"ghosteryOrganizationName": "Automattic"
		},
		{
			"domains": "lh3.googleusercontent.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "encore.scdn.co",
			"ghosteryId": "1816",
			"ghosteryOrganizationName": "Spotify"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o22381.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "www.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "i.scdn.co",
			"ghosteryId": "1816",
			"ghosteryOrganizationName": "Spotify",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "charts-images.scdn.co",
			"ghosteryId": "1816",
			"ghosteryOrganizationName": "Spotify"
		},
		{
			"domains": "spotify.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "spirit.scene7.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cdn.listrakbi.com",
			"ghosteryId": "1115",
			"ghosteryOrganizationName": "Listrak",
			"whenAddedToGhostery": "2024-01-23T11:41:01.000Z"
		},
		{
			"domains": "geoip-js.com",
			"disconnectMeName": "MaxMind",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "spencers.scene7.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cdn.ywxi.net",
			"ghosteryId": "1141",
			"ghosteryOrganizationName": "McAfee",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mr1.listrakbi.com",
			"ghosteryId": "1115",
			"ghosteryOrganizationName": "Listrak"
		},
		{
			"domains": "s1.listrakbi.com",
			"ghosteryId": "1115",
			"ghosteryOrganizationName": "Listrak"
		},
		{
			"domains": "d.monetate.net",
			"ghosteryId": "601",
			"ghosteryOrganizationName": "Monetate"
		},
		{
			"domains": "onescript-recscont.listrakbi.com",
			"ghosteryId": "1115",
			"ghosteryOrganizationName": "Listrak"
		},
		{
			"domains": "bl.listrakbi.com",
			"ghosteryId": "1115",
			"ghosteryOrganizationName": "Listrak"
		},
		{
			"domains": "at1.listrakbi.com",
			"ghosteryId": "1115",
			"ghosteryOrganizationName": "Listrak"
		},
		{
			"domains": "spencergifts.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "112.2o7.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "spencergifts.112.2o7.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "6023609.global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "173bf109.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "m1.listrakbi.com",
			"ghosteryId": "1115",
			"ghosteryOrganizationName": "Listrak"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "spiritairlines.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "dnlq9p2b.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "c1.rfihub.net",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "cdn.boomtrain.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "00000000.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "20861349p.rfihub.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "static.sojern.com",
			"ghosteryId": "782",
			"ghosteryOrganizationName": "Sojern, Inc."
		},
		{
			"domains": "events.api.boomtrain.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pixel.sojern.com",
			"ghosteryId": "782",
			"ghosteryOrganizationName": "Sojern, Inc."
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zncsz42qbnm39fnmf-spiritairlines.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "www.clicktripz.com",
			"ghosteryId": "3110",
			"ghosteryOrganizationName": "ClickTripz",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "bf04820crc.bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "a.rfihub.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "cdn.ziffstatic.com",
			"ghosteryId": "660",
			"ghosteryOrganizationName": "Ziff Davis LLC"
		},
		{
			"domains": "static.zdbb.net",
			"ghosteryId": "660",
			"ghosteryOrganizationName": "Ziff Davis LLC"
		},
		{
			"domains": "cdn.static.zdbb.net",
			"ghosteryId": "660",
			"ghosteryOrganizationName": "Ziff Davis LLC"
		},
		{
			"domains": "gurgle.zdbb.net",
			"ghosteryId": "660",
			"ghosteryOrganizationName": "Ziff Davis LLC"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "7290338b9c856f7b0483bffdbb1640a4.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "jogger.zdbb.net",
			"ghosteryId": "660",
			"ghosteryOrganizationName": "Ziff Davis LLC"
		},
		{
			"domains": "cdn.ampproject.org",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "encrypted-tbn3.gstatic.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "encrypted-tbn1.gstatic.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ookla-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "collector-8649.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collect.tealiumiq.com",
			"ghosteryId": "662",
			"ghosteryOrganizationName": "Tealium"
		},
		{
			"domains": "ssl.google-analytics.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "charter.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "d2.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "charter.d2.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "d15yx0mnc9teae.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "seal.digicert.com",
			"ghosteryId": "1526",
			"ghosteryOrganizationName": "Digicert",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "112.2o7.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "charterglobal.112.2o7.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "20829225p.rfihub.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "tracker.samplicio.us",
			"ghosteryId": "4426",
			"ghosteryOrganizationName": "Luc.id",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8159396.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "3679293.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10193002.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "p.cpx.to",
			"ghosteryId": "1976",
			"ghosteryOrganizationName": "Captify"
		},
		{
			"domains": "vi.ml314.com",
			"ghosteryId": "933",
			"ghosteryOrganizationName": "Bombora"
		},
		{
			"domains": "in.ml314.com",
			"ghosteryId": "933",
			"ghosteryOrganizationName": "Bombora"
		},
		{
			"domains": "s.cpx.to",
			"ghosteryId": "1976",
			"ghosteryOrganizationName": "Captify"
		},
		{
			"domains": "ads.servebom.com",
			"ghosteryId": "2052",
			"ghosteryOrganizationName": "Purch Group, Inc."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ee3678383bf9c2b4c3628b506c98754c.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "rtd-tm.everesttech.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "10363.global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn6fetw4rxykndjoz-southwest.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "style.sndcdn.com",
			"ghosteryId": "1817",
			"ghosteryOrganizationName": "SoundCloud"
		},
		{
			"domains": "a-v2.sndcdn.com",
			"ghosteryId": "1817",
			"ghosteryOrganizationName": "SoundCloud"
		},
		{
			"domains": "secure-assets.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "secure.sndcdn.com",
			"ghosteryId": "1817",
			"ghosteryOrganizationName": "SoundCloud"
		},
		{
			"domains": "i1.sndcdn.com",
			"ghosteryId": "1817",
			"ghosteryOrganizationName": "SoundCloud"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "66f1b8fdc9e38f637784a8896a634ce8.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "5352434.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "wa.appsflyer.com",
			"ghosteryId": "4300",
			"ghosteryOrganizationName": "AppsFlyer"
		},
		{
			"domains": "my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "soundcloud-privacy.my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "images.ctfassets.net",
			"ghosteryId": "5325",
			"ghosteryOrganizationName": "Contentful GmbH"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a25785590076.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "pmrg3twp.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "11491102.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "translate.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdn.consentmanager.net",
			"ghosteryId": "1813",
			"ghosteryOrganizationName": "iubenda"
		},
		{
			"domains": "translate.googleapis.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "delivery.consentmanager.net",
			"ghosteryId": "1813",
			"ghosteryOrganizationName": "iubenda"
		},
		{
			"domains": "664-nic-529.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "delivery.consentmanager.net",
			"ghosteryId": "1813",
			"ghosteryOrganizationName": "iubenda"
		},
		{
			"domains": "a.delivery.consentmanager.net",
			"ghosteryId": "1813",
			"ghosteryOrganizationName": "iubenda"
		},
		{
			"domains": "dr5dymrsxhdzh.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d31s10tn3clc14.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a19181790056.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "cdn.mxpnl.com",
			"ghosteryId": "227",
			"ghosteryOrganizationName": "Mixpanel"
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "execute-api.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "zg4rltrs90.execute-api.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "a.mgid.com",
			"ghosteryId": "577",
			"ghosteryOrganizationName": "MGID Inc."
		},
		{
			"domains": "js-tag.zemanta.com",
			"ghosteryId": "189",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-26273.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "p1.zemanta.com",
			"ghosteryId": "189",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "1adec6153884b7b971fe5881bde66f8a.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "api-js.mixpanel.com",
			"ghosteryId": "227",
			"ghosteryOrganizationName": "Mixpanel"
		},
		{
			"domains": "slickdeals.btttag.com",
			"ghosteryId": "3355",
			"ghosteryOrganizationName": "Blue Triangle"
		},
		{
			"domains": "ats.rlcdn.com",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp"
		},
		{
			"domains": "maggieeatstheangel.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ab1aebabf563d554af134eee2b5c419f.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "maggieeatstheangel.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "analytics.rlcdn.com",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp"
		},
		{
			"domains": "check.analytics.rlcdn.com",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp"
		},
		{
			"domains": "slickdeals-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zneldohfsiwgrhfvq-slickdeals.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "s3-us-west-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "us-west-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "execute-api.us-west-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "ckjjzdn8vk.execute-api.us-west-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "reveal.clearbit.com",
			"ghosteryId": "5324",
			"ghosteryOrganizationName": "Clearbit"
		},
		{
			"domains": "d34u8crftukxnk.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "api.demandbase.com",
			"ghosteryId": "53",
			"ghosteryOrganizationName": "Demandbase",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a11179690159.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "www.xing.com",
			"ghosteryId": "2787",
			"ghosteryOrganizationName": "XING",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6321597.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "12632256.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.cquotient.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "p.cquotient.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "100007688.collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "nova.collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9630990.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "1c9a5b7dc470a6283abfede9c63fc965.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "beacon.tru.am",
			"ghosteryId": "3030",
			"ghosteryOrganizationName": "trueAnthem"
		},
		{
			"domains": "meredith-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "sdk.privacy-center.org",
			"ghosteryId": "5327",
			"ghosteryOrganizationName": "Didomi"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "0e62bbad697b8f2a8e1d417fb1441253.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "minutemedia-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "cms.quantserve.com",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited"
		},
		{
			"domains": "fei.pro-market.net",
			"ghosteryId": "12",
			"ghosteryOrganizationName": "AlmondNet"
		},
		{
			"domains": "b1sync.zemanta.com",
			"ghosteryId": "189",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "p.rfihub.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "stags.bluekai.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdn.shopify.com",
			"ghosteryId": "2179",
			"ghosteryOrganizationName": "Shopify",
			"whenAddedToGhostery": "2024-07-26T15:54:45.000Z"
		},
		{
			"domains": "pay.shopify.com",
			"ghosteryId": "2179",
			"ghosteryOrganizationName": "Shopify"
		},
		{
			"domains": "attribution.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "adresults-43-adswizz.attribution.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13695120.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "eps.6sc.co",
			"ghosteryId": "2536",
			"ghosteryOrganizationName": "6Sense"
		},
		{
			"domains": "ltwebstatic.com",
			"disconnectMeName": "Shein",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ltwebstatic.com",
			"disconnectMeName": "Shein",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ltwebstatic.com",
			"disconnectMeName": "Shein",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cdn-apac.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "recommender.scarabresearch.com",
			"ghosteryId": "5182",
			"ghosteryOrganizationName": "Emarsys",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ltwebstatic.com",
			"disconnectMeName": "Shein",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ltwebstatic.com",
			"disconnectMeName": "Shein",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "publisher.liveperson.net",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "519-ynm-008.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "cdn.getsmartcontent.com",
			"ghosteryId": "2133",
			"ghosteryOrganizationName": "Get Smart Content"
		},
		{
			"domains": "s.getsmartcontent.com",
			"ghosteryId": "2133",
			"ghosteryOrganizationName": "Get Smart Content"
		},
		{
			"domains": "cmp.quantcast.com",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "1d2fbaf22730245aa0f854ec8b5dd7cd.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "sephora.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sephora.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "e309da9b9aaf.cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "0f3c9eaea768471fbb4c696709824a5e-e309da9b9aaf.cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "api.bluecore.com",
			"ghosteryId": "3058",
			"ghosteryOrganizationName": "TriggerMail"
		},
		{
			"domains": "sephora-track.inside-graph.com",
			"ghosteryId": "3042",
			"ghosteryOrganizationName": "PowerFront"
		},
		{
			"domains": "onsitestats.bluecore.com",
			"ghosteryId": "3058",
			"ghosteryOrganizationName": "TriggerMail"
		},
		{
			"domains": "siteassets.bluecore.com",
			"ghosteryId": "3058",
			"ghosteryOrganizationName": "TriggerMail"
		},
		{
			"domains": "df45ay5pw60dy.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "sephora-live.inside-graph.com",
			"ghosteryId": "3042",
			"ghosteryOrganizationName": "PowerFront"
		},
		{
			"domains": "digital-cloud.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2024-05-23T13:41:22.000Z"
		},
		{
			"domains": "analytics-fe.digital-cloud.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "assistjs.skimresources.com",
			"ghosteryId": "587",
			"ghosteryOrganizationName": "SkimLinks"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "139af62963ba9ac6c4fd9b4d5703a82c.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "sephora-cdn.inside-graph.com",
			"ghosteryId": "3042",
			"ghosteryOrganizationName": "PowerFront"
		},
		{
			"domains": "bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "bf15698iev.bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "5878462.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "media-akam.licdn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "analytics.pangle-ads.com",
			"ghosteryId": "5432",
			"ghosteryOrganizationName": "ByteDance Inc",
			"whenAddedToGhostery": "2024-03-22T13:47:05.000Z"
		},
		{
			"domains": "www.cloudflare.com",
			"ghosteryId": "2913",
			"ghosteryOrganizationName": "Cloudflare",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "awswaf.com",
			"disconnectMeName": "Amazon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "awswaf.com",
			"disconnectMeName": "Amazon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "dn6rwwtxa647p.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "574b65e4f3933a07b41fbef06b1c570d.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "clipcentric-a.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "forms.aweber.com",
			"ghosteryId": "1305",
			"ghosteryOrganizationName": "AWeber Communications"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "9fb2f5cfb1cd9b3f82ac4a21d8e5de59.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "r1---sn-ab5l6nrs.c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a14738960062.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "px.airpr.com",
			"ghosteryId": "5235",
			"ghosteryOrganizationName": "AirPR",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "schwab.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "2530996.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "dpx.airpr.com",
			"ghosteryId": "5235",
			"ghosteryOrganizationName": "AirPR"
		},
		{
			"domains": "68794912.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "stackpath.bootstrapcdn.com",
			"ghosteryId": "5320",
			"ghosteryOrganizationName": "BootstrapCDN"
		},
		{
			"domains": "app-ab11.marketo.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "dx.steelhousemedia.com",
			"ghosteryId": "751",
			"ghosteryOrganizationName": "Steel House, Inc."
		},
		{
			"domains": "a.optmstr.com",
			"ghosteryId": "5129",
			"ghosteryOrganizationName": "OptinMonster",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "193-bcc-509.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "861-rmi-846.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "px.steelhousemedia.com",
			"ghosteryId": "751",
			"ghosteryOrganizationName": "Steel House, Inc.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nexus.ensighten.com",
			"ghosteryId": "728",
			"ghosteryOrganizationName": "Ensighten",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hello.myfonts.net",
			"ghosteryId": "2683",
			"ghosteryOrganizationName": "MyFonts",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "privacy.ensighten.com",
			"ghosteryId": "728",
			"ghosteryOrganizationName": "Ensighten",
			"whenAddedToGhostery": "2024-03-22T13:47:05.000Z"
		},
		{
			"domains": "data.privacy.ensighten.com",
			"ghosteryId": "728",
			"ghosteryOrganizationName": "Ensighten",
			"whenAddedToGhostery": "2024-03-22T13:47:05.000Z"
		},
		{
			"domains": "cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fc30fd70b1b7.cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "challenges.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "12175fdb7dad404583c240054f19551a-fc30fd70b1b7.cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "api.useinsider.com",
			"ghosteryId": "4816",
			"ghosteryOrganizationName": "Insider",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "samsungusa.api.useinsider.com",
			"ghosteryId": "4816",
			"ghosteryOrganizationName": "Insider"
		},
		{
			"domains": "halc.iadvize.com",
			"ghosteryId": "2128",
			"ghosteryOrganizationName": "iAdvize"
		},
		{
			"domains": "cdn.decibelinsight.net",
			"ghosteryId": "3679",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "173bf10c.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "api.useinsider.com",
			"ghosteryId": "4816",
			"ghosteryOrganizationName": "Insider",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hit.api.useinsider.com",
			"ghosteryId": "4816",
			"ghosteryOrganizationName": "Insider"
		},
		{
			"domains": "static.iadvize.com",
			"ghosteryId": "2128",
			"ghosteryOrganizationName": "iAdvize"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "1782317.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "api.iadvize.com",
			"ghosteryId": "2128",
			"ghosteryOrganizationName": "iAdvize"
		},
		{
			"domains": "cdnapisec.kaltura.com",
			"ghosteryId": "1480",
			"ghosteryOrganizationName": "Kaltura"
		},
		{
			"domains": "cfvod.kaltura.com",
			"ghosteryId": "1480",
			"ghosteryOrganizationName": "Kaltura"
		},
		{
			"domains": "collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "7247925.collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10620053.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us-4.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "sallyholdings.us-4.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "20849636p.rfihub.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "f.monetate.net",
			"ghosteryId": "601",
			"ghosteryOrganizationName": "Monetate"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a10681260716.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "us-1.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "salesforce.us-1.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "14611606.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "11463663.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-119_ts-1733859552-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "jf7gf3qxfa6dez2ytdqa-pthkpn-362a8b3b7-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "ads.blogherads.com",
			"ghosteryId": "29",
			"ghosteryOrganizationName": "Penske Media Corporation",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "us-west-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "s3.us-west-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "pmc-pp-tou.s3.us-west-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "nimbleplot.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cdn.tinypass.com",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano"
		},
		{
			"domains": "c2.piano.io",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano"
		},
		{
			"domains": "buy.tinypass.com",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano"
		},
		{
			"domains": "in.treasuredata.com",
			"ghosteryId": "4464",
			"ghosteryOrganizationName": "arm",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "content.jwplatform.com",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fouanalytics.com",
			"disconnectMeName": "FouAnalytics",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "creative-p.undertone.com",
			"ghosteryId": "269",
			"ghosteryOrganizationName": "Perion"
		},
		{
			"domains": "b2c.com",
			"disconnectMeName": "Marketing Science",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "image6.pubmatic.com",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc."
		},
		{
			"domains": "aud.pubmatic.com",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "b047982247f56fb79163c4066b648a44.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "3d378ba81b1176c40ba731316b62c281.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "penske-tagan.adlightning.com",
			"ghosteryId": "5304",
			"ghosteryOrganizationName": "Ad Lightning"
		},
		{
			"domains": "js.adscale.de",
			"ghosteryId": "342",
			"ghosteryOrganizationName": "Ströer SSP GmbH"
		},
		{
			"domains": "gnuv1mhb.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "r2.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "global.r2.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "6292617.global.r2.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "68794905.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "t.eloqua.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "s1062412714.t.eloqua.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "bf84553kkn.bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "us.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "ingest.us.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o51008.ingest.us.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "app.clearbit.com",
			"ghosteryId": "5324",
			"ghosteryOrganizationName": "Clearbit"
		},
		{
			"domains": "us-west-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "execute-api.us-west-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "9xgnrndqve.execute-api.us-west-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10844217.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "mab.chartbeat.com",
			"ghosteryId": "313",
			"ghosteryOrganizationName": "ChartBeat"
		},
		{
			"domains": "t.eloqua.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "s2124157686.t.eloqua.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "pa.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "6f2ac6f7d0a642d202b6c114547bec13.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "api.segment.io",
			"ghosteryId": "1440",
			"ghosteryOrganizationName": "Segment"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn8qfk42azo5fsr2r-trdigital.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "awswaf.com",
			"disconnectMeName": "Amazon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "awswaf.com",
			"disconnectMeName": "Amazon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9772552.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8365807.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "external-preview.redd.it",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "styles.redditmedia.com",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "preview.redd.it",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "thumbs.redditmedia.com",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "b.thumbs.redditmedia.com",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "v.redd.it",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "packaged-media.redd.it",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "emoji.redditmedia.com",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "i.redd.it",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "api.parsely.com",
			"ghosteryId": "1009",
			"ghosteryOrganizationName": "Parse.ly"
		},
		{
			"domains": "isstarsbuilding.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "moveinc.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "www.everestjs.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "isstarsbuilding.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "s.tribalfusion.com",
			"ghosteryId": "64",
			"ghosteryOrganizationName": "Exponential Interactive, Inc"
		},
		{
			"domains": "lasteventf-tm.everesttech.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10291144.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ads.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "d2a2l5qrvi6kxt.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "ow.pubmatic.com",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "2da8ebb78000fe9c813023be392b5cf8.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "t.pubmatic.com",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc."
		},
		{
			"domains": "ssum.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn8p1dph4rgqzwv0x-move.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9327458.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "eps.6sc.co",
			"ghosteryId": "2536",
			"ghosteryOrganizationName": "6Sense"
		},
		{
			"domains": "v.eps.6sc.co",
			"ghosteryId": "2536",
			"ghosteryOrganizationName": "6Sense"
		},
		{
			"domains": "players.brightcove.net",
			"ghosteryId": "683",
			"ghosteryOrganizationName": "Brightcove",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pl.connatix.com",
			"ghosteryId": "3942",
			"ghosteryOrganizationName": "Connatix Native Exchange Inc."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "7450a75e8edc592834bd6ee55e644154.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "k.streamrail.com",
			"ghosteryId": "5016",
			"ghosteryOrganizationName": "ironSource",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tags.bkrtx.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "r2---sn-ab5l6nkd.c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "hashtaglabs-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "ssbsync.smartadserver.com",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver"
		},
		{
			"domains": "qvc.scene7.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "qvc3274061z.btttag.com",
			"ghosteryId": "3355",
			"ghosteryOrganizationName": "Blue Triangle"
		},
		{
			"domains": "qvc.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cdn.granify.com",
			"ghosteryId": "2980",
			"ghosteryOrganizationName": "Granify"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn0rpgfxyeoiso7vb-qvc.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "matching.granify.com",
			"ghosteryId": "2980",
			"ghosteryOrganizationName": "Granify"
		},
		{
			"domains": "d.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "d.btttag.com",
			"ghosteryId": "3355",
			"ghosteryOrganizationName": "Blue Triangle"
		},
		{
			"domains": "lh5.googleusercontent.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "s7d6.scene7.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "542-fmf-412.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "publix.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a17831451227.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "3589473.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "gateway.foresee.com",
			"ghosteryId": "330",
			"ghosteryOrganizationName": "ForeSee Results",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c47f5d7c8f594c6be8272698ff32e4dd.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "engine.monetate.net",
			"ghosteryId": "601",
			"ghosteryOrganizationName": "Monetate"
		},
		{
			"domains": "embed-cloudfront.wistia.com",
			"ghosteryId": "1307",
			"ghosteryOrganizationName": "Wistia"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "55a8ed7708c460957ce8e2d106180965.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "freestar-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "ghent-gce-sc.bidswitch.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "us-east-sync.bidswitch.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "grid.bidswitch.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "media.grid.bidswitch.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "grid-mercury.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "vjs.zencdn.net",
			"ghosteryId": "4475",
			"ghosteryOrganizationName": "Zencoder",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "d2gjrq7hs8he14.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d21y75miwcfqoq.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d2zlsagv0ouax1.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "di2ponv0v5otw.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "dtpmhvbsmffsz.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "sprysummit.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "concertads-configs.vox-cdn.com",
			"ghosteryId": "3999",
			"ghosteryOrganizationName": "Vox Media"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "5861a4cb4a8cfbffdcb3aeefb521d655.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ads.betweendigital.com",
			"ghosteryId": "2492",
			"ghosteryOrganizationName": "Between Digital"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "pncnationalbank.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn6al8zeqdbpslbqu-pncvoiceofcustomer.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "5263622.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "jf7gf3qxfa6bgz2yqaiq-p9dk5u-00f21f821-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-119_ts-1733853201-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "fast.fonts.net",
			"ghosteryId": "3427",
			"ghosteryOrganizationName": "Monotype Imaging"
		},
		{
			"domains": "s.btstatic.com",
			"ghosteryId": "761",
			"ghosteryOrganizationName": "Signal Digital Inc."
		},
		{
			"domains": "us-5.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "sonyinteractiveent.us-5.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10049583.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "blob.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "appds8093.blob.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "bam-cell.nr-data.net",
			"ghosteryId": "942",
			"ghosteryOrganizationName": "New Relic"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-29008.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "3405025.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10452233.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a19558781057.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "d5gisl1qw7mgp.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "cdn-4.convertexperiments.com",
			"ghosteryId": "5041",
			"ghosteryOrganizationName": "Convert"
		},
		{
			"domains": "logs.convertexperiments.com",
			"ghosteryId": "5041",
			"ghosteryOrganizationName": "Convert"
		},
		{
			"domains": "api-iam.intercom.io",
			"ghosteryId": "1161",
			"ghosteryOrganizationName": "Intercom"
		},
		{
			"domains": "downloads.intercomcdn.com",
			"ghosteryId": "1161",
			"ghosteryOrganizationName": "Intercom"
		},
		{
			"domains": "www.recaptcha.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "i.pinimg.com",
			"ghosteryId": "1306",
			"ghosteryOrganizationName": "Pinterest"
		},
		{
			"domains": "ijlyvlkq.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "508-ahm-437.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "867-gml-252.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "753-lzd-147.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "ba.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "c.ba.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "1511d7de4e8076799ecb607bfa1bf3fc.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "mtrcs.samba.tv",
			"ghosteryId": "5388",
			"ghosteryOrganizationName": "Samba TV"
		},
		{
			"domains": "pixel.mtrcs.samba.tv",
			"ghosteryId": "5388",
			"ghosteryOrganizationName": "Samba TV"
		},
		{
			"domains": "analytics.rlcdn.com",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp"
		},
		{
			"domains": "pearson.blueconic.net",
			"ghosteryId": "3860",
			"ghosteryOrganizationName": "BlueConic"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "11052299.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "173bf10f.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a18026570151.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "nbcuss.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "us-gmtdmp.mookie1.com",
			"ghosteryId": "4758",
			"ghosteryOrganizationName": "Xaxis"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "nbcstreaming.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9899657.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9374122.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "track.securedvisit.com",
			"ghosteryId": "2234",
			"ghosteryOrganizationName": "SecuredVisit"
		},
		{
			"domains": "nbcu.track.securedvisit.com",
			"ghosteryId": "2234",
			"ghosteryOrganizationName": "SecuredVisit"
		},
		{
			"domains": "assets-jpcust.jwpsrv.com",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player"
		},
		{
			"domains": "p.jwpcdn.com",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ssl.p.jwpcdn.com",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "entitlements.jwplayer.com",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c6abc5ecafe76ba4d08a00a560da83fd.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "prd.jwpltx.com",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player"
		},
		{
			"domains": "videos-cloudfront-usp.jwpsrv.com",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player"
		},
		{
			"domains": "pycrstg.wpengine.com",
			"ghosteryId": "5415",
			"ghosteryOrganizationName": "WP Engine"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9675597.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "003-jww-697.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "app-ab26.marketo.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-9152.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "abrtp1-cdn.marketo.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "715-yzo-232.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "rtp-static.marketo.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "abrtp1.marketo.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "tag.simpli.fi",
			"ghosteryId": "550",
			"ghosteryOrganizationName": "Simplifi Holdings Inc."
		},
		{
			"domains": "i.simpli.fi",
			"ghosteryId": "550",
			"ghosteryOrganizationName": "Simplifi Holdings Inc."
		},
		{
			"domains": "dvow0vltefbxy.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "server.cpmstar.com",
			"ghosteryId": "647",
			"ghosteryOrganizationName": "CPMStar"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "27211ba8eb0aef3b98a15c563e5f9cbf.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "phx.creativecdn.com",
			"ghosteryId": "3371",
			"ghosteryOrganizationName": "RTB House"
		},
		{
			"domains": "api-data-connector.abtasty.com",
			"ghosteryId": "3037",
			"ghosteryOrganizationName": "AB Tasty"
		},
		{
			"domains": "widgets.abtasty.com",
			"ghosteryId": "3037",
			"ghosteryOrganizationName": "AB Tasty"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o1407395.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "beacon.krxd.net",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6901690.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d2zah9y47r7bi2.cloudfront.net",
			"ghosteryId": "3549",
			"ghosteryOrganizationName": "TrackJS",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "www.linkedin.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "www.googleapis.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ea9291030a1f.cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "97c0282c653741048073e1c310621bf4-ea9291030a1f.cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "videos.ctfassets.net",
			"ghosteryId": "5325",
			"ghosteryOrganizationName": "Contentful GmbH"
		},
		{
			"domains": "s.swiftypecdn.com",
			"ghosteryId": "5332",
			"ghosteryOrganizationName": "Elastic"
		},
		{
			"domains": "855-qah-699.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "jadserve.postrelease.com",
			"ghosteryId": "2568",
			"ghosteryOrganizationName": "Nativo"
		},
		{
			"domains": "js.driftt.com",
			"ghosteryId": "4715",
			"ghosteryOrganizationName": "Drift",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "rc-sc.js.driftt.com",
			"ghosteryId": "4715",
			"ghosteryOrganizationName": "Drift"
		},
		{
			"domains": "cdn.office.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "res.cdn.office.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "d2hrivdxn8ekm8.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "firebase.googleapis.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "action.media6degrees.com",
			"ghosteryId": "111",
			"ghosteryOrganizationName": "Dstillery"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "94e9c6bcebbee968d82655a75219f7e6.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "g1.nyt.com",
			"ghosteryId": "1962",
			"ghosteryOrganizationName": "The New York Times Company"
		},
		{
			"domains": "static01.nyt.com",
			"ghosteryId": "1962",
			"ghosteryOrganizationName": "The New York Times Company"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "9841cae36c425ad5cce2d80f7a3a46d9.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "a1.nyt.com",
			"ghosteryId": "1962",
			"ghosteryOrganizationName": "The New York Times Company",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "pnytimes.chartbeat.net",
			"ghosteryId": "313",
			"ghosteryOrganizationName": "ChartBeat"
		},
		{
			"domains": "vp.nyt.com",
			"ghosteryId": "1962",
			"ghosteryOrganizationName": "The New York Times Company"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "5290727.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "nytimes-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "segment-data.zqtk.net",
			"ghosteryId": "246",
			"ghosteryOrganizationName": "comScore, Inc."
		},
		{
			"domains": "launcher-sa.spot.im",
			"ghosteryId": "3625",
			"ghosteryOrganizationName": "Spot.IM Ltd."
		},
		{
			"domains": "curbminers.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "delivery.adrecover.com",
			"ghosteryId": "3507",
			"ghosteryOrganizationName": "AdPushUp, Inc."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "b11be65934a0d34b7871f7e1e2988d8f.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "eventlog.outbrain.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "z-na.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "images.outbrainimg.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "3834cd3df4c7.cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "ad5f2050cc664b4cb24cac71a6d6b15c-3834cd3df4c7.cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "3573732.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d3nocrch4qti4v.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "9b4f2ce964a74069bf5394486cc8052a-3834cd3df4c7.cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d92667410b3df15c67fa2061c6542bfe.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d2o5idwacg3gyw.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13888066.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ambrosialsummit.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "experience.tinypass.com",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano"
		},
		{
			"domains": "s.ntv.io",
			"ghosteryId": "2568",
			"ghosteryOrganizationName": "Nativo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "js.matheranalytics.com",
			"ghosteryId": "5233",
			"ghosteryOrganizationName": "Mather Economics"
		},
		{
			"domains": "at.teads.tv",
			"ghosteryId": "2521",
			"ghosteryOrganizationName": "Teads"
		},
		{
			"domains": "advancelocal.blueconic.net",
			"ghosteryId": "3860",
			"ghosteryOrganizationName": "BlueConic"
		},
		{
			"domains": "app.matheranalytics.com",
			"ghosteryId": "5233",
			"ghosteryOrganizationName": "Mather Economics"
		},
		{
			"domains": "i.matheranalytics.com",
			"ghosteryId": "5233",
			"ghosteryOrganizationName": "Mather Economics"
		},
		{
			"domains": "www.i.matheranalytics.com",
			"ghosteryId": "5233",
			"ghosteryOrganizationName": "Mather Economics"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "f4166f7cd5667033c24a7b4de93643f6.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ntvcld-a.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "va6-bid.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "update.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "s.update.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "us.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "ingest.us.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o4507091576815616.ingest.us.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "cdn.pricespider.com",
			"ghosteryId": "4411",
			"ghosteryOrganizationName": "Price Spider",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn5aocakgjj2uagxj-nintendoofamerica.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "dap.digitalgov.gov",
			"ghosteryId": "5409",
			"ghosteryOrganizationName": "USA Government"
		},
		{
			"domains": "api.intentiq.com",
			"ghosteryId": "12",
			"ghosteryOrganizationName": "AlmondNet"
		},
		{
			"domains": "id.crwdcntrl.net",
			"ghosteryId": "103",
			"ghosteryOrganizationName": "Lotame"
		},
		{
			"domains": "qsearch-a.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "5d8d900e1db37bb6ef7c6828dbdc6c36.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "resources.infolinks.com",
			"ghosteryId": "88",
			"ghosteryOrganizationName": "Infolinks",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "router.infolinks.com",
			"ghosteryId": "88",
			"ghosteryOrganizationName": "Infolinks"
		},
		{
			"domains": "rt3007.infolinks.com",
			"ghosteryId": "88",
			"ghosteryOrganizationName": "Infolinks"
		},
		{
			"domains": "amli.sekindo.com",
			"ghosteryId": "2061",
			"ghosteryOrganizationName": "SekiNdo"
		},
		{
			"domains": "vfw.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "r3---sn-ab5sznzs.c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "da.us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "cat.da.us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "da.us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "rtb.da.us.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "d19rpgkrjeba2z.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "www.npttech.com",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano"
		},
		{
			"domains": "tag.aticdn.net",
			"ghosteryId": "1270",
			"ghosteryOrganizationName": "AT Internet"
		},
		{
			"domains": "recommendationengine.googleapis.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "38fa9e93e31e2fa6963893a9977b137c.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "api-esp.piano.io",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano"
		},
		{
			"domains": "p.tvpixel.com",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp"
		},
		{
			"domains": "platform-api.sharethis.com",
			"ghosteryId": "149",
			"ghosteryOrganizationName": "ShareThis, Inc."
		},
		{
			"domains": "buttons-config.sharethis.com",
			"ghosteryId": "149",
			"ghosteryOrganizationName": "ShareThis, Inc."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "3f7efa85a1ebacc037c50ce11e56fbc4.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "amp.akamaized.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "assets.revcontent.com",
			"ghosteryId": "3626",
			"ghosteryOrganizationName": "Revcontent"
		},
		{
			"domains": "static.earnify.com",
			"ghosteryId": "4358",
			"ghosteryOrganizationName": "Earnify"
		},
		{
			"domains": "yeet.revcontent.com",
			"ghosteryId": "3626",
			"ghosteryOrganizationName": "Revcontent"
		},
		{
			"domains": "zem.outbrainimg.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "173bf107.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "t.sharethis.com",
			"ghosteryId": "149",
			"ghosteryOrganizationName": "ShareThis, Inc."
		},
		{
			"domains": "sync.sharethis.com",
			"ghosteryId": "149",
			"ghosteryOrganizationName": "ShareThis, Inc."
		},
		{
			"domains": "experience-eu.piano.io",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano"
		},
		{
			"domains": "cdn-eu.piano.io",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano"
		},
		{
			"domains": "c2-eu.piano.io",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano"
		},
		{
			"domains": "buy-eu.piano.io",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano"
		},
		{
			"domains": "assets-manager.abtasty.com",
			"ghosteryId": "3037",
			"ghosteryOrganizationName": "AB Tasty"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "6191740102fdeaff565fe5aed3ed07a9.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "sync.teads.tv",
			"ghosteryId": "2521",
			"ghosteryOrganizationName": "Teads"
		},
		{
			"domains": "cdn2.teads.tv",
			"ghosteryId": "2521",
			"ghosteryOrganizationName": "Teads"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "18c449108979c96fd9d6a2d40e979935.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "a-iad3.1rx.io",
			"ghosteryId": "673",
			"ghosteryOrganizationName": "RhythmOne, LLC"
		},
		{
			"domains": "presentation-iad1.turn.com",
			"ghosteryId": "5298",
			"ghosteryOrganizationName": "Singtel"
		},
		{
			"domains": "trackedevt.1rx.io",
			"ghosteryId": "673",
			"ghosteryOrganizationName": "RhythmOne, LLC"
		},
		{
			"domains": "nbcuni.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "nbcu.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "nbcume.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "nbcu.sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "mssl.fwmrm.net",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "951b868f7f72313ab5bdcdbd8972d746.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "nbcu-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "c.tvpixel.com",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8168974.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "prodamdnewsencoding.akamaized.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "usasync01.admantx.com",
			"ghosteryId": "5336",
			"ghosteryOrganizationName": "Expert System, SpA"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ef2c420c48e25bcc3745aa0c658e9e48.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "mediatailor.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "9f6bc946ffc84f39ba7761ec18f6d85f.mediatailor.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "live-oneapp-prd-news.akamaized.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "hb.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "nbcume.hb.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "nfcu.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "navyfederalcu.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "collector-11598.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9749892.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "20843995p.rfihub.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "cdn-widgetsrepository.yotpo.com",
			"ghosteryId": "2657",
			"ghosteryOrganizationName": "Yotpo"
		},
		{
			"domains": "static.klaviyo.com",
			"ghosteryId": "4702",
			"ghosteryOrganizationName": "Klaviyo",
			"whenAddedToGhostery": "2024-02-01T09:32:33.000Z"
		},
		{
			"domains": "a.klaviyo.com",
			"ghosteryId": "4702",
			"ghosteryOrganizationName": "Klaviyo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9082788.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "static-tracking.klaviyo.com",
			"ghosteryId": "4702",
			"ghosteryOrganizationName": "Klaviyo",
			"whenAddedToGhostery": "2024-02-01T09:32:33.000Z"
		},
		{
			"domains": "us-west-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "s3.us-west-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "intg.snapchat.com",
			"ghosteryId": "157",
			"ghosteryOrganizationName": "Snap Technologies"
		},
		{
			"domains": "isolvedcdnprod.azureedge.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "applicationinsights.azure.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2024-07-09T11:11:23.000Z"
		},
		{
			"domains": "in.applicationinsights.azure.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "eastus-8.in.applicationinsights.azure.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "bf26898hpn.bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "img-s-msn-com.akamaized.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "www.bing.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2024-10-02T13:24:57.000Z"
		},
		{
			"domains": "th.bing.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "content.quantcount.com",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited"
		},
		{
			"domains": "pixel.quantcount.com",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited"
		},
		{
			"domains": "sync.im-apps.net",
			"ghosteryId": "4067",
			"ghosteryOrganizationName": "Intimate Merger",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "exch.quantcount.com",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited"
		},
		{
			"domains": "prod-streaming-video-msn-com.akamaized.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "prod-video-cms-amp-microsoft-com.akamaized.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "acdn.adnxs-simple.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "attribution.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "cadreonus-9-adswizz.attribution.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "10086.global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "znnan-morganstanleydigital.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "11382434.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "flourishingpartnership.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "486b3c2b3bb4bd1520e8fc9ec3b11843.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "tcheck.outbrainimg.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain"
		},
		{
			"domains": "mlb.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "mlbadvancedmedialp.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "mabping.chartbeat.net",
			"ghosteryId": "313",
			"ghosteryOrganizationName": "ChartBeat"
		},
		{
			"domains": "counter.snackly.co",
			"ghosteryId": "4282",
			"ghosteryOrganizationName": "Minute.ly"
		},
		{
			"domains": "cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "ipv4.cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "ipv6.cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "hb.360yield.com",
			"ghosteryId": "523",
			"ghosteryOrganizationName": "Improve Digital"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "072eb188abe94b104c6aef744ddd799f.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "znbhheuua1bbyykz4-mlb.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "mlb-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "268a2000018370f5f35b29272d1942aa2ff7b6a9.cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "cdn-pci.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "a8894411182.cdn-pci.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "djnf6e5yyirys.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8571574.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn1.friendbuy.com",
			"ghosteryId": "5219",
			"ghosteryOrganizationName": "FriendBuy",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "12613276.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "k-aus1.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "c.s-microsoft.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "ats.everesttech.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "vviecgwb.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6763511.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "tmobile.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "mpcs.inq.com",
			"ghosteryId": "230",
			"ghosteryOrganizationName": "TouchCommerce"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn7nj5omfyyzlxou5-tmobilecx.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "digital-cloud-bofa.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "resources.digital-cloud-bofa.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "1359940.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "digital-cloud-bofa.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "analytics-fe.digital-cloud-bofa.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "encyclopaediabritann.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "ay.delivery",
			"disconnectMeName": "AssertiveYield",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cafemedia-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "3abf83191637e6398bb0a60e13288850.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ny1-bid.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "ad.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "st.pubmatic.com",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc."
		},
		{
			"domains": "vpaid.doubleverify.com",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify"
		},
		{
			"domains": "tpsc-video-ue.doubleverify.com",
			"ghosteryId": "58",
			"ghosteryOrganizationName": "DoubleVerify"
		},
		{
			"domains": "c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "r3---sn-ab5l6nk6.c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us-west-sync.bidswitch.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "pdc.bidswitch.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "odr.mookie1.com",
			"ghosteryId": "4758",
			"ghosteryOrganizationName": "Xaxis"
		},
		{
			"domains": "global.ib-ibi.com",
			"ghosteryId": "611",
			"ghosteryOrganizationName": "KBM Group"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o66889.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "quadpay.com",
			"disconnectMeName": "Zip",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9344415.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13580167.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13949580.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ssl.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "global.ssl.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "mercari-images.global.ssl.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "id2.sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "match.deepintent.com",
			"ghosteryId": "5037",
			"ghosteryOrganizationName": "Deep Intent",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "maps.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "s7d1.scene7.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "blob.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "insitez.blob.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "cdn5.userzoom.com",
			"ghosteryId": "1692",
			"ghosteryOrganizationName": "UserZoom"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o264896.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "cbsi.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "ads.stickyadstv.com",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "v.fwmrm.net",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast"
		},
		{
			"domains": "7f077.v.fwmrm.net",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast"
		},
		{
			"domains": "v.fwmrm.net",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast"
		},
		{
			"domains": "1f2e7.v.fwmrm.net",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast"
		},
		{
			"domains": "damageddistance.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "8d2c8ee393bfb9da98a9397c5adca4b8.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "r2---sn-ajab55-55.c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "hb-api.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cbs.hb-api.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "atlas.ngtv.io",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T"
		},
		{
			"domains": "68794907.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "cdn.adgrx.com",
			"ghosteryId": "433",
			"ghosteryOrganizationName": "Samsung"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "12735917.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "scripps.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "ssl.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "global.ssl.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "mslc-prod-herokuapp-com.global.ssl.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10443819.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "assets.ctfassets.net",
			"ghosteryId": "5325",
			"ghosteryOrganizationName": "Contentful GmbH"
		},
		{
			"domains": "marriott.btttag.com",
			"ghosteryId": "3355",
			"ghosteryOrganizationName": "Blue Triangle"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "1359549.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "marriottinternationa.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "pxl.jivox.com",
			"ghosteryId": "1872",
			"ghosteryOrganizationName": "Jivox"
		},
		{
			"domains": "d1af033869koo7.cloudfront.net",
			"disconnectMeName": "d1af033869koo7.cloudfront.net",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "2713",
			"ghosteryOrganizationName": "[24]7",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "d.line-scdn.net",
			"ghosteryId": "5232",
			"ghosteryOrganizationName": "Line",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wcs.naver.net",
			"ghosteryId": "4249",
			"ghosteryOrganizationName": "Naver",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "tr.line.me",
			"ghosteryId": "5232",
			"ghosteryOrganizationName": "Line"
		},
		{
			"domains": "ag.innovid.com",
			"ghosteryId": "825",
			"ghosteryOrganizationName": "Innovid"
		},
		{
			"domains": "ssl.pstatic.net",
			"ghosteryId": "4249",
			"ghosteryOrganizationName": "Naver",
			"whenAddedToGhostery": "2023-12-19T12:23:20.000Z"
		},
		{
			"domains": "wcs.naver.com",
			"ghosteryId": "4249",
			"ghosteryOrganizationName": "Naver"
		},
		{
			"domains": "daum.net",
			"disconnectMeName": "Kakao",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "02e1c8a60f4e206c19ba08b54d509e31.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ssl.gstatic.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "impes.tradedoubler.com",
			"ghosteryId": "668",
			"ghosteryOrganizationName": "Tradedoubler AB"
		},
		{
			"domains": "geo.dailymotion.com",
			"ghosteryId": "5411",
			"ghosteryOrganizationName": "Vivendi"
		},
		{
			"domains": "img.tradedoubler.com",
			"ghosteryId": "668",
			"ghosteryOrganizationName": "Tradedoubler AB"
		},
		{
			"domains": "pebed.dm-event.net",
			"ghosteryId": "5411",
			"ghosteryOrganizationName": "Vivendi"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d1111496ac1b97200146a2e14878312d.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "t3.teads.tv",
			"ghosteryId": "2521",
			"ghosteryOrganizationName": "Teads"
		},
		{
			"domains": "api.privacy-center.org",
			"ghosteryId": "5327",
			"ghosteryOrganizationName": "Didomi"
		},
		{
			"domains": "macyscominc.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "macys.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "bk8d4asi.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "14350673.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d1n00d49gkbray.cloudfront.net",
			"ghosteryId": "2585",
			"ghosteryOrganizationName": "SmarterHQ",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "b4f4d557a194fd0dfbee8677000abfdd.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "3856256.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10289658.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "jf7gf3qxfa6dez2ypoxa-p112k5-a83aaa2ff-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-119_ts-1733852078-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "68794911.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "us.connextra.com",
			"ghosteryId": "502",
			"ghosteryOrganizationName": "Connextra"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13987601.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "zz.connextra.com",
			"ghosteryId": "502",
			"ghosteryOrganizationName": "Connextra"
		},
		{
			"domains": "lowes15841z.btttag.com",
			"ghosteryId": "3355",
			"ghosteryOrganizationName": "Blue Triangle"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "b2e868553c7d74c199363c98e891a896.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "12808899.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "173bf105.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "1060694.collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6450450.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fdz.flashtalking.com",
			"ghosteryId": "442",
			"ghosteryOrganizationName": "Flashtalking",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "digital-cloud-us-main.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "analytics-fe.digital-cloud-us-main.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "60849281f5016bd323ca480252912eed.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "1647f9939c59763e2745ec8411031f3e.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "v.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "3da9c32d5826ec81182afd5ec4238e82.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "r5---sn-ab5sznz6.c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c957a7b5666ea40fef345fc6ff65dc27.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "rendering.sharethrough.com",
			"ghosteryId": "718",
			"ghosteryOrganizationName": "Sharethrough, Inc"
		},
		{
			"domains": "groundcontrol.rendering.sharethrough.com",
			"ghosteryId": "718",
			"ghosteryOrganizationName": "Sharethrough, Inc"
		},
		{
			"domains": "b.sharethrough.com",
			"ghosteryId": "718",
			"ghosteryOrganizationName": "Sharethrough, Inc"
		},
		{
			"domains": "dis.criteo.com",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "azv.adsrvr.org",
			"ghosteryId": "560",
			"ghosteryOrganizationName": "The Trade Desk"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "be2c2db5b70feacc018486f2eb91669c.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "a2731.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "execute-api.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "2pqo3eid5b.execute-api.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6337982.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10606295.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733861220-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "jf7gf3qxfa6dez2yt5sa-p7f8m1-a3fd14cb7-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "173bf106.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "a0d0156fcd0316e54d02817c958ca7ca.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-44147.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o270910.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "cdn.treasuredata.com",
			"ghosteryId": "4464",
			"ghosteryOrganizationName": "arm",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdn-net.com",
			"disconnectMeName": "American Express",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "in.treasuredata.com",
			"ghosteryId": "4464",
			"ghosteryOrganizationName": "arm",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cdp.in.treasuredata.com",
			"ghosteryId": "4464",
			"ghosteryOrganizationName": "arm"
		},
		{
			"domains": "cdn-net.com",
			"disconnectMeName": "American Express",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "px.gumgum.com",
			"ghosteryId": "84",
			"ghosteryOrganizationName": "GumGum"
		},
		{
			"domains": "d1eoo1tco6rr5e.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "3508609.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "conversions-config.reddit.com",
			"ghosteryId": "1734",
			"ghosteryOrganizationName": "reddit"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "znberfuuilm5hhpho-littlecaesars.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "static-exp2.licdn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "lnkd.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "libertymutual-personalmarkets.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "visitor-service-us-east-1.tealiumiq.com",
			"ghosteryId": "662",
			"ghosteryOrganizationName": "Tealium"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "znagyjhfxnlbwptub-libertymutualvoc.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "d3hw6dc1ow8pp2.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "op85grh0.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "a.klaviyo.com",
			"ghosteryId": "4702",
			"ghosteryOrganizationName": "Klaviyo",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fast.a.klaviyo.com",
			"ghosteryId": "4702",
			"ghosteryOrganizationName": "Klaviyo"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "14421547.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "mux.com",
			"disconnectMeName": "Mux",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mux.com",
			"disconnectMeName": "Mux",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "mux.com",
			"disconnectMeName": "Mux",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "d9fvwtvqz2fm1.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d26ky332zktp97.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d1zcmvsklxjbur.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "ecommplugins-scripts.trustpilot.com",
			"ghosteryId": "5155",
			"ghosteryOrganizationName": "Trustpilot"
		},
		{
			"domains": "ecommplugins-trustboxsettings.trustpilot.com",
			"ghosteryId": "5155",
			"ghosteryOrganizationName": "Trustpilot"
		},
		{
			"domains": "invitejs.trustpilot.com",
			"ghosteryId": "5155",
			"ghosteryOrganizationName": "Trustpilot",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "getdeviceinf.com",
			"disconnectMeName": "getdeviceinf.com",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn394yygoj0zd35dd-cbs.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "freetls.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "lastfm.freetls.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "s7d9.scene7.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "labcorp.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn3flro8u7tjwoeec-8451cx.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "kohls.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "6249496.collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "bf27853irn.bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "9feff8697152d135877b7bae28794112.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "tjxbfc1n.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "kohls.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "us-7.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "kohlsinc2.us-7.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "cloud.kargo.com",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo"
		},
		{
			"domains": "storage.cloud.kargo.com",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo"
		},
		{
			"domains": "prodeastusmappscreative.azureedge.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "kds-pixel.kargo.com",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo"
		},
		{
			"domains": "marketingtools.apple.com",
			"ghosteryId": "390",
			"ghosteryOrganizationName": "Apple"
		},
		{
			"domains": "toolbox.marketingtools.apple.com",
			"ghosteryId": "390",
			"ghosteryOrganizationName": "Apple"
		},
		{
			"domains": "pixall.esm1.net",
			"ghosteryId": "4642",
			"ghosteryOrganizationName": "Dealer.com"
		},
		{
			"domains": "cs.esm1.net",
			"ghosteryId": "4642",
			"ghosteryOrganizationName": "Dealer.com"
		},
		{
			"domains": "7seasky.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "1a86d503984d03edef605db5a8988765.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8951737.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10178839.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "7seasky.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn3ts5izhgdp6ryfxcoxautomotive.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "72164059993b.cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "48c41e63e0cc4df197216c8f44c84544-72164059993b.cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "ads.travelaudience.com",
			"ghosteryId": "4913",
			"ghosteryOrganizationName": "Travel Audience",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "5142311.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "simage2.pubmatic.com",
			"ghosteryId": "348",
			"ghosteryOrganizationName": "PubMatic, Inc."
		},
		{
			"domains": "kaiserpermanente19051z.btttag.com",
			"ghosteryId": "3355",
			"ghosteryOrganizationName": "Blue Triangle"
		},
		{
			"domains": "js-cdn.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "dok.js-cdn.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zna4m7d69tmslujze-kp.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "bf78095soe.bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "privacyportal-na01.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "cdn.trackjs.com",
			"ghosteryId": "3549",
			"ghosteryOrganizationName": "TrackJS"
		},
		{
			"domains": "collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "7233063.collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "widget.trustpilot.com",
			"ghosteryId": "5155",
			"ghosteryOrganizationName": "Trustpilot"
		},
		{
			"domains": "jetblueairways.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "uwhfgjlv.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "jcpenney.scene7.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "jcpenney.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "d38knilzwtuys1.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d2e0sxz09bo7k2.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "vukev4zm.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "cdn.brcdn.com",
			"ghosteryId": "396",
			"ghosteryOrganizationName": "BloomReach"
		},
		{
			"domains": "collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "534000654.collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "p.brsrvr.com",
			"ghosteryId": "396",
			"ghosteryOrganizationName": "BloomReach"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6360663.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "33c8326a9bc84e0558ac7935a5a8f2c3.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "f29613dadca3.cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "boxycharm.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "3d332750b9244ddd86c0661f6020a9b9-f29613dadca3.cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "d3g5d7323c2i6m.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d38xvr37kwwhcm.cloudfront.net",
			"disconnectMeName": "d38xvr37kwwhcm.cloudfront.net",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d29qb9vav0xwuc.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d7c4jjeuqag9w.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "dn666andut2j1.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "cdn6.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "14618846.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d2vykwbochoala.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "invescogroup.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "invescogroup.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "invescogroup.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "consent.mailchimp.com",
			"ghosteryId": "1187",
			"ghosteryOrganizationName": "MailChimp"
		},
		{
			"domains": "turbotax.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8344993.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "1996823.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "2796.global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn_3siux5otvvf1mct-intuit.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "app-ab20.marketo.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "static.addtoany.com",
			"ghosteryId": "4",
			"ghosteryOrganizationName": "AddToAny",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "449-bvj-543.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "static.cdninstagram.com",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta"
		},
		{
			"domains": "awswaf.com",
			"disconnectMeName": "Amazon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "awswaf.com",
			"disconnectMeName": "Amazon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "ced.sascdn.com",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver"
		},
		{
			"domains": "d3c8j8snkzfr1n.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "ced-ns.sascdn.com",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o435357.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "1f1619d93e9f32fa5ec64ae6bd390645.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "dqpnq362acqdi.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d3dtw1sz7pzl52.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "452465f56b8f51fa052ce0145c692aec.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "axp.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "ono.axp.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "us-east.ono.axp.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "aes.us-east.ono.axp.amazon-adsystem.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "fls-na.amazon.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "unagi.amazon.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "images-na.ssl-images-amazon.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a24698640007.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "14973527.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "consent.truste.com",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "uh3fpcnb.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "services.xg4ken.com",
			"ghosteryId": "1299",
			"ghosteryOrganizationName": "Kenshoo"
		},
		{
			"domains": "us-1.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "sixcontinents.us-1.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "2463678.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "znaeyokp2zrxb2lop-ihg.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "clearchannel.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "amplifypixel.outbrain.com",
			"ghosteryId": "134",
			"ghosteryOrganizationName": "Outbrain",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "13e7d6db674f7b165543a3478cd261f7.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.piano.io",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fc1aaca27101b365bee5749c642aaf13.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ziffdavis-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "ps.eyeota.net",
			"ghosteryId": "1727",
			"ghosteryOrganizationName": "Eyeota"
		},
		{
			"domains": "loadus.exelator.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "www.apple.com",
			"ghosteryId": "390",
			"ghosteryOrganizationName": "Apple",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "hyatt.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "mboxedge35.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cdn-3.convertexperiments.com",
			"ghosteryId": "5041",
			"ghosteryOrganizationName": "Convert"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "5683605.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ct.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "us-west-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "s3.us-west-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ao-de-web-modules.s3.us-west-2.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "assetshuluimcom-a.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "my.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "disney.my.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "collector-1564.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "intljs.rmtag.com",
			"ghosteryId": "3334",
			"ghosteryOrganizationName": "Rakuten Marketing LLC"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "3797690.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "e.cquotient.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "hottopic.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cdns.brsrvr.com",
			"ghosteryId": "396",
			"ghosteryOrganizationName": "BloomReach"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9163167.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8966610.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d3fenhwk93s16g.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn_42v6draxyafsjmv-homedepot.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "1ad356638475.cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "effc276e035a4b9e8fedf9b829833432-1ad356638475.cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "3518820.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "homedepot-sync.quantummetric.com",
			"ghosteryId": "4748",
			"ghosteryOrganizationName": "Quantum Metric, Inc."
		},
		{
			"domains": "a1.adform.net",
			"ghosteryId": "457",
			"ghosteryOrganizationName": "Adform"
		},
		{
			"domains": "handm.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "bat.bing.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9054599.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "s2.adform.net",
			"ghosteryId": "457",
			"ghosteryOrganizationName": "Adform"
		},
		{
			"domains": "cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "4dc2aa82bc5e.cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "hilton.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cdn9.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "2013561.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "prvsz4pe.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "20858397p.rfihub.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "f0b815ada9d84f3c85b8d031c473a76e-4dc2aa82bc5e.cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "d196fri2z18sm.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "in.treasuredata.com",
			"ghosteryId": "4464",
			"ghosteryOrganizationName": "arm",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "records.in.treasuredata.com",
			"ghosteryId": "4464",
			"ghosteryOrganizationName": "arm"
		},
		{
			"domains": "us01.records.in.treasuredata.com",
			"ghosteryId": "4464",
			"ghosteryOrganizationName": "arm"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn9ogeu2akhc6qjuw-hiltonreservations.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "count-server.sharethis.com",
			"ghosteryId": "149",
			"ghosteryOrganizationName": "ShareThis, Inc."
		},
		{
			"domains": "platform-cdn.sharethis.com",
			"ghosteryId": "149",
			"ghosteryOrganizationName": "ShareThis, Inc."
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o256723.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10402920.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "i0.wp.com",
			"ghosteryId": "245",
			"ghosteryOrganizationName": "Automattic"
		},
		{
			"domains": "domf5oio6qrcr.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "surveystats.hotjar.io",
			"ghosteryId": "3632",
			"ghosteryOrganizationName": "Hotjar"
		},
		{
			"domains": "cdn.dynamicyield.com",
			"ghosteryId": "2280",
			"ghosteryOrganizationName": "Dynamic Yield",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "st.dynamicyield.com",
			"ghosteryId": "2280",
			"ghosteryOrganizationName": "Dynamic Yield",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "async-px.dynamicyield.com",
			"ghosteryId": "2280",
			"ghosteryOrganizationName": "Dynamic Yield"
		},
		{
			"domains": "rcom.dynamicyield.com",
			"ghosteryId": "2280",
			"ghosteryOrganizationName": "Dynamic Yield"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10563850.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "privacyportal-harborfreight.my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13740605.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "110-wox-868.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "dsh7ky7308k4b.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d1zndhgj5c3q5g.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "go.affec.tv",
			"ghosteryId": "1267",
			"ghosteryOrganizationName": "Hybrid Theory",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "go.affec.tv",
			"ghosteryId": "1267",
			"ghosteryOrganizationName": "Hybrid Theory",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "map.go.affec.tv",
			"ghosteryId": "1267",
			"ghosteryOrganizationName": "Hybrid Theory"
		},
		{
			"domains": "pbs.360yield.com",
			"ghosteryId": "523",
			"ghosteryOrganizationName": "Improve Digital"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ed9650c789101e6f7560b09e72788d43.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "static-na.payments-amazon.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "contentful.com",
			"disconnectMeName": "Contentful",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-21091.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "11687855.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "69b9700a671c.cdn4.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "78c3d31c69b24bf99eb5c14c302bc765-69b9700a671c.cdn.forter.com",
			"ghosteryId": "5177",
			"ghosteryOrganizationName": "Forter"
		},
		{
			"domains": "d3k6pebee3cv6.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d126fr91w2hv0v.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o565714.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-21641.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "attribution.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "adresults-19-adswizz.attribution.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "11910764.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ogads-pa.googleapis.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "encrypted-tbn0.gstatic.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "znergehtkuacyk0wa-goodrx.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "b1e0cf7984d7dd2d168c12ec15aa117e.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "alcmpn.com",
			"disconnectMeName": "Adstra",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ab372aac04720eab5c801f3354783a26.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "lumiere-a.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "a.espncdn.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "disney.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "2507573.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "github.githubassets.com",
			"ghosteryId": "1618",
			"ghosteryOrganizationName": "GitHub, Inc."
		},
		{
			"domains": "d3l739e8r8y9v7.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "api.mixpanel.com",
			"ghosteryId": "227",
			"ghosteryOrganizationName": "Mixpanel"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c166162942567a5058786707adcce281.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cs.emxdgt.com",
			"ghosteryId": "5333",
			"ghosteryOrganizationName": "Engine"
		},
		{
			"domains": "darnuid.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "yuswhqqs3gmia18okhicwrsm5uv8n1733859901.darnuid.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "geico.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "service.force.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "my.salesforce.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "geicoinsurance.my.salesforce.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "2992003.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "la4-c2-ia4.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "d.la4-c2-ia4.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn0thecsujsizknzd-geico.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "sfdc-yfeipo.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "la13-core1.sfdc-yfeipo.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "d.la13-core1.sfdc-yfeipo.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "geico-app.quantummetric.com",
			"ghosteryId": "4748",
			"ghosteryOrganizationName": "Quantum Metric, Inc."
		},
		{
			"domains": "impression.appsflyer.com",
			"ghosteryId": "4300",
			"ghosteryOrganizationName": "AppsFlyer"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a6529002483.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "www.res-x.com",
			"ghosteryId": "351",
			"ghosteryOrganizationName": "Certona"
		},
		{
			"domains": "gap.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "collect-us-west-2.tealiumiq.com",
			"ghosteryId": "662",
			"ghosteryOrganizationName": "Tealium"
		},
		{
			"domains": "insights-collector.newrelic.com",
			"ghosteryId": "942",
			"ghosteryOrganizationName": "New Relic"
		},
		{
			"domains": "dhfm3psl.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6900831.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "1956281.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8030980.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10709046.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "la3-c2-ia4.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "d.la3-c2-ia4.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "la3-c2-ia5.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "d.la3-c2-ia5.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "4c71634147e06710f65fd8e193f9085d.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "wikia.nocookie.net",
			"ghosteryId": "5412",
			"ghosteryOrganizationName": "Wikia"
		},
		{
			"domains": "script.wikia.nocookie.net",
			"ghosteryId": "5412",
			"ghosteryOrganizationName": "Wikia"
		},
		{
			"domains": "wikia.nocookie.net",
			"ghosteryId": "5412",
			"ghosteryOrganizationName": "Wikia"
		},
		{
			"domains": "static.wikia.nocookie.net",
			"ghosteryId": "5412",
			"ghosteryOrganizationName": "Wikia"
		},
		{
			"domains": "beacon.wikia-services.com",
			"ghosteryId": "5412",
			"ghosteryOrganizationName": "Wikia"
		},
		{
			"domains": "www.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "49ea602898196e1f945c50fe112bfe28.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "prod.kargo.com",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo"
		},
		{
			"domains": "kraken.prod.kargo.com",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo"
		},
		{
			"domains": "socialcanvas-cdn.kargo.com",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo"
		},
		{
			"domains": "tk.kargo.com",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo"
		},
		{
			"domains": "socialcanvas-api.kargo.com",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo"
		},
		{
			"domains": "tags.bluekai.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "wikia-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "7b2303cc86efbe7dfa020a3a12d08144.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d1gszp1bmamha.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "pixel.sitescout.com",
			"ghosteryId": "714",
			"ghosteryOrganizationName": "Centro"
		},
		{
			"domains": "a.impactradius-tag.com",
			"ghosteryId": "2230",
			"ghosteryOrganizationName": "Impact Radius"
		},
		{
			"domains": "cdn.scarabresearch.com",
			"ghosteryId": "5182",
			"ghosteryOrganizationName": "Emarsys"
		},
		{
			"domains": "static.scarabresearch.com",
			"ghosteryId": "5182",
			"ghosteryOrganizationName": "Emarsys"
		},
		{
			"domains": "emarsys.net",
			"disconnectMeName": "SAP",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6494373.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "sync.crwdcntrl.net",
			"ghosteryId": "103",
			"ghosteryOrganizationName": "Lotame"
		},
		{
			"domains": "redinuid.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "obgpm76tt0a0sgogzhdfe.redinuid.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "sync.mathtag.com",
			"ghosteryId": "290",
			"ghosteryOrganizationName": "MediaMath, Inc."
		},
		{
			"domains": "contributor.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ssl.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "global.ssl.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "webcontentassessor.global.ssl.fastly.net",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "player.h-cdn.com",
			"ghosteryId": "4896",
			"ghosteryOrganizationName": "Hola CDN",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "frontdoor.knotch.it",
			"ghosteryId": "4114",
			"ghosteryOrganizationName": "Knotch"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "3b92ea4212ad5017d009c9f4239bfff8.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "perr.h-cdn.com",
			"ghosteryId": "4896",
			"ghosteryOrganizationName": "Hola CDN"
		},
		{
			"domains": "link.h-cdn.com",
			"ghosteryId": "4896",
			"ghosteryOrganizationName": "Hola CDN"
		},
		{
			"domains": "foxnewsplayer-a.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "img.3lift.com",
			"ghosteryId": "2609",
			"ghosteryOrganizationName": "TripleLift, Inc."
		},
		{
			"domains": "sync.springserve.com",
			"ghosteryId": "2581",
			"ghosteryOrganizationName": "SpringServe, LLC"
		},
		{
			"domains": "s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "streamcontroller-stage1-ue1-1.s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "aws-us-east-prod-web-assets.s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "a2.adform.net",
			"ghosteryId": "457",
			"ghosteryOrganizationName": "Adform"
		},
		{
			"domains": "cdn.auth0.com",
			"ghosteryId": "5313",
			"ghosteryOrganizationName": "Auth0 Inc."
		},
		{
			"domains": "r.appspot.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "uc.r.appspot.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "gtm-wlp4xfv-nme2n.uc.r.appspot.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d3e62b1a229f5ca6ae9808915d7447b5.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ford.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "ford.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "blob.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "creativesham.blob.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "api.brightcove.com",
			"ghosteryId": "683",
			"ghosteryOrganizationName": "Brightcove",
			"whenAddedToGhostery": "2024-12-02T17:16:18.000Z"
		},
		{
			"domains": "edge.api.brightcove.com",
			"ghosteryId": "683",
			"ghosteryOrganizationName": "Brightcove"
		},
		{
			"domains": "metrics.brightcove.com",
			"ghosteryId": "683",
			"ghosteryOrganizationName": "Brightcove",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "bcbolt446c5271-a.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "690327.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733852622-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "jf7gf3qxfa6bgz2ypxha-p7ivn3-42265cf73-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "warp.media.net",
			"ghosteryId": "1879",
			"ghosteryOrganizationName": "Media.net"
		},
		{
			"domains": "cdn.blueconic.net",
			"ghosteryId": "3860",
			"ghosteryOrganizationName": "BlueConic"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d586bcf9d446601392fd72b3ee40a04b.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "open-api.spot.im",
			"ghosteryId": "3625",
			"ghosteryOrganizationName": "Spot.IM Ltd."
		},
		{
			"domains": "prebid-s2s.media.net",
			"ghosteryId": "1879",
			"ghosteryOrganizationName": "Media.net"
		},
		{
			"domains": "forbes.blueconic.net",
			"ghosteryId": "3860",
			"ghosteryOrganizationName": "BlueConic"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zndpq7uw2elr2st9z-forbesbi.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "b2ad4f9899c940acdb6f4b1ddf8650a9.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "lm.serving-sys.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "execute-api.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "bmxocid8k6.execute-api.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn0hyipakioaocqih-sni.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "jf7gf3qxfa6bgz2yresq-pbx85i-44ef5b0ba-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733855525-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-29178.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8499620.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "20844709p.rfihub.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "dn0qt3r0xannq.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "1f6041ceb6aa0f049ca3d0ee55b4719c.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "js.usemessages.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "api.hubspot.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "js-na1.hs-scripts.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot"
		},
		{
			"domains": "cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "ipv4.cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "27f19c7c68e3eadf7756fb7efdb661dd8909acf9.ipv4.cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "ipv6.cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "27f19c7c68e3eadf7756fb7efdb661dd8909acf9.ipv6.cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "57a1ba584090d0932d2773d94cd3dfc3.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "de9a11s35xj3d.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "webcontentassessor.com",
			"disconnectMeName": "TMTDigital",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "sync-t1.taboola.com",
			"ghosteryId": "1463",
			"ghosteryOrganizationName": "Taboola"
		},
		{
			"domains": "secure-dcr.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "global.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "fidelity.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fmrcorp.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zncvgjh8lmjxbkyln-fmrpi.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "config.playwire.com",
			"ghosteryId": "4577",
			"ghosteryOrganizationName": "Snowplow"
		},
		{
			"domains": "impression-inferences-edge-prod.playwire.com",
			"ghosteryId": "4577",
			"ghosteryOrganizationName": "Snowplow"
		},
		{
			"domains": "px.moatads.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "0a1a839b172bcd1bba538a0ba1cd6cf1.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "playwire-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "r5---sn-ab5l6nrz.c.2mdn.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fedex.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fedex.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "znagz4jo87lmiuo1k-fedex.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "xx.fbcdn.net",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta"
		},
		{
			"domains": "static.xx.fbcdn.net",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o4504566675341312.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a26979700476.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "get.s-onetag.com",
			"ghosteryId": "5424",
			"ghosteryOrganizationName": "OneTag"
		},
		{
			"domains": "signal-beacon.s-onetag.com",
			"ghosteryId": "5424",
			"ghosteryOrganizationName": "OneTag"
		},
		{
			"domains": "signal-segments.s-onetag.com",
			"ghosteryId": "5424",
			"ghosteryOrganizationName": "OneTag"
		},
		{
			"domains": "connect-metrics-collector.s-onetag.com",
			"ghosteryId": "5424",
			"ghosteryOrganizationName": "OneTag"
		},
		{
			"domains": "signal-metrics-collector-beta.s-onetag.com",
			"ghosteryId": "5424",
			"ghosteryOrganizationName": "OneTag"
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "s3.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "collector-7762.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "pixel.parsely.com",
			"ghosteryId": "1009",
			"ghosteryOrganizationName": "Parse.ly",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "srv-2024-12-10-20.pixel.parsely.com",
			"ghosteryId": "1009",
			"ghosteryOrganizationName": "Parse.ly"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "13816b56648c3a5b452c00a37deda1f5.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "lhr-v4.pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "kteb-v4.pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "u.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "us.u.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "bd9825d3-7a25-4c90-9fac-b3ea99caad64.us.u.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "muc-v4.pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "phx-v4.pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "bare-v4.pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "dub-v4.pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "ewr-v4.pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "any-v4.pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "astral-v4.pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "kul-v4.pops.fastly-insights.com",
			"ghosteryId": "5338",
			"ghosteryOrganizationName": "Fastly"
		},
		{
			"domains": "ecs.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "consumerinfo.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "1150992.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9224405.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d3rse9xjbp8270.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d3lopmpcew67el.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d362h7pxdteoyk.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "i.etsystatic.com",
			"ghosteryId": "2030",
			"ghosteryOrganizationName": "Etsy, Inc."
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8666735.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9910951.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "14895689.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ad.wsod.com",
			"ghosteryId": "1184",
			"ghosteryOrganizationName": "IHS",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "b51649f1f41c9a4c25b1caea6fc436a7.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "dfm0jp10ki2dt.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "cdn.raygun.io",
			"ghosteryId": "4101",
			"ghosteryOrganizationName": "Raygun"
		},
		{
			"domains": "api.raygun.io",
			"ghosteryId": "4101",
			"ghosteryOrganizationName": "Raygun",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a1.espncdn.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "a4.espncdn.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "a3.espncdn.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "a2.espncdn.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "espndotcom.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "auth.adobe.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "entitlement.auth.adobe.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "auth.adobe.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sp.auth.adobe.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "registerdisney.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "cdn.registerdisney.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "secure.espncdn.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "watchabc.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "config.watchabc.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "api.config.watchabc.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "mb.moatads.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "9bbb024d28955a3dd1ae99cecdd7f32d.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "log.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "publishers.tremorhub.com",
			"ghosteryId": "564",
			"ghosteryOrganizationName": "Tremor Video"
		},
		{
			"domains": "i79zj.publishers.tremorhub.com",
			"ghosteryId": "564",
			"ghosteryOrganizationName": "Tremor Video"
		},
		{
			"domains": "pespn.chartbeat.net",
			"ghosteryId": "313",
			"ghosteryOrganizationName": "ChartBeat"
		},
		{
			"domains": "engsvc.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "semfs.engsvc.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "fastcast.semfs.engsvc.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "engsvc.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "semfs.engsvc.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "fastcast.semfs.engsvc.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "pe7ef5b3c3-b6b8-4fa8-9c6f-91d5f64816f3-18-207-246-231.fastcast.semfs.engsvc.go.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "fcast.espncdn.com",
			"ghosteryId": "1826",
			"ghosteryOrganizationName": "The Walt Disney Company"
		},
		{
			"domains": "secure-sdk.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "elsevierlimited.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "cdn-fsly.yottaa.net",
			"ghosteryId": "5419",
			"ghosteryOrganizationName": "Yottaa"
		},
		{
			"domains": "qoe-1.yottaa.net",
			"ghosteryId": "5419",
			"ghosteryOrganizationName": "Yottaa"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10742279.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10265292.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9231397.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ba.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "srm.ba.contentsquare.net",
			"ghosteryId": "5261",
			"ghosteryOrganizationName": "Content Square"
		},
		{
			"domains": "278-nxo-307.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cc25a42918fb25ce82d7034a5dbe9fa9.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10622129.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ir.ebaystatic.com",
			"ghosteryId": "220",
			"ghosteryOrganizationName": "eBay"
		},
		{
			"domains": "i.ebayimg.com",
			"ghosteryId": "220",
			"ghosteryOrganizationName": "eBay"
		},
		{
			"domains": "secureir.ebaystatic.com",
			"ghosteryId": "220",
			"ghosteryOrganizationName": "eBay"
		},
		{
			"domains": "main.ebayrtm.com",
			"ghosteryId": "220",
			"ghosteryOrganizationName": "eBay"
		},
		{
			"domains": "srv.main.ebayrtm.com",
			"ghosteryId": "220",
			"ghosteryOrganizationName": "eBay"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ae413dd8001f690f581496252f8d4dfb.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13341218.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "api-sr.amplitude.com",
			"ghosteryId": "3070",
			"ghosteryOrganizationName": "Amplitude"
		},
		{
			"domains": "secure.gravatar.com",
			"ghosteryId": "245",
			"ghosteryOrganizationName": "Automattic"
		},
		{
			"domains": "syndication.twitter.com",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp.",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "9b4db6d642c50d57691ed9e70d1e8dc3.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "as.jivox.com",
			"ghosteryId": "1872",
			"ghosteryOrganizationName": "Jivox"
		},
		{
			"domains": "evs.jivox.com",
			"ghosteryId": "1872",
			"ghosteryOrganizationName": "Jivox"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "3879194.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ga.clearbit.com",
			"ghosteryId": "5324",
			"ghosteryOrganizationName": "Clearbit"
		},
		{
			"domains": "t.eloqua.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "s860818199.t.eloqua.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "cisco.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "12979078.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "3569326.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d35aaqx5ub95lt.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o4505784036032512.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "ymbtsoj7.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "dswinc.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "11993393.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "5866208.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "s.nitropay.com",
			"ghosteryId": "5346",
			"ghosteryOrganizationName": "GG Software LLC"
		},
		{
			"domains": "pbs.twimg.com",
			"ghosteryId": "174",
			"ghosteryOrganizationName": "X Corp."
		},
		{
			"domains": "tracker.nitropay.com",
			"ghosteryId": "5346",
			"ghosteryOrganizationName": "GG Software LLC"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d8179c4ac9ec6c0b1cc1f5807a09f55a.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ggsoftware-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "by8aun9we0.kameleoon.eu",
			"ghosteryId": "3044",
			"ghosteryOrganizationName": "Kameleoon"
		},
		{
			"domains": "s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "xp2023-pix.s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "na-data.kameleoon.eu",
			"ghosteryId": "3044",
			"ghosteryOrganizationName": "Kameleoon"
		},
		{
			"domains": "apay-us.amazon.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "doui4jqs03un3.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "form-assets.mailchimp.com",
			"ghosteryId": "1187",
			"ghosteryOrganizationName": "MailChimp"
		},
		{
			"domains": "fonts.shopifycdn.com",
			"ghosteryId": "2179",
			"ghosteryOrganizationName": "Shopify"
		},
		{
			"domains": "dropbox.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "d9sojbwwxq62r.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d2tjpz01y5bfgl.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "cdn.fonts.net",
			"ghosteryId": "3427",
			"ghosteryOrganizationName": "Monotype Imaging"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9325724.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-44754.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "us.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "ingest.us.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o17585.ingest.us.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9927915.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8974041.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "dominos.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "docucdn-a.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8397396.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9093642.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "disney-portal.my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "discover.sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "3470633.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "f444f81c9522e7c49683accbb66b0878.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "t.eloqua.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "s1358.t.eloqua.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "direxion.blueconic.net",
			"ghosteryId": "3860",
			"ghosteryOrganizationName": "BlueConic"
		},
		{
			"domains": "plugins.blueconic.net",
			"ghosteryId": "3860",
			"ghosteryOrganizationName": "BlueConic"
		},
		{
			"domains": "andstarsbuilding.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "andstarsbuilding.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "usync.proper.io",
			"ghosteryId": "5216",
			"ghosteryOrganizationName": "Proper Media"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "f90b9d9349db5102f6d02aff41b86f70.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "static.sharethrough.com",
			"ghosteryId": "718",
			"ghosteryOrganizationName": "Sharethrough, Inc"
		},
		{
			"domains": "creative-assets.quantcount.com",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited"
		},
		{
			"domains": "us-east-notify-rtb.quantserve.com",
			"ghosteryId": "139",
			"ghosteryOrganizationName": "Quantcast International Limited"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ce658461d6ad6c421546603d1e99528b.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ghent-gce-or.bidswitch.net",
			"ghosteryId": "51",
			"ghosteryOrganizationName": "Criteo"
		},
		{
			"domains": "dpcomdhl.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "d3.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "dhlcom.d3.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "dpcomdhl.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "static.parastorage.com",
			"ghosteryId": "5414",
			"ghosteryOrganizationName": "Wix"
		},
		{
			"domains": "images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com",
			"ghosteryId": "5414",
			"ghosteryOrganizationName": "Wix"
		},
		{
			"domains": "frog.wix.com",
			"ghosteryId": "5414",
			"ghosteryOrganizationName": "Wix"
		},
		{
			"domains": "apps.wix.com",
			"ghosteryId": "5414",
			"ghosteryOrganizationName": "Wix"
		},
		{
			"domains": "load.sumo.com",
			"ghosteryId": "3560",
			"ghosteryOrganizationName": "SumoMe"
		},
		{
			"domains": "cdn.callrail.com",
			"ghosteryId": "2652",
			"ghosteryOrganizationName": "CallRail"
		},
		{
			"domains": "load.sumome.com",
			"ghosteryId": "3560",
			"ghosteryOrganizationName": "SumoMe"
		},
		{
			"domains": "js.callrail.com",
			"ghosteryId": "2652",
			"ghosteryOrganizationName": "CallRail"
		},
		{
			"domains": "clients6.google.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "roper-privacy.my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "d35k22e9287vnh.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "ay.delivery",
			"disconnectMeName": "AssertiveYield",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "pubgw.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "webc2s.pubgw.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "prebid-us.creativecdn.com",
			"ghosteryId": "3371",
			"ghosteryOrganizationName": "RTB House"
		},
		{
			"domains": "klkstrm.kargo.com",
			"ghosteryId": "1585",
			"ghosteryOrganizationName": "Kargo"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "e34fb071ba6a2d46513b280eee20040c.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "mailonline-us-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "9a913f952dc1254853cc206e6534cfc3.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "a604.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "7a2b96e4d15948afdc3b13b7aa997b40.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "6446eca47a95983f1544c73ce432f6de.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "spot-im-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "video-outstream.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "apps.sascdn.com",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver"
		},
		{
			"domains": "ash.creativecdn.com",
			"ghosteryId": "3371",
			"ghosteryOrganizationName": "RTB House"
		},
		{
			"domains": "use2.smartadserver.com",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver"
		},
		{
			"domains": "www8.smartadserver.com",
			"ghosteryId": "631",
			"ghosteryOrganizationName": "Smart Adserver"
		},
		{
			"domains": "prebid.deepintent.com",
			"ghosteryId": "5037",
			"ghosteryOrganizationName": "Deep Intent"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "447b914f8cbad90c6caa2f7536c2606f.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "40f46583f0356339f69c6de7d870219f.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "4e61e38796507d25a9d19d08bcf7f39b.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "618a84f27bea0eed27ccc7b6e9296f66.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "15d543dbcf78972326cb19ad65c1298b.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d9daf6a9d6c3b889b81f0ce9d11e09dc.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "92ddfa3ce2a4d2922f477470308aa336.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "91240e98b3a582fcf06a7e4d397a5e26.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "f32f2683b156c72426ca355b268428c6.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "38c459c6ec40c4429dc335dcf23bd557.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "8dd210a2c94c5038426c1331bcf004ab.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "46d10e297377f8231ce14e279feca264.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "9c413c4bb1f72a5a2be9215e07d2fcee.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ab03773760938999440b2aa6c52e8279.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "173bf10d.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "11c4820ed782c8fae47fd24d64a63071.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "3eff8597d42b7b966a01df62c69da128.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "7240cedbb8e1a5fcc5ebe670aff18da7.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "23fa069b831bf2627817e3d9b07d4242.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c6d0d175f72b4f400a2fde801b5b5c9f.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "7f8881e38145e120deae2d9e98174cde.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-119_ts-1733860447-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "jf7gf3qxfa6bgz2ytrpq-p1ng7r-a7f7321f1-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "aa5567f89dada8ccf7348f439c55e06b.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "550b82244a0e17af6cb888a52ed7f2ce.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "31bcc6a9450d657b839daf21897acdf1.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "dbae722f4f0bf5829f72a38218756ec5.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "edc7058680dd6e0d342922d13b02913f.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "7ea1de9e752713b2e73c9a759b715fea.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "84a1f30d4ec0635e195be5e65c12504c.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "2b4f79ccd259d15eac6bd860297d5623.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "bd4e22759fcddd4c38ad6c658a6d70e3.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "a05cb6ed7595081c546928b7b3302987.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "4c19a9609f5afc2777c76b4c7fbe1baa.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "9a801fde1f75d939910441a88be510ac.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6615255.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "sjrtp-cdn.marketo.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "sjrtp1.marketo.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "006-lrt-285.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "o2.mouseflow.com",
			"ghosteryId": "418",
			"ghosteryOrganizationName": "Mouseflow"
		},
		{
			"domains": "www.upsellit.com",
			"ghosteryId": "642",
			"ghosteryOrganizationName": "UpSellit",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "cricket.inq.com",
			"ghosteryId": "230",
			"ghosteryOrganizationName": "TouchCommerce"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "attservicesinc.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9716298.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6038155.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cobrowse-cricket.inq.com",
			"ghosteryId": "230",
			"ghosteryOrganizationName": "TouchCommerce"
		},
		{
			"domains": "creditone.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "api.bazaarvoice.com",
			"ghosteryId": "1272",
			"ghosteryOrganizationName": "Bazaarvoice"
		},
		{
			"domains": "creditkarmacdn-a.akamaihd.net",
			"disconnectMeName": "creditkarmacdn-a.akamaihd.net",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "dds6m601du5ji.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "rageagainstthesoap.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "s-vop.sundaysky.com",
			"ghosteryId": "1896",
			"ghosteryOrganizationName": "SundaySky"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10425642.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "rageagainstthesoap.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "d3njjcbhbojbot.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o75955.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "collector-3549.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "costco.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "vsvipac01.rightnowtech.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "173bf10b.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "jf7gf3qxfa6dez2yqzca-pbzi79-9dc5bddd9-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733854788-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "d31otfhas71ais.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mfcdn.s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "538ffc0d58575b063ce75ca14ee57a00.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "a956.casalemedia.com",
			"ghosteryId": "36",
			"ghosteryOrganizationName": "Index Exchange, Inc."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "daea875ec1991648ff291f01ddfd91e6.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "mid.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "cdn-widget-assets.yotpo.com",
			"ghosteryId": "2657",
			"ghosteryOrganizationName": "Yotpo"
		},
		{
			"domains": "joincheckmate.com",
			"disconnectMeName": "Checkmate",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "api-cdn.yotpo.com",
			"ghosteryId": "2657",
			"ghosteryOrganizationName": "Yotpo"
		},
		{
			"domains": "cdn.refersion.com",
			"ghosteryId": "3359",
			"ghosteryOrganizationName": "Refersion"
		},
		{
			"domains": "dcdcsl55x0411.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d0f467a5fd406da04a06dec58f39f3cd.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "dwgyu36up6iuz.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "dp8hsntg6do36.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "pb-logs.media.net",
			"ghosteryId": "1879",
			"ghosteryOrganizationName": "Media.net"
		},
		{
			"domains": "condenastus-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "a.jsrdn.com",
			"ghosteryId": "4472",
			"ghosteryOrganizationName": "Distroscale"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a125375509.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "cdn.ml314.com",
			"ghosteryId": "933",
			"ghosteryOrganizationName": "Bombora"
		},
		{
			"domains": "cdn.turner.com",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T"
		},
		{
			"domains": "s.cdn.turner.com",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T"
		},
		{
			"domains": "segment-data-us-east.zqtk.net",
			"ghosteryId": "246",
			"ghosteryOrganizationName": "comScore, Inc."
		},
		{
			"domains": "cdn.turner.com",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T"
		},
		{
			"domains": "turnip.cdn.turner.com",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "4b0989bb76269f2986506efd59264f0f.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "a6709203f34992a5095d2bc7ceaf2ec504f651a8.cws.conviva.com",
			"ghosteryId": "819",
			"ghosteryOrganizationName": "Conviva"
		},
		{
			"domains": "medium.ngtv.io",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T"
		},
		{
			"domains": "bitmovin.com",
			"disconnectMeName": "BitMovin",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cnn.bounceexchange.com",
			"ghosteryId": "2468",
			"ghosteryOrganizationName": "Bounce Exchange"
		},
		{
			"domains": "v.fwmrm.net",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast"
		},
		{
			"domains": "bea4.v.fwmrm.net",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast"
		},
		{
			"domains": "atom.warnermedia.com",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T"
		},
		{
			"domains": "adex2.fwmrm.net",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast"
		},
		{
			"domains": "s.adex2.fwmrm.net",
			"ghosteryId": "3014",
			"ghosteryOrganizationName": "Comcast"
		},
		{
			"domains": "dqif5bl25s0bf.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "publishers.tremorhub.com",
			"ghosteryId": "564",
			"ghosteryOrganizationName": "Tremor Video"
		},
		{
			"domains": "eq97f.publishers.tremorhub.com",
			"ghosteryId": "564",
			"ghosteryOrganizationName": "Tremor Video"
		},
		{
			"domains": "dashboard.tinypass.com",
			"ghosteryId": "2935",
			"ghosteryOrganizationName": "Piano"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "2d0ea017ad6a766baba286819827ef48.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-26223.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "8cmfzco0.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10486893.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "112.2o7.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "nbcucnbcglobal.112.2o7.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fast.wistia.net",
			"ghosteryId": "1307",
			"ghosteryOrganizationName": "Wistia",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "mktdplp102cdn.azureedge.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a28007920049.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "oc-cdn-ocprod.azureedge.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "svc.dynamics.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2024-06-21T10:26:14.000Z"
		},
		{
			"domains": "ca264331a46e4359af48029ef070df94.svc.dynamics.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "citi.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "recs-prod.rfihub.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "citicorpcreditservic.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn3vi8kkuds0jjrfc-citifeedback.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "sr.rlcdn.com",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6260004.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cigna.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "11003711.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "thisgreencolumn.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "choice.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "choicehotels.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "thisgreencolumn.com",
			"disconnectMeName": "CHEQ",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "i.ctnsnet.com",
			"ghosteryId": "606",
			"ghosteryOrganizationName": "Crimtan"
		},
		{
			"domains": "e.acuityplatform.com",
			"ghosteryId": "1635",
			"ghosteryOrganizationName": "Acuity Ads"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "14643551.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6247130.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "media-cdn.ipredictive.com",
			"ghosteryId": "3878",
			"ghosteryOrganizationName": "Viant"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "12297711.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13180647.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fs.liveperson.com",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "chpwv.fs.liveperson.com",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "orderweb-prd-centralus-cdne.azureedge.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "web.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "z19.web.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "payeezystrg.z19.web.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "blob.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "chipotlestrgprdcentral.blob.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6527605.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "feedmob-cdn.s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "attribution.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "adresults-49-adswizz.attribution.adswizz.com",
			"ghosteryId": "1842",
			"ghosteryOrganizationName": "AdsWizz"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "14958650.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "13644961.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d2wl1kt18tqdum.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d31iqi82ivd0ac.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d1fd34dzzl09j.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "pvqccnfz.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6396012.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a28554780121.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o90235.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a14932920627.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "log-api.newrelic.com",
			"ghosteryId": "942",
			"ghosteryOrganizationName": "New Relic"
		},
		{
			"domains": "pixel-static.spotify.com",
			"ghosteryId": "1816",
			"ghosteryOrganizationName": "Spotify"
		},
		{
			"domains": "pixel.spotify.com",
			"ghosteryId": "1816",
			"ghosteryOrganizationName": "Spotify"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "5942083.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "204-wfi-586.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "origin.acuityplatform.com",
			"ghosteryId": "1635",
			"ghosteryOrganizationName": "Acuity Ads"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "14394883.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "vo.msecnd.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "az416426.vo.msecnd.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "servicebus.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "launchpad-eventhubs.servicebus.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "cdn.nowinteract.com",
			"ghosteryId": "3623",
			"ghosteryOrganizationName": "Now Interact"
		},
		{
			"domains": "us1.nowinteract.com",
			"ghosteryId": "3623",
			"ghosteryOrganizationName": "Now Interact"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733852959-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "jf7gf3qxfa6dez2yp4pq-p9k89c-7f42c5eb6-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "us-5.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "cengagelearning.us-5.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a8392411042.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10145194.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10154447.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "rum.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "client.rum.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "auth.adobe.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "api.auth.adobe.com",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "js.agkn.com",
			"ghosteryId": "3452",
			"ghosteryOrganizationName": "TransUnion"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn_ed65ynwxvsuk9lf-cbs.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "radar.cedexis.com",
			"ghosteryId": "691",
			"ghosteryOrganizationName": "Cedexis"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a2628570003.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9475917.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "init.cedexis-radar.net",
			"ghosteryId": "691",
			"ghosteryOrganizationName": "Cedexis"
		},
		{
			"domains": "i2-neqscegwhatczskeujlcifqsfsqbnq.init.cedexis-radar.net",
			"ghosteryId": "691",
			"ghosteryOrganizationName": "Cedexis"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6441934.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fc526730df80e63fd3d298540001aaa4.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "darnuid.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "nxkaup07efd96rptf3k6pfwinpff61733862528.darnuid.imrworldwide.com",
			"ghosteryId": "167",
			"ghosteryOrganizationName": "Nielsen"
		},
		{
			"domains": "datacloud-us-east-1.tealiumiq.com",
			"ghosteryId": "662",
			"ghosteryOrganizationName": "Tealium"
		},
		{
			"domains": "init.cedexis-radar.net",
			"ghosteryId": "691",
			"ghosteryOrganizationName": "Cedexis"
		},
		{
			"domains": "i2-nghbapogelitwstykizchljpgeunaq.init.cedexis-radar.net",
			"ghosteryId": "691",
			"ghosteryOrganizationName": "Cedexis"
		},
		{
			"domains": "927-img.c3tag.com",
			"ghosteryId": "754",
			"ghosteryOrganizationName": "C3 Metrics"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "5095325.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "5c9daadd0494fef5d76b5f331a623f54.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zne5szqpbkez95p8v-cars.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "yul1.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8789640.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn824bpwruzg5mxb3-carmax.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o47004.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10743458.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "carfaxcom3281561z.btttag.com",
			"ghosteryId": "3355",
			"ghosteryOrganizationName": "Blue Triangle"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a10683441301.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "mtrcs.samba.tv",
			"ghosteryId": "5388",
			"ghosteryOrganizationName": "Samba TV"
		},
		{
			"domains": "tag.mtrcs.samba.tv",
			"ghosteryId": "5388",
			"ghosteryOrganizationName": "Samba TV"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a21018620252.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "ay.delivery",
			"disconnectMeName": "AssertiveYield",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "68acfe75d760bc62d7ce9eaff72fc3db.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "capitaloneservices.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "capitaloneservices.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "digital-cloud.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2024-05-23T13:41:22.000Z"
		},
		{
			"domains": "capitalone-resources.digital-cloud.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8591251.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "806653.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6361220.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "1330903.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "digital-cloud.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2024-05-23T13:41:22.000Z"
		},
		{
			"domains": "capitalone-analytics.digital-cloud.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "digital-cloud.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia",
			"whenAddedToGhostery": "2024-05-23T13:41:22.000Z"
		},
		{
			"domains": "capitalone-udc.digital-cloud.medallia.com",
			"ghosteryId": "5294",
			"ghosteryOrganizationName": "Medallia"
		},
		{
			"domains": "cdn.betrad.com",
			"ghosteryId": "4957",
			"ghosteryOrganizationName": "Crownpeak"
		},
		{
			"domains": "capitalgroup.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "capitalgroupcompanie.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o13855.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-22324.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "scontent-sea1-1.cdninstagram.com",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta"
		},
		{
			"domains": "s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "caltech-prod.s3.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d26tpo4cm8sb6k.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d1zchjxt6i84hj.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "caesars.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "bf60322zwe.bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-16455.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "2891872.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "am.adlooxtracking.com",
			"ghosteryId": "1455",
			"ghosteryOrganizationName": "Adloox"
		},
		{
			"domains": "data00.adlooxtracking.com",
			"ghosteryId": "1455",
			"ghosteryOrganizationName": "Adloox"
		},
		{
			"domains": "ay.delivery",
			"disconnectMeName": "AssertiveYield",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "a823d19a05f0b1b0119fb0aa1d136a17.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "pd.sharethis.com",
			"ghosteryId": "149",
			"ghosteryOrganizationName": "ShareThis, Inc."
		},
		{
			"domains": "ads.jetpackdigital.com",
			"ghosteryId": "1859",
			"ghosteryOrganizationName": "Jetpack Digital"
		},
		{
			"domains": "tracking.jetpackdigital.com",
			"ghosteryId": "1859",
			"ghosteryOrganizationName": "Jetpack Digital"
		},
		{
			"domains": "business-insider-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "geniuslinkcdn.com",
			"disconnectMeName": "Geniuslink",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "flipp.com",
			"disconnectMeName": "Flipp",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "breitbartproduction.disqus.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "www.instagram.com",
			"ghosteryId": "249",
			"ghosteryOrganizationName": "Meta"
		},
		{
			"domains": "videos-cloudfront.jwpsrv.com",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "48663d87e9e7c0c263e23e488f291206.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "trends.revcontent.com",
			"ghosteryId": "3626",
			"ghosteryOrganizationName": "Revcontent"
		},
		{
			"domains": "img.revcontent.com",
			"ghosteryId": "3626",
			"ghosteryOrganizationName": "Revcontent"
		},
		{
			"domains": "engine.4dsply.com",
			"ghosteryId": "2159",
			"ghosteryOrganizationName": "AdSupply"
		},
		{
			"domains": "cdn.engine.4dsply.com",
			"ghosteryId": "2159",
			"ghosteryOrganizationName": "AdSupply"
		},
		{
			"domains": "images.revcontent.com",
			"ghosteryId": "3626",
			"ghosteryOrganizationName": "Revcontent"
		},
		{
			"domains": "engine.4dsply.com",
			"ghosteryId": "2159",
			"ghosteryOrganizationName": "AdSupply"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10319666.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "responder.wt-safetag.com",
			"ghosteryId": "335",
			"ghosteryOrganizationName": "Webtrekk",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "awswaf.com",
			"disconnectMeName": "Amazon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "awswaf.com",
			"disconnectMeName": "Amazon",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "9c5e584b213fe5f04723c93e2a10c926.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "bleacherreport.net",
			"disconnectMeName": "Warner Bros. Discovery",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "cdn.turner.com",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T"
		},
		{
			"domains": "i.cdn.turner.com",
			"ghosteryId": "4385",
			"ghosteryOrganizationName": "AT&T"
		},
		{
			"domains": "cdn.krxd.net",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ba8a6b83dcdb4fd206acf417d071141c.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d2adqanfijfsj5.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn73axurlao42xuyx-blackrockdigital.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "assets.msn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "c.msn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "data.msn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "events.data.msn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "browser.events.data.msn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "www.msn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "dev.virtualearth.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "ecn.dev.virtualearth.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "6db4d971b75bb835470e49b7f8c5bad8.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "duwriicdzpsrh.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "piwik.pro",
			"disconnectMeName": "CookieInformation",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "piwik.pro",
			"disconnectMeName": "CookieInformation",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "up.pixel.ad",
			"ghosteryId": "714",
			"ghosteryOrganizationName": "Centro"
		},
		{
			"domains": "d3ab3ke2xlfzp0.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "d1zafhmmezns74.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "10201463.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "173bf111.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "d16fk4ms6rqz1v.cloudfront.net",
			"ghosteryId": "1963",
			"ghosteryOrganizationName": "SaleCycle",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "ibarbowq.micpn.com",
			"ghosteryId": "3778",
			"ghosteryOrganizationName": "Movable Ink"
		},
		{
			"domains": "bestwestern.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "d1.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "bestwesterninternational.d1.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "bestwesterninternati.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "s.salecycle.com",
			"ghosteryId": "1963",
			"ghosteryOrganizationName": "SaleCycle"
		},
		{
			"domains": "global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "6046818.global.siteimproveanalytics.io",
			"ghosteryId": "1447",
			"ghosteryOrganizationName": "Siteimprove"
		},
		{
			"domains": "ws.salecycle.com",
			"ghosteryId": "1963",
			"ghosteryOrganizationName": "SaleCycle"
		},
		{
			"domains": "20855206p.rfihub.com",
			"ghosteryId": "426",
			"ghosteryOrganizationName": "Zeta Global"
		},
		{
			"domains": "i.salecycle.com",
			"ghosteryId": "1963",
			"ghosteryOrganizationName": "SaleCycle"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "082af54ab71ac5a9502a84fbb467ac6e.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "bestbuy.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "4448269.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a4621041136.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "98744306f8c8837ca2194d89e65de397.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "barclaybankdelaware.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "barclaycardus.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "lon-col.eum-appdynamics.com",
			"ghosteryId": "2793",
			"ghosteryOrganizationName": "AppDynamics"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "407d0c63dbdd1e3c7463ba94e46602f4.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ox-rtb-us-east1.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "eu-u.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "traffick.jivox.com",
			"ghosteryId": "1872",
			"ghosteryOrganizationName": "Jivox"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "5f6709e9ac32fa209e1fc66ad1f78f41.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "form-renderer.trustarc.com",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc"
		},
		{
			"domains": "consent-reporting.trustarc.com",
			"ghosteryId": "775",
			"ghosteryOrganizationName": "TrustArc"
		},
		{
			"domains": "195-loz-515.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "js.driftt.com",
			"ghosteryId": "4715",
			"ghosteryOrganizationName": "Drift",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "rc-widget-frame.js.driftt.com",
			"ghosteryId": "4715",
			"ghosteryOrganizationName": "Drift"
		},
		{
			"domains": "edge1.certona.net",
			"ghosteryId": "351",
			"ghosteryOrganizationName": "Certona"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "znenhmrspg8idzymd-autozone.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "td.yieldify.com",
			"ghosteryId": "2874",
			"ghosteryOrganizationName": "Yieldify"
		},
		{
			"domains": "custom.yieldify.com",
			"ghosteryId": "2874",
			"ghosteryOrganizationName": "Yieldify"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "11424857.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "56dad55abd4552fa97e8fe4c849d8d07.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "collector-29675.us.tvsquared.com",
			"ghosteryId": "4931",
			"ghosteryOrganizationName": "TV Squared"
		},
		{
			"domains": "att.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "7a32338cf85ffbace5a64b04abffb708.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "brain.foresee.com",
			"ghosteryId": "330",
			"ghosteryOrganizationName": "ForeSee Results"
		},
		{
			"domains": "173bf110.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "att-sync.quantummetric.com",
			"ghosteryId": "4748",
			"ghosteryOrganizationName": "Quantum Metric, Inc."
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "6100125.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "att.inq.com",
			"ghosteryId": "230",
			"ghosteryOrganizationName": "TouchCommerce"
		},
		{
			"domains": "ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "o55978.ingest.sentry.io",
			"ghosteryId": "2820",
			"ghosteryOrganizationName": "Sentry"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "5406241.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "594-atc-127.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "cdn.petametrics.com",
			"ghosteryId": "5356",
			"ghosteryOrganizationName": "LiftIgniter"
		},
		{
			"domains": "query-us-east1.petametrics.com",
			"ghosteryId": "5356",
			"ghosteryOrganizationName": "LiftIgniter"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ba7f7c02bf22456bc401566053284fd9.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "s.innovid.com",
			"ghosteryId": "825",
			"ghosteryOrganizationName": "Innovid"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "e1d72c378a7690f66c90e0df6751d0dc.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "traderbyte.com",
			"disconnectMeName": "Admiral",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "feedback.adrecover.com",
			"ghosteryId": "3507",
			"ghosteryOrganizationName": "AdPushUp, Inc."
		},
		{
			"domains": "la1-c2-ia5.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "c.la1-c2-ia5.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "athenahealth.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "la1-c2-ia5.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "d.la1-c2-ia5.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "us-4.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "athenahealth.us-4.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "la1-c2-ia4.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "d.la1-c2-ia4.salesforceliveagent.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "athenahealth.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "895-cgw-711.mktoresp.com",
			"ghosteryId": "108",
			"ghosteryOrganizationName": "Marketo"
		},
		{
			"domains": "app.hubspot.com",
			"ghosteryId": "86",
			"ghosteryOrganizationName": "HubSpot",
			"whenAddedToGhostery": "2024-03-22T13:47:05.000Z"
		},
		{
			"domains": "ap.blueconic.net",
			"ghosteryId": "3860",
			"ghosteryOrganizationName": "BlueConic"
		},
		{
			"domains": "aps.zqtk.net",
			"ghosteryId": "246",
			"ghosteryOrganizationName": "comScore, Inc."
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d97daf830dac7cd796c3d1dbd8d83fa5.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "beacon-sjc2.rubiconproject.com",
			"ghosteryId": "168",
			"ghosteryOrganizationName": "The Rubicon Project, Limited"
		},
		{
			"domains": "vpb-server.jwplayer.com",
			"ghosteryId": "1112",
			"ghosteryOrganizationName": "JW Player"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a26780310980.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "d21gpk1vhmjuf5.cloudfront.net",
			"ghosteryId": "4437",
			"ghosteryOrganizationName": "UNBXD",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "www.shopperapproved.com",
			"ghosteryId": "3981",
			"ghosteryOrganizationName": "Shopper Approved",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "10948010.collect.igodigital.com",
			"ghosteryId": "143",
			"ghosteryOrganizationName": "Salesforce"
		},
		{
			"domains": "jf7gf3qxfa6dez2yt3ha-p9wf8h-f166ee101-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733861070-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "wellpoint.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "wellpoint.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "jf7gf3qxfa6bgz2ysvcq-pzyxkz-ea5ff442c-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-119_ts-1733858629-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "amtrakdigital.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "amtrak.inq.com",
			"ghosteryId": "230",
			"ghosteryOrganizationName": "TouchCommerce"
		},
		{
			"domains": "amtrakdigital.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "12472045.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "us-7.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "amtrak.us-7.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "cdn-akamai.mookie1.com",
			"ghosteryId": "4758",
			"ghosteryOrganizationName": "Xaxis"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8939204.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "cobrowse-amtrak.inq.com",
			"ghosteryId": "230",
			"ghosteryOrganizationName": "TouchCommerce"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "amtrakdigital.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "aeopprodvip.acxiom.com",
			"ghosteryId": "319",
			"ghosteryOrganizationName": "LiveRamp"
		},
		{
			"domains": "centenecorp.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "centene.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "znekdeodbme4antru-centene.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "ally.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "ally.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "bf07779yqi.bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8877379.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn0jrcasstp2ekclo-allyinsights.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "jf7gf3qxfa6bgz2ypz3a-p7f4tf-bfa074092-clientnsv4-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "73-126-98-238_s-23-36-38-100_ts-1733852790-clienttons-s.akamaihd.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "173bf10a.akstat.io",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "fs.liveperson.com",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "static-assets.fs.liveperson.com",
			"ghosteryId": "100",
			"ghosteryOrganizationName": "LivePerson"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "allstate.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "2be571f8549c80b96da2adbc81b35d33.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ae01.alicdn.com",
			"ghosteryId": "3001",
			"ghosteryOrganizationName": "Alibaba"
		},
		{
			"domains": "ae04.alicdn.com",
			"ghosteryId": "3001",
			"ghosteryOrganizationName": "Alibaba"
		},
		{
			"domains": "assets.alicdn.com",
			"ghosteryId": "3001",
			"ghosteryOrganizationName": "Alibaba"
		},
		{
			"domains": "is.alicdn.com",
			"ghosteryId": "3001",
			"ghosteryOrganizationName": "Alibaba"
		},
		{
			"domains": "aeis.alicdn.com",
			"ghosteryId": "3001",
			"ghosteryOrganizationName": "Alibaba"
		},
		{
			"domains": "g.alicdn.com",
			"ghosteryId": "3001",
			"ghosteryOrganizationName": "Alibaba"
		},
		{
			"domains": "time-ae.akamaized.net",
			"ghosteryId": "11",
			"ghosteryOrganizationName": "Akamai Technologies"
		},
		{
			"domains": "ae.mmstat.com",
			"ghosteryId": "2149",
			"ghosteryOrganizationName": "MarkMonitor"
		},
		{
			"domains": "tdum.alibaba.com",
			"ghosteryId": "3001",
			"ghosteryOrganizationName": "Alibaba"
		},
		{
			"domains": "1xgnk4.tdum.alibaba.com",
			"ghosteryId": "3001",
			"ghosteryOrganizationName": "Alibaba"
		},
		{
			"domains": "aldisued.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "d3.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "aldisued.d3.sc.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "aldisued.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "12523818.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "aldi-privacy.my.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "ads.justpremium.com",
			"ghosteryId": "2882",
			"ghosteryOrganizationName": "GumGum"
		},
		{
			"domains": "pre.ads.justpremium.com",
			"ghosteryId": "2882",
			"ghosteryOrganizationName": "GumGum"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "c66a22ae2d1d8632e8e46d3800034151.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ag.yieldoptimizer.com",
			"ghosteryId": "286",
			"ghosteryOrganizationName": "Adara"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "2e51795706a7e9138b269cc573b17777.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "evt.undertone.com",
			"ghosteryId": "269",
			"ghosteryOrganizationName": "Perion"
		},
		{
			"domains": "ipds.adrta.com",
			"ghosteryId": "4097",
			"ghosteryOrganizationName": "Pixalate, Inc."
		},
		{
			"domains": "pixel.advertising.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "cw.addthis.com",
			"ghosteryId": "1170",
			"ghosteryOrganizationName": "Oracle"
		},
		{
			"domains": "ads.scorecardresearch.com",
			"ghosteryId": "246",
			"ghosteryOrganizationName": "comScore, Inc."
		},
		{
			"domains": "usr.undertone.com",
			"ghosteryId": "269",
			"ghosteryOrganizationName": "Perion"
		},
		{
			"domains": "cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "a10453949094.cdn.optimizely.com",
			"ghosteryId": "881",
			"ghosteryOrganizationName": "Optimizely"
		},
		{
			"domains": "core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "blob.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft",
			"whenAddedToGhostery": "2025-04-03T10:16:22.000Z"
		},
		{
			"domains": "contentcdnprodacct.blob.core.windows.net",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "alaskaairlines.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "5584487.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn3xeyguhe8idwa8d-alaskaair.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "8432219.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9772812.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "privacyportal-ca.onetrust.com",
			"ghosteryId": "4754",
			"ghosteryOrganizationName": "OneTrust"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn5sbiq8onusb0vml-aflac.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "us-4.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "adpinc.us-4.evergage.com",
			"ghosteryId": "2792",
			"ghosteryOrganizationName": "Evergage"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9019107.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "bf11493kpk.bf.dynatrace.com",
			"ghosteryId": "5405",
			"ghosteryOrganizationName": "Thoma Bravo"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "9212252.fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ssp.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "c2shb.ssp.yahoo.com",
			"ghosteryId": "726",
			"ghosteryOrganizationName": "Verizon"
		},
		{
			"domains": "media.licdn.com",
			"ghosteryId": "250",
			"ghosteryOrganizationName": "Microsoft"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d5c0678e18efe3e4311736627edea73f.safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "d2huezsn80zkc1.cloudfront.net",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "accuweather-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "aarp.sv.rkdms.com",
			"ghosteryId": "391",
			"ghosteryOrganizationName": "Dentsu Aegis Network"
		},
		{
			"domains": "aarp.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "execute-api.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "ggfi3szd85.execute-api.us-east-1.amazonaws.com",
			"ghosteryId": "243",
			"ghosteryOrganizationName": "Amazon"
		},
		{
			"domains": "aarp-d.openx.net",
			"ghosteryId": "131",
			"ghosteryOrganizationName": "OpenX Software Ltd."
		},
		{
			"domains": "api.securedvisit.com",
			"ghosteryId": "2234",
			"ghosteryOrganizationName": "SecuredVisit"
		},
		{
			"domains": "content.securedvisit.com",
			"ghosteryId": "2234",
			"ghosteryOrganizationName": "SecuredVisit"
		},
		{
			"domains": "piwik.pro",
			"disconnectMeName": "CookieInformation",
			"whenAddedToDisconnectMe": "2015-10-13T19:06:27.000Z"
		},
		{
			"domains": "analytics.foresee.com",
			"ghosteryId": "330",
			"ghosteryOrganizationName": "ForeSee Results"
		},
		{
			"domains": "mpp.vindicosuite.com",
			"ghosteryId": "739",
			"ghosteryOrganizationName": "Vindico Group",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "events.xg4ken.com",
			"ghosteryId": "1299",
			"ghosteryOrganizationName": "Kenshoo"
		},
		{
			"domains": "statse.webtrendslive.com",
			"ghosteryId": "181",
			"ghosteryOrganizationName": "Webtrends"
		},
		{
			"domains": "ddc.optimahub.com",
			"ghosteryId": "3231",
			"ghosteryOrganizationName": "Datalicious"
		},
		{
			"domains": "americanairlines.demdex.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "americanairlines.tt.omtrdc.net",
			"ghosteryId": "414",
			"ghosteryOrganizationName": "Adobe"
		},
		{
			"domains": "fls.doubleclick.net",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google",
			"whenAddedToGhostery": "2023-02-20T19:33:05.000Z"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "aa-sync.quantummetric.com",
			"ghosteryId": "4748",
			"ghosteryOrganizationName": "Quantum Metric, Inc."
		},
		{
			"domains": "secure.flashtalking.com",
			"ghosteryId": "442",
			"ghosteryOrganizationName": "Flashtalking"
		},
		{
			"domains": "siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "zn4sjgms8pc0ssxdx-cbs.siteintercept.qualtrics.com",
			"ghosteryId": "2572",
			"ghosteryOrganizationName": "Qualtrics"
		},
		{
			"domains": "safeframe.googlesyndication.com",
			"ghosteryId": "82",
			"ghosteryOrganizationName": "Google"
		},
		{
			"domains": "ib.mookie1.com",
			"ghosteryId": "4758",
			"ghosteryOrganizationName": "Xaxis"
		}
	]
};
